/* Dictionnaire i18n en — MyNutriLab V1447. Généré, ne pas éditer à la main.
   3065 clés traduites. Toute clé absente retombe sur le repli français de MNL_T. */
window.__MNL_I18N = {
  "config.cart_uncertain_title": "Check your cart",
  "config.cart_uncertain_body": "The result of the addition is still uncertain. No further addition will be sent until the first one is confirmed.",
  "config.cart_not_sent": "No new addition has been confirmed. Check your connection or reload the page before trying again.",
  "coach.cart_confirmed_display_error": "Your addition is confirmed. Open your cart to see your formula.",
  "coach.cart_check": "Check cart",
  "coach.cart_uncertain": "The result is still uncertain. No further addition will be sent until the first one is confirmed.",
  "coach.community_publication_consent": "I agree to make the title and composition of my formula public in the community.",
  "coach.community_publish": "Publish my formula",
  "cart.js_uncertain": "The update is still uncertain. Check your cart before continuing: no further changes will be sent.",
  "cart.js_verify": "Check cart",
  "cart.js_not_applied": "The displayed quantity will be resynced with your cart.",
  "global.promo_pending_prefix": "Promo code ",
  "global.promo_pending_suffix": " is being sent. The discount will be checked at checkout.",
  "global.promo_request_failed_title": "Code not sent",
  "global.promo_requested_title": "Code sent",
  "global.promo_requested_prefix": "Code ",
  "global.promo_requested_suffix": " sent. Its validity and the discount will be confirmed at checkout.",
  "global.promo_network_failure_prefix": "Unable to send code ",
  "global.promo_network_failure_suffix": ". It has been saved: try again in your cart or enter it at checkout.",
  "global.birthday_pending": "Code BIRTHDAY20 sent. Its validity and the discount will be confirmed at checkout.",
  "global.birthday_request_failed": "Unable to send BIRTHDAY20. Enter it at checkout to check its validity.",
  "global.net_offline_retry": "Connection lost. Try your actions again when you are back online.",
  "config.ing.caffeine.label": "Anhydrous Caffeine",
  "config.ing.theanine.label": "L-Theanine",
  "config.ing.glycerol.label": "Glycerol",
  "config.ing.pinksalt.label": "Himalayan Pink Salt",
  "config.ing.creatine.label": "Creatine Monohydrate",
  "config.ing.piperine.label": "Piperine",
  "config.ing.glycerol.fullname": "Glycerol (GlycoPump® 65 %)",
  "config.obj_custom_label": "Custom",
  "config.obj_custom_aria": "Custom. Moving this slider adjusts the ingredients in this group.",
  "mnl.coach.help_config_back": "Yes. Use “Back” or a completed step at the top of the configurator. Your choices are kept unless you click “Start again”.",
  "mnl.coach.help_formula_name": "For a formula you are currently creating, edit its name at the configurator’s ‘Name’ step. If you have already placed your order, contact us before requesting a change.",
  "mnl.coach.wait_long": "The reply is taking longer than expected.",
  "mnl.coach.question_flavor_short": "Which flavour do you prefer?",
  "mnl.coach.question_format_short": "How many servings would you like? Choose a format below.",
  "account.js_add_failed": "Add failed",
  "account.js_added_to_cart": "Added to cart",
  "account.js_adding": "Adding…",
  "account.js_adjust": "Adjust",
  "account.js_article_plural": "s",
  "account.js_article_word": " item",
  "account.js_carrier_universal": "Universal search",
  "account.js_cart_error": "Cart error",
  "account.js_check_connection": "Check your connection and try again",
  "account.js_check_items": "Check that the items are available",
  "account.js_code_copied": "Code copied",
  "account.js_compo_unavailable": "Composition temporarily unavailable — we cannot read your doses back right now. Reload the page to try again.",
  "account.js_del_cancel": "Keep my account",
  "account.js_del_confirm": "Delete my account",
  "account.js_del_title": "Delete your account permanently?",
  "account.js_export_ready": "Export ready",
  "account.js_export_ready_sub": "CSV downloaded (UTF-8 encoding + Excel BOM)",
  "account.js_guard_text_1": "Your saved doses date from before our latest revisions, and we cannot ",
  "account.js_guard_text_2": "recalculate them right now. Rather than ship you — and bill you for — doses we are ",
  "account.js_guard_text_3": "not sure about, we prefer to put nothing in the cart. Try again in a moment: ",
  "account.js_guard_text_4": "it is almost always temporary.",
  "account.js_guard_title": "We could not read back the doses of this formula",
  "account.js_invoice_action": "Write to us",
  "account.js_invoice_sub": "Available in your confirmation email · otherwise the contact form",
  "account.js_invoice_title": "Invoice for order ",
  "account.js_items_added": "✓ Items added",
  "account.js_items_unavail": "Items unavailable",
  "account.js_items_unavail_sale": "The items are no longer available for sale",
  "account.js_items_unavail_sub": "This order contains items that can no longer be re-added",
  "account.js_no_tracking": "Tracking number not available",
  "account.js_no_tracking_sub": "Go through the contact form",
  "account.js_order_impossible": "Order not possible",
  "account.js_order_this_formula": "Order this formula",
  "account.js_prefs_account": "Linked to your account.",
  "account.js_prefs_device": "On this device.",
  "account.js_prefs_saved": "Preferences saved",
  "account.js_reorder_done": "Order re-added",
  "account.js_reread_failed": "We could not read your doses back. Reload the page and try again.",
  "account.js_retry_moment": "Try again in a moment.",
  "account.js_retry_pdp": "Try again from the product page.",
  "account.js_see_composition": "See the composition",
  "account.js_share_subject": "Discover MyNutriLab with -10%",
  "account.js_sub_confirm": "Subscription to confirm",
  "account.js_sub_confirm_note": "We are adding the tub; our team activates your subscription within 24 h.",
  "account.js_text_copied": "Text copied",
  "account.js_text_copied_sub": "Paste it wherever you want to share it",
  "account.js_timeout": "Timed out (15s)",
  "account.js_track_bad": "Format not recognised — check the number",
  "account.js_track_detected": " detected",
  "account.js_track_detected_open": " detected — opening…",
  "account.js_track_empty": "Enter a tracking number",
  "account.js_unavailable": "Unavailable",
  "account.js_view_cart": "View cart",
  "achievements.js_badges_suffix": " badges",
  "achievements.js_copied": "✓ Copied",
  "achievements.js_copy_prompt": "Copy to share:",
  "achievements.js_copy_title": "Copy the share text",
  "achievements.js_png_aria": "Download this badge as an image",
  "achievements.js_png_cta": "Unlock yours at mynutrilab.com ",
  "achievements.js_png_unlocked": "✓ UNLOCKED",
  "achievements.js_progress_aria_mid": " of ",
  "achievements.js_progress_aria_prefix": "Badge progress: ",
  "achievements.js_share_badge_aria": "Share this badge",
  "achievements.js_share_btn": "Share",
  "achievements.js_share_name_fallback": "MNL Achievement",
  "achievements.js_share_text_a": "I have just unlocked \"",
  "achievements.js_share_text_b": "\" on MyNutriLab!",
  "achievements.js_unlocked": "✓ Unlocked",
  "athletetabs.am_js_copied_html": "✓ Copied!",
  "athletetabs.am_js_question_prefix_html": "Question ",
  "athletetabs.am_js_question_sep_html": " / ",
  "athletetabs.am_js_share_prefix_html": "My MyNutriLab athletic twin: ",
  "athletetabs.am_js_share_restore_html": "Share my result",
  "athletetabs.am_js_share_suffix_html": ". And you? ",
  "athletetabs.am_js_share_title_html": "MyNutriLab — Athlete Match",
  "athletetabs.am_js_step_done_html": "✓ Your match is ready!",
  "athletetabs.am_js_step_intro_html": "Find your athlete",
  "athletetabs.am_profile_collectif_bio_html": "Team sport profile: 90 min with no drop in pace, repeated sprints + constant alertness.",
  "athletetabs.am_profile_collectif_name_html": "Repeated sprint 90 min",
  "athletetabs.am_profile_collectif_sport_html": "Team sport · football / rugby",
  "athletetabs.am_profile_combat_rage_bio_html": "Pro fighting profile: max alertness, power and clear thinking through to the final round.",
  "athletetabs.am_profile_combat_rage_name_html": "Pro fighting",
  "athletetabs.am_profile_combat_rage_sport_html": "MMA / Pro boxing · 5 rounds",
  "athletetabs.am_profile_combat_zen_bio_html": "Technical fighting profile: laser focus + reading the fight, with no stimulant overload.",
  "athletetabs.am_profile_combat_zen_name_html": "Technical focus",
  "athletetabs.am_profile_combat_zen_sport_html": "Technical boxing · reading the fight",
  "athletetabs.am_profile_crossfit_rage_bio_html": "Demanding profile, no compromise on performance. This formula maximises caffeine/citrulline/beta-alanine for repeated power in competition WODs.",
  "athletetabs.am_profile_crossfit_rage_name_html": "Pure strength",
  "athletetabs.am_profile_crossfit_rage_sport_html": "CrossFit · Competition",
  "athletetabs.am_profile_crossfit_zen_bio_html": "Calm and precise profile. Favours lactic endurance and concentration for long WODs.",
  "athletetabs.am_profile_crossfit_zen_name_html": "Lactic endurance",
  "athletetabs.am_profile_crossfit_zen_sport_html": "CrossFit · technical zen",
  "athletetabs.am_profile_endurance_rage_bio_html": "Marathon profile: optimised effort perception + lactate threshold over 42 km.",
  "athletetabs.am_profile_endurance_rage_name_html": "Marathon threshold",
  "athletetabs.am_profile_endurance_rage_sport_html": "Marathon · lactate threshold",
  "athletetabs.am_profile_endurance_zen_bio_html": "Calm, enduring trail profile: beta-alanine + electrolytes balance for efforts of 2h and beyond.",
  "athletetabs.am_profile_endurance_zen_name_html": "Long trail",
  "athletetabs.am_profile_endurance_zen_sport_html": "Trail / Ultra · long efforts",
  "athletetabs.am_profile_forme_bio_html": "Multi-sport profile: booster and longevity in balance, no excess, an all-round formula.",
  "athletetabs.am_profile_forme_name_html": "Hybrid fitness",
  "athletetabs.am_profile_forme_sport_html": "Fitness · multi-sport",
  "athletetabs.am_profile_muscu_force_bio_html": "Powerlifting profile: triple max effort, intercellular recovery between heavy sets.",
  "athletetabs.am_profile_muscu_force_name_html": "Max strength 1RM",
  "athletetabs.am_profile_muscu_force_sport_html": "Powerlifting · pure power",
  "athletetabs.am_profile_muscu_volume_bio_html": "Bodybuilding profile: max pump + mind-muscle connection for volume sessions.",
  "athletetabs.am_profile_muscu_volume_name_html": "Pump + volume",
  "athletetabs.am_profile_muscu_volume_sport_html": "Bodybuilding · hypertrophy",
  "buy.atc_loading": "Adding…",
  "buy.per_dose": " / serving",
  "buy.perf_attr_fallback": "Attribute",
  "buy.perf_level_suffix": " — level in %",
  "calc.bf.btn_copy": "Copy",
  "calc.bf.js_cat_athlete": "Athlete",
  "calc.bf.js_cat_average": "Average",
  "calc.bf.js_cat_essential": "Essential",
  "calc.bf.js_cat_fitness": "Fitness",
  "calc.bf.js_cat_over": "Overweight",
  "calc.bf.js_copied_bang": "✓ Copied!",
  "calc.bf.js_copy_title": "Copy the body fat measurement",
  "calc.bf.js_female": "Female",
  "calc.bf.js_incoherent": "Inconsistent measurements",
  "calc.bf.js_male": "Male",
  "calc.bf.js_need_all": "Complete your measurements",
  "calc.bf.js_need_hips": "Enter your hip measurement",
  "calc.bf.js_prompt_copy": "Copy this result:",
  "calc.bf.js_sum_bf": "Body Fat: ",
  "calc.bf.js_sum_cat": "% — Category: ",
  "calc.bf.js_sum_height": " | Height: ",
  "calc.bf.js_sum_hips": " | Hips: ",
  "calc.bf.js_sum_neck": "Neck: ",
  "calc.bf.js_sum_sex": "Sex: ",
  "calc.bf.js_sum_title": "Body Fat % MyNutriLab — ",
  "calc.bf.js_sum_waist": "cm | Waist: ",
  "calc.bf.js_sum_weight": "cm | Weight: ",
  "calc.bf.js_toast_err": "Save failed",
  "calc.bf.js_toast_err_sub": "Browser storage full?",
  "calc.bf.js_toast_saved": "Saved",
  "calc.bf.js_toast_saved2": "Measurement saved",
  "calc.bf.js_toast_saved_sub": "Progress tracking: 30 measurements max",
  "calc.bf.js_warn_coherence": "Consistency: the neck measurement must be SMALLER than the waist measurement for this formula (US Navy).",
  "calc.bm.js_csv_err": "Export failed",
  "calc.bm.js_csv_err_sub": "Try again or go through the contact form (/pages/contact)",
  "calc.bm.js_csv_nodata": "No data",
  "calc.bm.js_csv_nodata_sub_html": "Save some measurements first",
  "calc.bm.js_csv_ok": "CSV exported",
  "calc.bm.js_csv_ok_sub": " measurements",
  "calc.bm.js_lbl_arm": "Arm",
  "calc.bm.js_lbl_calf": "Calf",
  "calc.bm.js_lbl_chest": "Chest",
  "calc.bm.js_lbl_hips": "Hips",
  "calc.bm.js_lbl_neck": "Neck",
  "calc.bm.js_lbl_thigh": "Thigh",
  "calc.bm.js_lbl_waist": "Waist",
  "calc.bm.js_lbl_weight": "Weight",
  "calc.bm.js_spark_from_html": " measurements · from <strong>",
  "calc.bm.js_spark_to_html": " kg</strong> to <strong>",
  "calc.bm.js_toast_bounds": "Values out of range",
  "calc.bm.js_toast_bounds_a": "Check: ",
  "calc.bm.js_toast_bounds_b": " (physiologically impossible value)",
  "calc.bm.js_toast_min": "Enter at least 1 measurement",
  "calc.bm.js_toast_points": "+10 loyalty pts",
  "calc.bm.js_toast_saved": "Measurements saved",
  "calc.macro.bmi_normal": "Normal",
  "calc.macro.bmi_obese": "Obese",
  "calc.macro.bmi_over": "Overweight",
  "calc.macro.bmi_thin": "Underweight",
  "calc.macro.btn_copy": "Copy",
  "calc.macro.js_copied": "✓ Copied",
  "calc.macro.js_copied_bang": "✓ Copied!",
  "calc.macro.js_copy_title": "Copy the macros",
  "calc.macro.js_female": "Female",
  "calc.macro.js_male": "Male",
  "calc.macro.js_pdf_soon": "PDF (soon)",
  "calc.macro.js_pdf_title": "PDF coming — use Save / Print",
  "calc.macro.js_prompt_copy": "Copy this result:",
  "calc.macro.js_share_a": "My macros worked out on MyNutriLab: ",
  "calc.macro.js_share_b": "g of protein. Work yours out ",
  "calc.macro.js_sum_act": " | Activity: ×",
  "calc.macro.js_sum_age": "Age: ",
  "calc.macro.js_sum_bmi": "BMI: ",
  "calc.macro.js_sum_cal": "Calories: ",
  "calc.macro.js_sum_carb": "Carbs: ",
  "calc.macro.js_sum_fat": "Fat: ",
  "calc.macro.js_sum_goal": "Goal: ",
  "calc.macro.js_sum_height": " | Height: ",
  "calc.macro.js_sum_prot": "Protein: ",
  "calc.macro.js_sum_sex": "Sex: ",
  "calc.macro.js_sum_title": "Macros MyNutriLab — ",
  "calc.macro.js_sum_weight": "cm | Weight: ",
  "calc.macro.js_toast_err": "Save failed",
  "calc.macro.js_toast_err_sub": "Browser storage full?",
  "calc.macro.js_toast_saved": "Saved",
  "calc.macro.js_toast_saved2": "Macros saved",
  "calc.macro.js_toast_saved_sub": "Macro tracking: 30 entries max",
  "calc.rm.btn_copy": "Copy",
  "calc.rm.js_copied_bang": "✓ Copied!",
  "calc.rm.js_copy_title": "Copy the 1RM result",
  "calc.rm.js_enter_bw": "Enter your body weight",
  "calc.rm.js_enter_values": "Enter your values",
  "calc.rm.js_need_bw": "The ratio needs your body weight.",
  "calc.rm.js_need_values": "Load and reps are required to estimate your 1RM.",
  "calc.rm.js_prompt_copy": "Copy this result:",
  "calc.rm.js_std_adv": "Advanced level. You could aim for a local or regional competition.",
  "calc.rm.js_std_beg": "You are just starting out! Keep going, the progress comes fast in the first months.",
  "calc.rm.js_std_elite": "Elite level! You are in the top 5% of lifters.",
  "calc.rm.js_std_int_html": "You are at the level of an athlete who has been training seriously for 2-3 years.",
  "calc.rm.js_std_nov": "You have solid foundations. Focus on technique above all.",
  "calc.rm.js_sum_bw": " | Body weight: ",
  "calc.rm.js_sum_est": "1RM estimate: ",
  "calc.rm.js_sum_load": "Load: ",
  "calc.rm.js_sum_sex": "Sex: ",
  "calc.rm.js_sum_title": "1RM MyNutriLab — ",
  "calc.rm.js_toast_err": "Save failed",
  "calc.rm.js_toast_err_sub": "Browser storage full?",
  "calc.rm.js_toast_saved": "Saved",
  "calc.rm.js_toast_saved_sub": "1RM history updated (30 max)",
  "calc.rm.std_adv": "Advanced",
  "calc.rm.std_beg": "Beginner",
  "calc.rm.std_elite": "Elite",
  "calc.rm.std_int": "Intermediate",
  "calc.rm.std_nov": "Novice",
  "calc.wp.day_fri": "Fri",
  "calc.wp.day_mon": "Mon",
  "calc.wp.day_sat": "Sat",
  "calc.wp.day_sun": "Sun",
  "calc.wp.day_thu": "Thu",
  "calc.wp.day_tue": "Tue",
  "calc.wp.day_wed": "Wed",
  "calc.wp.dayfull_fri": "Friday",
  "calc.wp.dayfull_mon": "Monday",
  "calc.wp.dayfull_sat": "Saturday",
  "calc.wp.dayfull_sun": "Sunday",
  "calc.wp.dayfull_thu": "Thursday",
  "calc.wp.dayfull_tue": "Tuesday",
  "calc.wp.dayfull_wed": "Wednesday",
  "calc.wp.js_already_done_html": "✓ Already logged today",
  "calc.wp.js_already_sub": "Come back tomorrow for the next session",
  "calc.wp.js_already_title_html": "Already logged today",
  "calc.wp.js_f_dur_hint": "E.g.: 1h00 or 45min. Used to work out your weekly total.",
  "calc.wp.js_f_dur_label": "Duration",
  "calc.wp.js_f_time_hint_html": "E.g.: 18:30. Leave it blank if the time is not fixed yet.",
  "calc.wp.js_f_time_label": "Time",
  "calc.wp.js_f_title_hint": "E.g.: Upper body weights, Bike ride, Core work.",
  "calc.wp.js_f_title_label": "Session name",
  "calc.wp.js_f_title_ph": "Upper body weights",
  "calc.wp.js_f_title_req": "Give the session a name so you can find it in your planner.",
  "calc.wp.js_prompt_cancel": "Cancel",
  "calc.wp.js_prompt_dur": "Duration (e.g.: 1h00) — optional",
  "calc.wp.js_prompt_msg_html": "It will be added to today.",
  "calc.wp.js_prompt_name": "Session name (e.g.: Upper body weights)",
  "calc.wp.js_prompt_ok": "Add the session",
  "calc.wp.js_prompt_time": "Time (e.g.: 18:30) — optional",
  "calc.wp.js_prompt_title": "Add a session",
  "calc.wp.js_session_default": "Session",
  "calc.wp.js_toast_added": "Session added",
  "calc.wp.js_toast_added_sub": "Planner updated",
  "calc.wp.js_toast_points": "+25 loyalty pts",
  "calc.wp.js_toast_removed": "Session removed",
  "calc.wp.js_toast_validated": "Session logged!",
  "calc.wp.js_today_html": "Today · ",
  "calc.wp.js_validated": "✓ Logged",
  "calc.wp.js_week_of": "Week of ",
  "calc.wp.js_week_to": " to ",
  "calc.wp.month_01": "January",
  "calc.wp.month_02": "February",
  "calc.wp.month_03": "March",
  "calc.wp.month_04": "April",
  "calc.wp.month_05": "May",
  "calc.wp.month_06": "June",
  "calc.wp.month_07": "July",
  "calc.wp.month_08": "August",
  "calc.wp.month_09": "September",
  "calc.wp.month_10": "October",
  "calc.wp.month_11": "November",
  "calc.wp.month_12": "December",
  "calc.wp.plan_fri": "Pull",
  "calc.wp.plan_mon": "Push",
  "calc.wp.plan_sat": "CrossFit",
  "calc.wp.plan_sun": "Bike ride",
  "calc.wp.plan_thu": "Rest",
  "calc.wp.plan_tue": "Cardio",
  "calc.wp.plan_wed": "Legs",
  "cart.js_check_connection": "Check your connection and try again",
  "cart.js_code_applied": "Code applied",
  "cart.js_code_refused": "Code refused",
  "cart.js_code_refused_sub": "Check the expiry date, the minimum spend or the conditions of the code.",
  "cart.js_code_removed": "Code removed",
  "cart.js_error": "Error",
  "cart.js_first_delivery_only": "1st delivery only",
  "cart.js_first_order": "1st order",
  "cart.js_invalid_format": "Invalid format",
  "cart.js_letters_digits_only": "Letters and digits only",
  "cart.js_mnl10_min": "MNL10: on orders from 39 €",
  "cart.js_next_deliveries": " The following deliveries keep the −10% subscription discount.",
  "cart.js_product_fallback": "Product",
  "cart.js_remove_code_failed": "Could not remove the code, try again",
  "cart.js_retry_soon": "Try again in a moment.",
  "cart.js_saving_counted": " — saving counted",
  "cart.js_timeout_title": "Timed out (15s)",
  "cart.js_update_failed": "Update failed",
  "coach.ach_beginner_desc": "You are starting gently, smart move",
  "coach.ach_beginner_name": "Beginner profile",
  "coach.ach_first_quiz_desc": "You launched your 1st coach quiz",
  "coach.ach_first_quiz_name": "First quiz",
  "coach.ach_hardcore_desc": "You push to the max — elite dosing",
  "coach.ach_hardcore_name": "Hardcore profile",
  "coach.ach_locked": "Not unlocked yet",
  "coach.ach_rare_sport_name": "Rare sport",
  "coach.ach_voice_desc": "You use voice mode",
  "coach.achievements_title_html": "<h3>Your achievements</h3>",
  "coach.action_adjust_doses": "Adjust the doses (expert)",
  "coach.action_other_goal": "Redo it for another goal",
  "coach.action_other_intensity": "Try another intensity",
  "coach.action_why_formula": "Why this formula?",
  "coach.answer_before_html": "<span class=\"mnl-ai-closer__big-btn-text\">Answer the question first</span>",
  "coach.answer_below": "Answer the question below",
  "coach.apply": "Apply",
  "coach.aria_add_tag": "Add a tag to the note",
  "coach.aria_formula_actions": "Actions for your formula",
  "coach.aria_notes_panel": "My AI Coach notes",
  "coach.aria_perf_prefix": "Answer generated in ",
  "coach.aria_perf_seconds": " seconds, ",
  "coach.aria_perf_words": " words, ",
  "coach.aria_perf_wps": " words per second",
  "coach.aria_recap_panel": "Recap of your last conversation",
  "coach.aria_restore_bubble": "Restore the AI Coach — drag to reposition",
  "coach.aria_send_message": "Send the message",
  "coach.aria_stop_generation": "Stop generating",
  "coach.aria_stop_generation_esc": "Stop generating (Escape)",
  "coach.aria_stop_listening": "Stop listening",
  "coach.aria_typing": "The coach is preparing an answer",
  "coach.atc": "Add to cart",
  "coach.atc_adding": "Adding...",
  "coach.atc_admin_setup_required": "⚠Admin setup required",
  "coach.atc_prefix": "Add to cart · ",
  "coach.autosave_html": "<span aria-hidden=\"true\">✓</span> Saved",
  "coach.badge_best_value": "Best value",
  "coach.badge_recommended": "Recommended",
  "coach.badge_test_size": "Trial size",
  "coach.benefit_endurance": "Endurance",
  "coach.benefit_energy": "Energy",
  "coach.benefit_focus": "Focus",
  "coach.benefit_force": "Strength",
  "coach.benefit_pump": "Pump",
  "coach.bm_empty_sub_html": "<p style=\"font-size:12px;color:rgba(255,255,255,.6);margin:0;line-height:1.5;\">Click next to a Coach reply to save it here.</p>",
  "coach.bm_empty_title_html": "<p style=\"font-size:14px;font-weight:700;margin:0 0 6px;color:#fff;\">No notes</p>",
  "coach.bm_footer_html": "<footer style=\"padding:12px 16px;border-top:1px solid rgba(255,255,255,.08);text-align:center;flex-shrink:0;font-size:11px;color:rgba(255,255,255,.5);\">Saved locally · Available offline</footer>",
  "coach.bm_no_note_prefix_html": "<p style=\"text-align:center;color:rgba(255,255,255,.5);font-size:12px;padding:20px;\">No notes ",
  "coach.bm_title_html": "<h3 style=\"margin:0;font-size:15px;font-weight:900;letter-spacing:-.01em;color:#fff;\">My notes</h3>",
  "coach.bm_with_tag_prefix": "with the tag #",
  "coach.buy_once": "One-time purchase",
  "coach.buy_subscription": "Subscription −10%",
  "coach.cancel": "Cancel",
  "coach.chip_caf_none": "No caff",
  "coach.chip_caf_sensitive": "Caff sensitive",
  "coach.chip_caf_used": "Caff regular",
  "coach.chip_level_beginner": "Beginner",
  "coach.chip_level_expert": "Expert",
  "coach.chip_level_regular": "Regular",
  "coach.chip_time_afternoon": "Afternoon",
  "coach.chip_time_evening": "Evening",
  "coach.chip_time_morning": "Morning",
  "coach.chip_time_noon": "Midday",
  "coach.clear": "Clear",
  "coach.closer_default_tip_html": "<strong>Pro tip:</strong> take it 20 to 25 min before your session, mixed into ~300 ml of water. Stir well until it is fully dissolved, and pick the flavor that fires you up.",
  "coach.cmd_backup": "Download a full backup (conv + formulas + memory)",
  "coach.cmd_clear": "Clear the display history",
  "coach.cmd_copy": "Copy the conversation to the clipboard",
  "coach.cmd_dark": "Switch on the dark theme",
  "coach.cmd_export": "Download the conversation as Markdown",
  "coach.cmd_help": "List of available commands",
  "coach.cmd_light": "Switch on the light theme",
  "coach.cmd_notes": "See your saved notes (bookmarks)",
  "coach.cmd_reset": "Start the quiz over from scratch",
  "coach.cmd_restore": "Restore a JSON backup from a file",
  "coach.cmd_save": "Save the current formula",
  "coach.cmd_share": "Generate a shareable link (anonymous, client-only)",
  "coach.cmd_speed_fast": "Fast voice playback (1.4×)",
  "coach.cmd_speed_normal": "Normal voice playback (1.05×)",
  "coach.cmd_speed_slow": "Slow voice playback (0.7×)",
  "coach.cmd_tag": "List your tags OR tag the last note (e.g. /tag caffeine)",
  "coach.cmd_tone_direct": "Short, no-nonsense tone",
  "coach.cmd_tone_friendly": "Warm tone, the default",
  "coach.cmd_tone_pro": "Clinical, professional tone",
  "coach.cmd_voice": "Switch on the mic",
  "coach.cmd_wishlist": "See your multi-list wishlists",
  "coach.compare_added_html": "<strong style=\"color:#22c55e;\">new</strong> → ",
  "coach.compare_current_html": "<div style=\"background:#FDEDE6;padding:12px;border-radius:12px;\"><strong style=\"font-size:12px;color:#C2410C;\">CURRENT</strong><br><strong style=\"font-size:14px;\">",
  "coach.compare_diff_html": "<div style=\"margin-top:14px;\"><strong style=\"font-size:12px;color:#f5f5f5;\">Active differences:</strong>",
  "coach.compare_hint": "✓ Tick 2-4 formulas · Click to compare",
  "coach.compare_intro_html": "<p style=\"font-size:13px;color:#475569;\">Here are the differences vs your last formula:</p>",
  "coach.compare_no_diff_html": "<tr><td colspan=\"2\" style=\"padding:14px 0;color:#94a3b8;text-align:center;font-style:italic;\">No differences — the 2 formulas are identical</td></tr>",
  "coach.compare_previous_html": "<div style=\"background:rgba(15,23,42,.04);padding:12px;border-radius:12px;\"><strong style=\"font-size:12px;color:#64748b;\">PREVIOUS</strong><br><strong style=\"font-size:14px;\">",
  "coach.compare_removed_html": " → <strong style=\"color:#ef4444;\">removed</strong> <span style=\"color:#ef4444;font-weight:900;\">✗</span>",
  "coach.compare_title_html": "<h3>Compare your formula</h3>",
  "coach.confirm_clear_memory_msg": "Sport, level, sensitivity, goals… everything will be forgotten. The coach will start again from scratch.",
  "coach.confirm_clear_memory_title": "Clear the coach memory?",
  "coach.confirm_delete_formula_msg": "It will be removed from your history. This cannot be undone.",
  "coach.confirm_delete_formula_title": "Delete this formula?",
  "coach.confirm_restart_msg": "Your current conversation will be erased.",
  "coach.confirm_restart_title": "Start the quiz over?",
  "coach.confirm_restore_title": "Restore this backup?",
  "coach.copied_check": "✓ Copied!",
  "coach.copy": "Copy",
  "coach.copy_link": "Copy the link",
  "coach.copy_text_title": "Copy the text",
  "coach.copy_the_link": "Copy the link:",
  "coach.copy_this_link": "Copy this link:",
  "coach.copy_this_text": "Copy this text (Ctrl/Cmd + C):",
  "coach.default_formula_name": "My formula",
  "coach.delete": "Delete",
  "coach.dna_row_endurance_html": "<div class=\"mnl-ai-dna__row\"><span class=\"mnl-ai-dna__lbl\">Endurance</span><div class=\"mnl-ai-dna__bar\"><span class=\"mnl-ai-dna__fill mnl-ai-dna__fill--en\" style=\"width:",
  "coach.dna_row_energy_html": "<div class=\"mnl-ai-dna__row\"><span class=\"mnl-ai-dna__lbl\">Energy</span><div class=\"mnl-ai-dna__bar\"><span class=\"mnl-ai-dna__fill mnl-ai-dna__fill--e\" style=\"width:",
  "coach.dna_row_force_html": "<div class=\"mnl-ai-dna__row\"><span class=\"mnl-ai-dna__lbl\">Strength</span><div class=\"mnl-ai-dna__bar\"><span class=\"mnl-ai-dna__fill mnl-ai-dna__fill--f\" style=\"width:",
  "coach.dna_row_pump_html": "<div class=\"mnl-ai-dna__row\"><span class=\"mnl-ai-dna__lbl\">Pump</span><div class=\"mnl-ai-dna__bar\"><span class=\"mnl-ai-dna__fill mnl-ai-dna__fill--p\" style=\"width:",
  "coach.dna_title_html": "<div class=\"mnl-ai-dna\"><span class=\"mnl-ai-dna__title\">Your formula profile</span>",
  "coach.doses_aria_suffix": " servings",
  "coach.doses_clinical": "clinical",
  "coach.doses_go_html": "<button type=\"button\" class=\"mnl-ai-doses__go\">Confirm this size</button>",
  "coach.doses_head_html": "<div class=\"mnl-ai-doses__head\"><span class=\"mnl-ai-doses__lbl\">Choose your number of servings</span>",
  "coach.doses_max": "at max",
  "coach.doses_soft": "gentle",
  "coach.doses_val_html": "<span class=\"mnl-ai-doses__val\"><strong data-doses-n>30</strong> servings</span></div>",
  "coach.doses_weeks_suffix": " weeks at 4 sessions",
  "coach.email_intro_code_html": "By confirming, you sign up to the newsletter and you get the code <strong>MNL10</strong> (−10 € from 39 €) by email. 2-3 emails a month, unsubscribe in 1 click.",
  "coach.email_intro_formula": "By confirming, you get your formula by email — nothing else.",
  "coach.email_invalid": "Invalid email — check the format.",
  "coach.email_sent_code": "✅ Code request accepted. This does not yet confirm email delivery.",
  "coach.email_sent_code_suffix": " Your newsletter subscription was also accepted.",
  "coach.email_sent_formula": "✅ Formula request accepted. This does not yet confirm email delivery.",
  "coach.email_partial": "One request was accepted, but the other could not be confirmed. Try again: the accepted request will not be sent again.",
  "coach.empty_value": "(empty)",
  "coach.error_atc_module": "Add-to-cart module unavailable — reload the page",
  "coach.error_cannot_copy": "Could not copy",
  "coach.error_local_storage_full": "Local storage full?",
  "coach.error_title": "Error",
  "coach.exit_sub_formula": "Your formula will be saved — you can find it again under My formulas.",
  "coach.exit_sub_progress": "Your progress will be saved. Come back whenever you like to finish.",
  "coach.exit_title_formula": "Sure you want to leave?",
  "coach.exit_title_progress": "Leaving already?",
  "coach.export_actives_label": "Actives (per serving):",
  "coach.export_brand_line": "French brand — ISO 22000 certified laboratory",
  "coach.export_calibrated_line": "Calibrated by the MyNutriLab AI.",
  "coach.export_flavor_label": "Flavor: ",
  "coach.export_format_label": "Size: ",
  "coach.export_format_label_plain": "Size: ",
  "coach.export_head": "My MyNutriLab pre-workout formula",
  "coach.export_intensity_label": "Intensity: ",
  "coach.export_name_label": "Name: ",
  "coach.export_per_dose_suffix": "€/serving)",
  "coach.export_price_label": "Price: ",
  "coach.fallback_banner_html": "<span style=\"flex:1;min-width:140px;\">The AI Coach is temporarily overloaded. No panic: I am carrying on with a simplified calibration — you can also switch to the manual builder.</span>",
  "coach.fallback_config_link_html": "\" style=\"color:#78350f;font-weight:800;text-decoration:underline;white-space:nowrap;font-size:12px;\">Builder →</a>",
  "coach.fallback_contact_html": "<a href=\"/pages/contact\" style=\"color:#78350f;font-weight:700;text-decoration:underline;white-space:nowrap;font-size:11.5px;opacity:.85;\" title=\"If nothing works, write to us directly\">✉ Contact form</a>",
  "coach.fallback_retry_html": "<button type=\"button\" data-mnl-ai-retry style=\"background:#fbbf24;color:#78350f;border:0;padding:6px 14px;border-radius:100px;font-size:12px;font-weight:800;cursor:pointer;font-family:inherit;white-space:nowrap;\">↻ Try again</button>",
  "coach.faq1.a": "Preparation within 4 working days once payment is confirmed, plus carrier transit time. The carrier, delivery price and transit estimate are shown at checkout. Pickup point free from 49 €, home delivery free from 110 €. Delivery in mainland France and Corsica. You get the tracking by email as soon as it ships.",
  "coach.faq1.q": "Delivery time?",
  "coach.faq2.a": "Give yourself 7-10 sessions to judge it properly. Beta-alanine saturates muscle carnosine gradually over 4-6 weeks (Saunders 2017). If after 2 weeks your formula does not suit you, write to us through the contact form (/pages/contact) — we adapt your formula (higher intensity, a different angle of attack) with the AI Coach.",
  "coach.faq2.q": "What if I do not feel the difference?",
  "coach.faq3.a": "The precautions for use are given on the product page and in our terms and conditions. Here, I only help you configure your formula according to your sport, your goal, your training time, your caffeine tolerance, your flavor and your size.",
  "coach.faq3.q": "Contraindications?",
  "coach.faq4.a": "25-30 min before your session, in 300ml of cold water. On an empty stomach it works very well. Training in the evening? Lower the caffeine — half-life 5-6 h. You set it to the mg, right down to zero.",
  "coach.faq4.q": "When should I take my serving?",
  "coach.faq5.a": "Our actives are not on the WADA prohibited list to our knowledge. In competition, always check with your federation. Produced in a laboratory that meets HACCP hygiene standards.",
  "coach.faq5.q": "Competition / WADA compatible?",
  "coach.faq6.a": "Whenever you like. Retake the quiz, or adjust it by hand in the builder. Every order can have a different formula — handy if you change sport or goal.",
  "coach.faq6.q": "Can I change formula?",
  "coach.faq7.a": "Every active is dosed according to published clinical studies (PubMed). No proprietary blend, everything is shown to the mg on the label. Caffeine is capped at 200mg max (vs 400mg+ in some US pre-workouts, far above the thresholds recommended by ANSES).",
  "coach.faq7.q": "How are the doses calculated?",
  "coach.faq8.a": "Because an effective pre-workout has to cover 4 pillars: Mental Drive (caffeine, theanine, tyrosine), Muscle Pump (citrulline, glycerol, pink salt), Power & Stamina (beta-alanine, creatine, taurine), Optimization (electrolyte mix, piperine). With 4 actives, you get 1 pillar at best.",
  "coach.faq8.q": "Why 11 actives and not 4 like the others?",
  "coach.faq_intro_html": "<p class=\"mnl-ai-faq-intro\">Everything you need to know before your first tub.</p>",
  "coach.faq_title_html": "<h3>Frequently asked questions</h3>",
  "coach.favorite": "☆ Favourite",
  "coach.formula_name_prefix": "Formula ",
  "coach.history_empty_html": "<h3>Your formulas</h3><p style=\"color:#64748b;\">You do not have a saved formula yet. Generate your first formula and it will show up here automatically!</p>",
  "coach.history_favorites_html": "<p class=\"mnl-ai-history-section\" data-section=\"fav\">Favourites</p>",
  "coach.history_recent_html": "<p class=\"mnl-ai-history-section\" data-section=\"hist\">Recent history</p>",
  "coach.history_share_note_html": "<p style=\"margin:0;font-size:11px;color:#94a3b8;text-align:center;\">To share with your coach / doctor / nutritionist</p>",
  "coach.history_title_html": "<h3>Your formulas</h3>",
  "coach.ics_actives_label": "Main actives:\\\\n",
  "coach.ics_advice1": "Take it 30 min before exercise with 400 ml of water\\\\n",
  "coach.ics_advice2": "Stay well hydrated during the session\\\\n",
  "coach.ics_advice3": "⚠ Caffeine half-life: 5-6 h — for a late session, go for a low dose or a zero caffeine version\\\\n\\\\n",
  "coach.ics_alarm_desc": "DESCRIPTION:Take your MyNutriLab formula in 30 min",
  "coach.ics_default_name": "MyNutriLab formula",
  "coach.ics_desc_head": "Your MyNutriLab pre-workout formula\\\\n\\\\n",
  "coach.ics_product_link_label": "Product link: ",
  "coach.ics_summary_prefix": "Pre-workout session — ",
  "coach.idle_prompt": "Still there? Here are a few popular questions to get you going:",
  "coach.image_check": "✓ Image",
  "coach.img_actives_title": "Actives per serving",
  "coach.img_cta": "Calibrate yours at mynutrilab.com",
  "coach.img_per_dose_prefix": "that is ",
  "coach.img_per_dose_suffix": "€ / serving",
  "coach.img_price_title": "Price",
  "coach.img_tagline": "Made-to-measure pre-workout · French brand ",
  "coach.ing.betaalanine.benefit1": "Precursor of carnosine (pH buffer)",
  "coach.ing.betaalanine.benefit2": "Hobson 2012 meta-analysis: effect observed on 1-4 min efforts",
  "coach.ing.betaalanine.benefit3": "Saturation in 4-6 weeks of regular use",
  "coach.ing.betaalanine.benefit4": "Full 4 g dose, shown to the mg",
  "coach.ing.betaalanine.cat": "Muscular endurance",
  "coach.ing.betaalanine.study": "Hobson (2012):+2.85% performance on 1-4min efforts",
  "coach.ing.betaalanine.what": "Precursor of carnosine, the pH buffer of the muscle (Hobson 2012). Mild tingling is normal — harmless and short-lived.",
  "coach.ing.caffeine.benefit1": "The most documented stimulant in the world",
  "coach.ing.caffeine.benefit2": "Adenosine antagonist",
  "coach.ing.caffeine.benefit3": "Half-life ~5-6 h",
  "coach.ing.caffeine.benefit4": "To be dosed according to tolerance (ANSES cap 200 mg per intake)",
  "coach.ing.caffeine.cat": "Benchmark stimulant",
  "coach.ing.caffeine.study": "Presented as fact — no health claim is authorised for caffeine",
  "coach.ing.caffeine.what": "The most studied active in sports nutrition. Central nervous system stimulant; antagonist of the adenosine receptors.",
  "coach.ing.citrulline.benefit1": "Intense muscle pump",
  "coach.ing.citrulline.benefit2": "Support for between-set recovery",
  "coach.ing.citrulline.benefit3": "Nitric oxide precursor",
  "coach.ing.citrulline.benefit4": "Muscle vasodilation",
  "coach.ing.citrulline.cat": "Muscle pump",
  "coach.ing.citrulline.study": "Pérez-Guisado (2010), bench press study, 41 trained subjects",
  "coach.ing.citrulline.what": "THE pump. Precursor of nitric oxide → vasodilation → swollen muscles, visible veins, support for muscle recovery.",
  "coach.ing.creatine.benefit1": "Increases physical performance in successive bursts of short-term, high intensity exercise (EFSA claim Reg 432/2012, ≥3g/day)",
  "coach.ing.creatine.benefit2": "Regenerates ATP via creatine kinase",
  "coach.ing.creatine.benefit3": "Increases the muscle store of phosphocreatine",
  "coach.ing.creatine.benefit4": "Cumulative effect after ~4 weeks of regular use",
  "coach.ing.creatine.cat": "Strength & power",
  "coach.ing.creatine.study": "EFSA Reg 432/2012 (official EU health claim) · Kreider 2017 ISSN meta-analysis",
  "coach.ing.creatine.what": "The most studied active in sports nutrition.",
  "coach.ing.electrolytes.benefit1": "Support for hydration during exercise",
  "coach.ing.electrolytes.benefit2": "Three minerals dosed together, to the mg",
  "coach.ing.electrolytes.benefit3": "Slider from 0 to 1500 mg per serving",
  "coach.ing.electrolytes.benefit4": "Doses shown to the mg",
  "coach.ing.electrolytes.cat": "Electrolyte complex",
  "coach.ing.electrolytes.study": "Burke (2003):electrolytes = perf > water alone over >1h",
  "coach.ing.electrolytes.what": "The sodium, potassium and magnesium trio of the formula — dosed to the mg, for hydration during exercise.",
  "coach.ing.glycerol.benefit1": "Intracellular hydration",
  "coach.ing.glycerol.benefit2": "Pump that lasts 60min+",
  "coach.ing.glycerol.benefit3": "Extended endurance",
  "coach.ing.glycerol.benefit4": "Improved recovery",
  "coach.ing.glycerol.cat": "Cellular hydration",
  "coach.ing.glycerol.study": "Patlar (2012):+3% performance on long efforts",
  "coach.ing.glycerol.what": "Pump 2.0. Draws water into the muscle cells → fuller muscles, for longer.",
  "coach.ing.pinksalt.benefit1": "Natural source of sodium",
  "coach.ing.pinksalt.benefit2": "Sodium is critical beyond 90 min of exercise",
  "coach.ing.pinksalt.benefit3": "Supply of essential minerals",
  "coach.ing.pinksalt.benefit4": "Exact dose shown to the mg",
  "coach.ing.pinksalt.cat": "Natural electrolytes",
  "coach.ing.pinksalt.study": "Maughan (2007):salt = the key to hydration",
  "coach.ing.pinksalt.what": "Natural source of sodium. Beyond 90 min of exercise, sodium intake becomes critical — dose shown to the mg.",
  "coach.ing.piperine.benefit1": "Improves bioavailability",
  "coach.ing.piperine.benefit2": "Patented natural extract",
  "coach.ing.piperine.benefit3": "Standardised pure form",
  "coach.ing.piperine.benefit4": "Piperine 2 mg per serving — the MyNutriLab product cap",
  "coach.ing.piperine.cat": "Black pepper extract",
  "coach.ing.piperine.study": "Shoba (1998) Planta Medica",
  "coach.ing.piperine.what": "Standardised black pepper extract, studied for absorption (Shoba 1998 study on turmeric+piperine).",
  "coach.ing.taurine.benefit1": "Sulphur amino acid naturally present in muscle",
  "coach.ing.taurine.benefit2": "Up to 1000 mg — a full dose",
  "coach.ing.taurine.benefit3": "Exact dose shown on the label",
  "coach.ing.taurine.benefit4": "Adjustable to the mg in your formula",
  "coach.ing.taurine.cat": "Sulphur amino acid",
  "coach.ing.taurine.study": "Galloway (2008):controlled study on taurine and endurance",
  "coach.ing.taurine.what": "Sulphur amino acid, naturally present in muscle. Up to 1000 mg — every mg shown on the label.",
  "coach.ing.theanine.benefit1": "Theanine:caffeine 1:1 ratio studied (Owen 2008)",
  "coach.ing.theanine.benefit2": "200 mg = a full dose, not a sprinkle",
  "coach.ing.theanine.benefit3": "Exact dose shown on the label",
  "coach.ing.theanine.benefit4": "Adjustable to the mg in your formula",
  "coach.ing.theanine.cat": "Ratio studied with caffeine",
  "coach.ing.theanine.study": "Owen et al. (2008):caff+theanine combo studied in a controlled trial vs caffeine alone",
  "coach.ing.theanine.what": "The green tea amino acid. Often paired with caffeine — up to 1:1 in our recipes (Owen 2008) — adjustable to the mg.",
  "coach.ing.tyrosine.benefit1": "Precursor of dopamine and noradrenaline",
  "coach.ing.tyrosine.benefit2": "Studied under physical stress (Coull 2015)",
  "coach.ing.tyrosine.benefit3": "Up to 1000 mg — a full dose",
  "coach.ing.tyrosine.benefit4": "Adjustable to the mg in your formula",
  "coach.ing.tyrosine.cat": "Dopamine precursor",
  "coach.ing.tyrosine.study": "Coull et al. (2015):effects observed on cognition under physical stress (controlled study)",
  "coach.ing.tyrosine.what": "Precursor of dopamine and noradrenaline. Up to 1000 mg in your formula — a full dose, shown to the mg.",
  "coach.keep": "Keep",
  "coach.labtip1": "Beta-alanine causes mild tingling on the skin (paraesthesia). It is harmless and short-lived.",
  "coach.labtip10": "Citrulline is better absorbed on an empty stomach, ~25 min before your session.",
  "coach.labtip11": "Citrulline → nitric oxide precursor → vasodilation → muscle pump.",
  "coach.labtip12": "Creatine monohydrate is the only active in the formula that carries an authorised European claim (EU Reg 432/2012), from 3 g a day.",
  "coach.labtip13": "Creatine monohydrate 3 g a day: the dose behind the EFSA claim on successive bursts of short-term, high intensity exercise.",
  "coach.labtip14": "Glycerol draws water into the muscle cells.",
  "coach.labtip15": "Glycerol before a session supports prolonged intracellular hydration in hot weather.",
  "coach.labtip16": "Glycerol: 3 g per serving, that is the MyNutriLab product cap. Steps you can set in the builder: 0,5 · 1 · 1,5 · 2 · 3 g — every dose shown, nothing hidden.",
  "coach.labtip17": "Himalayan pink salt contains natural minerals — support for electrolyte balance.",
  "coach.labtip18": "Beyond 90 min of exercise, sodium intake is critical for hydration and nerve impulses.",
  "coach.labtip19": "L-tyrosine is a precursor of dopamine and noradrenaline. Exact dose shown to the mg.",
  "coach.labtip2": "Beta-alanine = saturating the muscles with carnosine. That saturation builds over 4-6 weeks of regular use.",
  "coach.labtip20": "Tyrosine = up to 1000 mg in your formula, adjustable to the mg. Popular in technical sports (boxing, fencing, golf).",
  "coach.labtip21": "Piperine (black pepper) improves the bioavailability of fat-soluble actives.",
  "coach.labtip22": "Piperine is dosed at 2 mg per serving: that is the MyNutriLab product cap, set below the acceptable daily intake used by ANSES. Above that, no extra absorption (the law of diminishing returns).",
  "coach.labtip23": "Taurine is a sulphur amino acid naturally present in muscle. Up to 1000 mg, every mg shown.",
  "coach.labtip24": "Citrulline + beta-alanine: a duo combining muscle pump (nitric oxide) and pH buffer (carnosine) for long sets.",
  "coach.labtip25": "Caffeine + L-theanine: the most studied duo in the literature (Owen 2008, Haskell 2008). Up to 1:1 in our recipes — and every dose stays adjustable to the mg.",
  "coach.labtip26": "All our doses respect the ANSES thresholds (caffeine 200mg/day) and the WHO thresholds (caffeine 200mg/day in pregnancy).",
  "coach.labtip27": "Our 11 actives are not on the WADA prohibited list to our knowledge — in competition (boxing, athletics, CrossFit…), always check with your federation.",
  "coach.labtip28": "No caffeine after 17:00 if you are sensitive. Half-life 5-6h: half your dose is still circulating 6h later. Adjustable to the mg, right down to zero.",
  "coach.labtip3": "Caffeine 100mg = 1 espresso. 200mg = the ANSES maximum limit for sporting effort. We never go past that cap.",
  "coach.labtip4": "Caffeine blocks the adenosine receptors — the most documented mechanism in sports nutrition. Plasma peak: 15-45 min after intake.",
  "coach.labtip5": "⏰ Caffeine half-life: 5-6h. A session at 18:00 with 200mg → still 100mg circulating at midnight. That is why we dose low in the evening.",
  "coach.labtip6": "♀ Caffeine metabolism varies a lot from one profile to another (genetics, oral contraception). That is why we suggest -15% by default — adjustable to the mg.",
  "coach.labtip7": "L-theanine pairs with caffeine — up to 1:1 in our recipes, the duo of the studies (Owen 2008) — and it is set to the mg, not to the marketing.",
  "coach.labtip8": "Optimal caffeine:theanine ratio = 1:1 or 1:2 depending on the studies. We always respect it.",
  "coach.labtip9": "L-Theanine: 200 mg per serving, that is the MyNutriLab product cap. Steps you can set in the builder: 25 · 50 · 100 · 150 · 200 mg — the trials on the caffeine/theanine duo cover 100 to 200 mg; beyond that, you leave performance behind for relaxation.",
  "coach.link_copied_check": "✓ Link copied!",
  "coach.listen": "Listen",
  "coach.loading1": "Analysing your sport profile…",
  "coach.loading10": "Finalising your made-to-measure formula…",
  "coach.loading11": "**Did you know?** Caffeine is an antagonist of the adenosine receptors. With us: 200 mg max, the ANSES cap — every mg shown.",
  "coach.loading12": "**Science:** L-theanine + caffeine is one of the most studied duos in sports nutrition (Owen 2008, Haskell 2008). Our ratio: 1:1 to 1:2, shown to the mg.",
  "coach.loading13": "**Did you know?** Citrulline is a precursor of nitric oxide → vasodilation → muscle pump.",
  "coach.loading14": "**Science:** Beta-alanine increases muscle carnosine in 4 weeks, acting as a pH buffer (Saunders 2017).",
  "coach.loading15": "**Studies:** Creatine monohydrate is the only active in the formula that carries an authorised European claim (EU Reg 432/2012), from 3 g a day.",
  "coach.loading16": "**Physiology:** Glycerol draws water into the muscle cells to support prolonged hydration.",
  "coach.loading17": "**Nutrition:** Himalayan pink salt brings natural minerals for electrolyte balance.",
  "coach.loading18": "**Biochemistry:** L-tyrosine is a precursor of dopamine and noradrenaline. Exact dose shown to the mg on the label.",
  "coach.loading19": "**Did you know?** Piperine (black pepper) improves the bioavailability of fat-soluble actives (Shoba 1998).",
  "coach.loading2": "Calculating the dosages in mg/kg…",
  "coach.loading20": "**Endurance:** Beyond 90 min of exercise, you lose 1-2g of sodium per hour of sweat — hence the electrolytes.",
  "coach.loading21": "**Strength:** Olympic athletes take up to 6mg/kg of caffeine before competition (ANSES limit 200mg).",
  "coach.loading22": "**Research:** The caffeine + L-theanine synergy is one of the most documented in the literature (Owen 2008, Haskell 2008). Up to 1:1 in our recipes, adjustable to the mg.",
  "coach.loading23": "**Performance:** Citrulline significantly improves muscular endurance on repeated sets (Trexler 2019 meta-analysis, JISSN).",
  "coach.loading24": "**Safety:** All our doses respect the ANSES thresholds — caffeine capped at 200mg/day, beta-alanine 4g max.",
  "coach.loading3": "Checking the synergy of the 11 actives…",
  "coach.loading4": "Calibrating the intensity for your sport…",
  "coach.loading5": "Cross-checking with 12 PubMed clinical studies…",
  "coach.loading6": "Adjusting to stay within the ANSES thresholds…",
  "coach.loading7": "Optimising the caffeine/theanine ratio for YOU…",
  "coach.loading8": "Reviewing the actives and their dosages…",
  "coach.loading9": "Testing the interactions between actives…",
  "coach.long_wait_hint": "Tricky question, the coach is taking time to calibrate. You can cancel with Esc or wait.",
  "coach.mail_subject": "My MyNutriLab pre-workout formula ",
  "coach.modal_facts_html": "<p><strong>The facts, nothing else:</strong></p>",
  "coach.modal_max_prefix_html": "<span style=\"font-size:13px;font-weight:900;color:#16a34a;\">Max: ",
  "coach.modal_safety_marker_html": "<div style=\"position:absolute;top:-2px;left:70%;width:3px;height:12px;background:#0f172a;border-radius:2px;box-shadow:0 0 4px rgba(0,0,0,.4);\" title=\"MNL safety threshold\"></div>",
  "coach.modal_scale_label_html": "<span style=\"font-size:11px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;\">Scientific scale</span>",
  "coach.modal_scale_ticks_html": "<span>Optimal</span><span>MNL cap</span><span>Excess</span>",
  "coach.modal_synergies_title_html": "<div class=\"mnl-ai-modal__synergies\"><p style=\"font-weight:800;font-size:13px;margin:18px 0 10px;color:#f5f5f5;\">Winning combos in your formula:</p>",
  "coach.multicompare_footnote_html": "<p style=\"margin:14px 0 0;font-size:11px;color:#94a3b8;text-align:center;font-style:italic;\">All values in the original unit (mg/g depending on the active)</p>",
  "coach.multicompare_head_html": "<table style=\"width:100%;border-collapse:collapse;font-size:12px;margin-top:14px;\"><thead><tr style=\"border-bottom:2px solid rgba(15,23,42,.15);\"><th style=\"text-align:left;padding:8px 4px;font-size:10px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;\">Active</th>",
  "coach.multicompare_title_prefix_html": "<h3>Comparing ",
  "coach.multicompare_title_suffix_html": " formulas</h3>",
  "coach.no_commitment": "No commitment",
  "coach.note_free_relay_html": "Pickup point delivery free from 49 €",
  "coach.note_mnl10_hint_suffix": " · Standard 30 servings from {price} → from {net_price} with MNL10",
  "coach.note_mnl10_missing_suffix_html": " €</strong> for −10 € with <strong>MNL10</strong>",
  "coach.note_mnl10_once_html": "with the code <strong>MNL10</strong> · 1<sup>st</sup> order · applied at checkout",
  "coach.note_mnl10_sub_html": "−10 € with the code <strong>MNL10</strong> · 1<sup>st</sup> delivery only · applied at checkout<br><span style=\"font-weight:400;opacity:.8;\">The following deliveries keep the −10% subscription discount.</span>",
  "coach.note_mnl10_sub_suffix_html": " — on a subscription, it applies to the 1<sup>st</sup> delivery (the following ones keep the −10%)",
  "coach.note_mnl10_subtotal_suffix": " on this subscription subtotal (already discounted by −10%)",
  "coach.per_month_eur": "€/month",
  "coach.perf_badge_prefix_html": "<span aria-hidden=\"true\"></span> Generated in <strong>",
  "coach.perf_badge_words": " words",
  "coach.pin_top": "Pin to the top",
  "coach.placeholder_ask_hint": "Type a question if you are unsure",
  "coach.placeholder_ex2_actives": "Ask your question about the actives...",
  "coach.placeholder_ex2_combat": "E.g. Combat sports, late evening session",
  "coach.placeholder_ex2_crossfit": "E.g. CrossFit, sensitive to caffeine",
  "coach.placeholder_ex2_cycling": "E.g. Road cycling, endurance >2h",
  "coach.placeholder_ex2_muscu": "E.g. Weights 4x/week, I want more pump",
  "coach.placeholder_ex2_running": "E.g. Long distance running, hot summer",
  "coach.placeholder_ex_crossfit": "E.g. \"CrossFit 5x/week\"",
  "coach.placeholder_ex_marathon": "E.g. \"Marathon in 3 months\"",
  "coach.placeholder_ex_morning": "E.g. \"I train in the morning\"",
  "coach.placeholder_ex_sensitive": "E.g. \"Sensitive to caff\"",
  "coach.placeholder_listening": "Listening... speak now",
  "coach.placeholder_mic_hint": "You can also speak into the mic",
  "coach.placeholder_other": "or something else…",
  "coach.placeholder_write_answer": "Write your answer...",
  "coach.print_default_name": "My MNL formula",
  "coach.print_foot2_html": "MyNutriLab — The made-to-measure pre-workout<br>",
  "coach.print_foot_html": "<div class=\"foot\">French brand · Made in a laboratory<br>",
  "coach.print_price_prefix_html": "<div class=\"box\"><strong>Price: ",
  "coach.print_price_suffix_html": "</strong> · Pickup point free from 49€ · French brand</div>",
  "coach.print_sub_html": "<p class=\"sub\">Made-to-measure pre-workout formula · MyNutriLab</p>",
  "coach.print_table_head_html": "<table><thead><tr><th>Active</th><th style=\"text-align:right;\">Dose</th></tr></thead><tbody>",
  "coach.print_why_default": "11 actives, every dose shown to the nearest mg, calibrated for your sport profile.",
  "coach.print_why_html": "<div class=\"box\"><h2>Why this formula?</h2><p>",
  "coach.profile_complete": "✓ Profile complete",
  "coach.profile_detected_html": "<div class=\"mnl-ai-recap\"><span class=\"mnl-ai-recap__lbl\">Profile detected:</span>",
  "coach.profile_learning": "The coach is getting to know you",
  "coach.profile_listening": "The coach is listening…",
  "coach.profile_progressing": "Keep going, this is coming along nicely",
  "coach.profile_refining": "The coach is fine-tuning…",
  "coach.promo_applied_prefix_html": "✓ Code <strong>",
  "coach.promo_applied_suffix_html": "</strong> applied — the discount will be active at checkout",
  "coach.promo_enter_code": "Enter a promo code",
  "coach.promo_invalid": "This code is not valid",
  "coach.promo_network_error": "Network error — please try again",
  "coach.prompt_mem_msg": "Leave it empty to erase this info.",
  "coach.prompt_tags_msg": "Comma separated — max 6 tags, 20 characters each.",
  "coach.prompt_tags_placeholder": "bulk, summer, test",
  "coach.prompt_tags_title": "Tags for this formula",
  "coach.qr_sub": "Scan to open your formula, send the link to your mates or download the QR.",
  "coach.quiz_done_html": "<strong>✓ Quiz complete</strong>",
  "coach.quiz_progress_prefix_html": "Quiz: <strong>",
  "coach.recap_clear_all_html": "</span> <button type=\"button\" class=\"mnl-ai-recap__clear-all\" id=\"mnlAiRecapClearAll\" title=\"Forget every field\">Forget everything</button></div>",
  "coach.recap_head_html": "<div class=\"mnl-ai-recap__head\">Session resumed <span class=\"mnl-ai-recap__age\">",
  "coach.recap_import_head_html": "<div class=\"mnl-ai-recap__head\">Shared conversation imported <span class=\"mnl-ai-recap__age\">",
  "coach.recap_import_readonly_html": "<div class=\"mnl-ai-recap__chips\"><span class=\"mnl-ai-recap__chip\">Read only — start a new conv by asking your question</span></div>",
  "coach.reorder": "Order again",
  "coach.reorder_sub": "Order again on subscription",
  "coach.reorder_sub_title": "Add this formula to the cart on a monthly subscription −10%, no commitment",
  "coach.reorder_title": "Add this formula to the cart as a one-time purchase",
  "coach.restart": "Start over",
  "coach.restore": "Restore",
  "coach.retry_button": "⚠Try again",
  "coach.retry_in_a_moment": "Try again in a moment",
  "coach.retry_in_a_moment_dot": "Try again in a moment.",
  "coach.retry_short": "Try again",
  "coach.save": "Save",
  "coach.send": "Send",
  "coach.sending_ellipsis": "Sending…",
  "coach.share": "Share",
  "coach.share_formula_msg": "Direct link to your personalised formula.",
  "coach.share_formula_title": "Share your formula",
  "coach.share_title_short": "My MNL formula",
  "coach.shared_check": "Shared ✓",
  "coach.sharing_ellipsis": "Sharing…",
  "coach.speed_fast": "Fast playback",
  "coach.speed_help": "Speeds available: `/speed slow` · `/speed normal` · `/speed fast`",
  "coach.speed_normal": "Normal playback",
  "coach.speed_slow": "Slow playback",
  "coach.speed_updated": "Speed updated",
  "coach.sport_general": "general",
  "coach.storage_full": "Storage full",
  "coach.storage_full_notes_sub": "Delete some notes to free up space",
  "coach.stream_stop_html": "<span class=\"mnl-ai-stream-pill__lbl\">Stop</span>",
  "coach.subscribe_prefix": "Subscribe · ",
  "coach.syn.betaalanine.desc": "Nitric oxide (citrulline) + carnosine buffer (beta-alanine). Two mechanisms, two full doses.",
  "coach.syn.betaalanine.desc2": "Creatine monohydrate 3 g (authorised EFSA claim on successive bursts of very intense effort) + beta-alanine to hold the long sets.",
  "coach.syn.betaalanine.label": "Muscular Endurance Combo",
  "coach.syn.betaalanine.label2": "Strength + Size Combo",
  "coach.syn.caffeine.desc": "Theanine + caffeine, up to 1:1 — the most studied duo in the literature (Owen 2008, Haskell 2008). Doses shown to the mg.",
  "coach.syn.caffeine.desc2": "Caffeine at the ANSES cap of 200 mg + tyrosine, a precursor of dopamine. Two exact doses, shown to the mg.",
  "coach.syn.caffeine.label": "Studied Combo",
  "coach.syn.caffeine.label2": "Caffeine + Tyrosine Combo",
  "coach.syn.citrulline.desc": "Citrulline = vasodilation, glycerol = cellular hydration. Together = a pump that is big AND lasting.",
  "coach.syn.citrulline.desc2": "Citrulline for nitric oxide + beta-alanine for muscle pH = +reps on long sets.",
  "coach.syn.citrulline.label": "Pump 2.0 Combo",
  "coach.syn.citrulline.label2": "Muscular Endurance Combo",
  "coach.syn.creatine.desc": "Creatine ≥3g: increases physical performance in successive bursts of short-term, high intensity exercise (EFSA claim). Beta-alanine: precursor of carnosine. The benchmark duo for CrossFit / HYROX / long WODs.",
  "coach.syn.creatine.desc2": "Creatine saturates the muscles with phosphocreatine, citrulline maximises the vascular pump. Muscle size and performance combined.",
  "coach.syn.creatine.desc3": "Caffeine at the ANSES cap of 200mg + creatine ≥3g — increases physical performance in successive bursts of short-term, high intensity exercise (EFSA claim). Sprints, jumps, max lifts.",
  "coach.syn.creatine.label": "Strength + Endurance Combo",
  "coach.syn.creatine.label2": "Maximum Size Combo",
  "coach.syn.creatine.label3": "Sprint & Explosiveness Combo",
  "coach.syn.electrolytes.desc": "Potassium contributes to the normal functioning of the nervous system (EFSA claim). The hydration duo for long efforts.",
  "coach.syn.electrolytes.label": "Pro Hydration Combo",
  "coach.syn.glycerol.desc": "Maximum muscle size + prolonged intracellular hydration.",
  "coach.syn.glycerol.desc2": "Salt + glycerol = optimal water absorption, long-lasting protection against dehydration.",
  "coach.syn.glycerol.label": "Pump 2.0 Combo",
  "coach.syn.glycerol.label2": "Pro Hydration Combo",
  "coach.syn.pinksalt.desc": "The hydration combo for long efforts (>1h) — sodium + glycerol, doses shown to the mg.",
  "coach.syn.pinksalt.desc2": "Pink salt + taurine — two full doses, shown to the mg.",
  "coach.syn.pinksalt.label": "Pro Hydration Combo",
  "coach.syn.pinksalt.label2": "Long Efforts Combo",
  "coach.syn.piperine.desc": "Piperine (black pepper) improves the bioavailability of fat-soluble actives. Bioavailability reference on turmeric+piperine (Shoba 1998).",
  "coach.syn.piperine.label": "Universal Booster",
  "coach.syn.taurine.desc": "Built for efforts >2h:marathon, ultra-trail, ironman. Doses shown to the mg.",
  "coach.syn.taurine.label": "Long Efforts Combo",
  "coach.syn.theanine.desc": "Caff 100 mg + theanine 200 mg — a pairing inside the range of the studies (Owen 2008).",
  "coach.syn.theanine.label": "Studied Combo",
  "coach.syn.tyrosine.desc": "Tyrosine is the direct precursor of dopamine and noradrenaline. Exact dose shown to the mg.",
  "coach.syn.tyrosine.label": "Caffeine + Tyrosine Combo",
  "coach.tease_check1": "11 actives validated",
  "coach.tease_check2": "Dosages consistent",
  "coach.tease_check3": "Dosed to the nearest mg",
  "coach.tease_check4": "Suited to intensive training",
  "coach.tease_phase1": "Analysing your sport profile",
  "coach.tease_phase2": "Selecting the optimal actives",
  "coach.tease_phase3": "Calibrating the doses to the nearest mg",
  "coach.tease_phase4": "Final check",
  "coach.tease_row_goal": "Goal",
  "coach.tease_row_intensity": "Intensity",
  "coach.tease_row_level": "Level",
  "coach.tease_row_sport": "Sport",
  "coach.tease_title_html": "</span><span class=\"mnl-ai-tease2__title\" data-t2-title>Analysing your profile…</span></div>",
  "coach.tip.boxe.1.text": "Take it 25 min before your sparring/padwork. Caff + theanine, the duo of the studies (Owen 2008), dosed to the nearest mg.",
  "coach.tip.boxe.1.title": "Optimal timing",
  "coach.tip.boxe.2.text": "Check that the glycerol dose does not put 1-2kg on you just before the weigh-in. Adapt it to the timing of the fight.",
  "coach.tip.boxe.2.title": "Weight class",
  "coach.tip.boxe.3.text": "Our actives are not on the WADA prohibited list to our knowledge — in competition, always check with your federation.",
  "coach.tip.boxe.3.title": "Competition",
  "coach.tip.crossfit.1.text": "Take it 25-30 min before your WOD. Timing set on the plasma peak of caffeine (15-45 min).",
  "coach.tip.crossfit.1.title": "Optimal timing",
  "coach.tip.crossfit.2.text": "Mix into 400ml of cold water + add another 200ml during the WOD. The sled push does not forgive dehydration.",
  "coach.tip.crossfit.2.title": "Hydration",
  "coach.tip.crossfit.3.text": "Across your 5 sessions a week, keep 1-2 days off WITHOUT pre-workout. Caffeine tolerance is documented — off days are standard practice.",
  "coach.tip.crossfit.3.title": "Recovery",
  "coach.tip.cyclisme.1.text": "On a ride >3h, take it 30 min before + 1/2 a serving during (km 60-80). Splitting it keeps you under the ANSES cap of 200mg across the ride.",
  "coach.tip.cyclisme.1.title": "Optimal timing",
  "coach.tip.cyclisme.2.text": "Before the climbs: caff 200mg (the ANSES cap, no more) + citrulline up to 8g. Hydration x2 is a must at altitude.",
  "coach.tip.cyclisme.2.title": "Mountains",
  "coach.tip.cyclisme.3.text": "On a sportive, mix it into a 750ml bottle + add 1 isotonic serving. The complete hydration combo for long efforts.",
  "coach.tip.cyclisme.3.title": "Hydration",
  "coach.tip.default.1.text": "Take it 20-30 min before your session so that every active is bioavailable at the right moment.",
  "coach.tip.default.1.title": "Optimal timing",
  "coach.tip.default.2.text": "Mix into 300-400ml of cold water. If you feel the beta-alanine tingle (face, hands), that is normal and short-lived.",
  "coach.tip.default.2.title": "Hydration",
  "coach.tip.default.3.text": "On your off days, do not take the pre-workout. Caffeine tolerance is documented — off days are standard practice.",
  "coach.tip.default.3.title": "Recovery",
  "coach.tip.football.1.text": "Before a match:25-30 min. Caff at the ANSES cap of 200mg + tyrosine, a precursor of dopamine — every dose shown to the mg.",
  "coach.tip.football.1.title": "Optimal timing",
  "coach.tip.football.2.text": "Citrulline (nitric oxide) + beta-alanine (carnosine buffer): the duo studied on repeated efforts, full doses shown.",
  "coach.tip.football.2.title": "Repeated sprints",
  "coach.tip.football.3.text": "If the match is in full sun, double up on the electrolytes — sweat carries off sodium that has to be replaced.",
  "coach.tip.football.3.title": "Heat adaptation",
  "coach.tip.golf.1.text": "Before the 1st round:20 min. Caffeine half-life: 5-6h — it stays in circulation across the whole round. Dose set to the mg.",
  "coach.tip.golf.1.title": "Optimal timing",
  "coach.tip.golf.2.text": "L-Theanine 200mg at a 2:1 ratio with caffeine — the studied ratio (Owen 2008). Caffeine capped at 100mg: half the ANSES cap, your call to the nearest mg.",
  "coach.tip.golf.2.title": "Focus",
  "coach.tip.golf.3.text": "Over 18 holes + the range, take 1/2 a serving at the turn (hole 9-10). You stay under the ANSES cap of 200mg across the day.",
  "coach.tip.golf.3.title": "Long round",
  "coach.tip.hyrox.1.text": "Take it 30 min before HYROX. Station 4 (sled push) is the most demanding — beta-alanine, a precursor of carnosine, is studied on exactly this effort format (Hobson 2012).",
  "coach.tip.hyrox.1.title": "Optimal timing",
  "coach.tip.hyrox.2.text": "Mix into 400ml. On the transitions, 50ml sips of water to hold cellular hydration.",
  "coach.tip.hyrox.2.title": "Hydration",
  "coach.tip.hyrox.3.text": "On the wall balls (station 5), every mg counts. Theanine + tyrosine: exact doses shown, adjustable to the mg.",
  "coach.tip.hyrox.3.title": "Mental",
  "coach.tip.musculation.1.text": "Take it 20-25 min before your session. For your 5x5 squat, the pump lands right on sets 3-4 — when you push the hardest.",
  "coach.tip.musculation.1.title": "Optimal timing",
  "coach.tip.musculation.2.text": "Mix into 350ml of water. On drop sets or rest-pause, glycerol keeps the pump from fading.",
  "coach.tip.musculation.2.title": "Hydration",
  "coach.tip.musculation.3.text": "Cycle 4 weeks ON / 1 week OFF: the standard protocol for handling caffeine tolerance. Your dose stays adjustable to the mg on every order.",
  "coach.tip.musculation.3.title": "Progression",
  "coach.tip.powerlifting.1.text": "At a meet, take it 35-40 min before your 1st attempt. For bench/squat/deadlift, strength peaks between 30 and 60 min.",
  "coach.tip.powerlifting.1.title": "Optimal timing",
  "coach.tip.powerlifting.2.text": "Creatine monohydrate 3g (the EFSA claim threshold) + caff 200mg (ANSES cap, no more). Avoid too much pump (moderate citrulline), you would feel \"diluted\" on the max attempts.",
  "coach.tip.powerlifting.2.title": "1RM",
  "coach.tip.powerlifting.3.text": "Our actives are not on the WADA prohibited list to our knowledge — in federated competition (FFForce/IPF…), always check with your federation.",
  "coach.tip.powerlifting.3.title": "Competition",
  "coach.tip.rugby.1.text": "Before a match:30 min. Before physical training:25 min. Beta-alanine: precursor of carnosine, the pH buffer studied on repeated efforts (Hobson 2012).",
  "coach.tip.rugby.1.title": "Optimal timing",
  "coach.tip.rugby.2.text": "Citrulline 8g full dose + creatine monohydrate 3g (EFSA claim threshold). Two full doses, shown to the mg.",
  "coach.tip.rugby.2.title": "Contact",
  "coach.tip.rugby.3.text": "For an 80 min match, plan on 1L of extra water. Sweat carries off sodium — pink salt + electrolytes, doses shown to the mg.",
  "coach.tip.rugby.3.title": "Hydration",
  "coach.tip.running.1.text": "On intervals:25 min before. On a long run >2h:take 1/2 a serving — you keep headroom under the ANSES cap of 200mg, even with a caffeinated gel on the way.",
  "coach.tip.running.1.title": "Optimal timing",
  "coach.tip.running.2.text": "Mix into 500ml. On a marathon, double up on the electrolytes — beyond 90 min of exercise, sodium intake becomes critical.",
  "coach.tip.running.2.title": "Hydration",
  "coach.tip.running.3.text": "In hot conditions, drop the caff to 100mg max — half the ANSES cap. Your formula is set to the mg for exactly that.",
  "coach.tip.running.3.title": "Heat",
  "coach.title_stop_esc": "Stop (ESC)",
  "coach.toast_already_saved_sub": "This answer is already in your favourites",
  "coach.toast_already_saved_title": "Already saved",
  "coach.toast_already_shared_sub": "Thanks for adding to the community!",
  "coach.toast_already_shared_title": "Already shared",
  "coach.toast_conversation_copied": "Conversation copied",
  "coach.toast_copied": "Copied",
  "coach.toast_copy_failed_sub": "Try again or share it by hand",
  "coach.toast_copy_failed_title": "Copy failed",
  "coach.toast_csv_exported": "CSV exported",
  "coach.toast_doses_infix": " · servings ",
  "coach.toast_edit_msg_sub": "Fix it and send it again",
  "coach.toast_edit_msg_title": "Message to edit",
  "coach.toast_export_failed_sub": "Try again or go through the contact form (/pages/contact)",
  "coach.toast_export_failed_title": "Export failed",
  "coach.toast_fav": "Added to favourites",
  "coach.toast_fav_added_sub": "You can load it again from My formulas",
  "coach.toast_fav_added_title": "Added to favourites!",
  "coach.toast_fav_removed_title": "Removed from favourites",
  "coach.toast_field_forgotten": "Field forgotten",
  "coach.toast_format_prefix": "Size ",
  "coach.toast_formula_deleted": "Formula deleted",
  "coach.toast_formula_incomplete_sub": "This formula cannot be shared.",
  "coach.toast_formula_incomplete_title": "Incomplete formula",
  "coach.toast_formula_renamed": "Formula renamed",
  "coach.toast_formula_shared_sub": "Thank you — it is joining the community.",
  "coach.toast_formula_shared_title": "Formula shared",
  "coach.toast_image_failed_sub": "Browser too old or not enough memory",
  "coach.toast_image_failed_title": "Image failed",
  "coach.toast_intensity_prefix": "Intensity ",
  "coach.toast_link_copied": "Link copied",
  "coach.toast_max4_sub": "Untick one to bring it down",
  "coach.toast_max4_title": "Maximum 4 formulas",
  "coach.toast_memory_cleared_sub": "The coach starts again from scratch",
  "coach.toast_memory_cleared_title": "Memory cleared",
  "coach.toast_memory_updated": "Memory updated",
  "coach.toast_message_copied": "Message copied",
  "coach.toast_mic_blocked_sub": "Go to Settings → Website → Microphone to allow MyNutriLab",
  "coach.toast_mic_blocked_title": "Mic blocked",
  "coach.toast_mic_unavailable": "Mic unavailable",
  "coach.toast_need_help_sub": "You can click a suggestion or speak into the mic",
  "coach.toast_need_help_title": "Need a hand?",
  "coach.toast_no_question_to_regen": "No question to regenerate",
  "coach.toast_pinned": "Pinned to the top",
  "coach.toast_popup_blocked_sub": "Allow pop-ups for this site.",
  "coach.toast_popup_blocked_sub_retry": "Allow pop-ups for this site and try again.",
  "coach.toast_popup_blocked_title": "Pop-up blocked",
  "coach.toast_promo_applied": "Promo code applied",
  "coach.toast_question_loaded_sub": "Edit it if you need to, then send",
  "coach.toast_question_loaded_title": "Question loaded",
  "coach.toast_quiz_reset_sub": "We start again from scratch",
  "coach.toast_quiz_reset_title": "Quiz reset",
  "coach.toast_reminder_sub_long": "Import the file into Calendar (iPhone) / Google Calendar / Outlook",
  "coach.toast_reminder_sub_short": "Import it into your calendar",
  "coach.toast_reminder_title": "Reminder downloaded",
  "coach.toast_retry_auto_prefix": "Automatic retry in ",
  "coach.toast_retry_prefix": "Retry in ",
  "coach.toast_save_failed_title": "Save failed",
  "coach.toast_saved_fav_title": "Saved to favourites",
  "coach.toast_server_busy_title": "Server overloaded",
  "coach.toast_share_failed_title": "Share failed",
  "coach.toast_sub_on": "Subscription switched on",
  "coach.toast_sub_save_prefix": "Save ",
  "coach.toast_sub_unavailable_sub": "We are adding it as a one-time purchase. Our team will contact you to switch on the -10% subscription within 24h.",
  "coach.toast_sub_unavailable_title": "Subscription temporarily unavailable",
  "coach.toast_tag_added": "Tag added",
  "coach.toast_tags_cleared": "Tags removed",
  "coach.toast_tone_updated_sub": "In effect from the next coach answer",
  "coach.toast_tone_updated_title": "Tone updated",
  "coach.toast_tts_unavailable_sub": "Browser not supported",
  "coach.toast_tts_unavailable_title": "TTS unavailable",
  "coach.toast_unfav": "Removed from favourites",
  "coach.toast_unpinned": "Unpinned",
  "coach.tone_direct_on": "Direct mode on",
  "coach.tone_friendly_on": "Mate mode on",
  "coach.tone_pro_on": "Pro mode on",
  "coach.tts_actives_label": "Actives per serving:",
  "coach.tts_flavor_label": "Flavor ",
  "coach.tts_intro": "Here is your MyNutriLab pre-workout formula.",
  "coach.tts_outro": ". Have a great session!",
  "coach.tts_pause_aria": "Pause the playback",
  "coach.tts_play_aria": "Read this message out loud",
  "coach.tts_resume_aria": "Resume the playback",
  "coach.tts_stop": "⏸ Stop",
  "coach.unfavorite": "★ Remove favourite",
  "coach.unpin": "Unpin",
  "coach.update": "Update",
  "coach.view_cart": "View the cart",
  "coach.voice_err_audio_capture": "No mic detected. Check that it is plugged in.",
  "coach.voice_err_network": "Voice recognition unavailable (network). Type your message instead.",
  "coach.voice_err_no_speech": "I did not hear anything. Type your message or try again.",
  "coach.voice_err_not_allowed": "Mic refused. Allow it in the browser settings (icon in the address bar).",
  "coach.voice_err_service": "This browser does not support the mic. Type your message.",
  "coach.voice_level_loud": "A bit loud, ease off a touch",
  "coach.voice_level_normal": "Listening…",
  "coach.voice_level_silence": "I cannot hear anything — speak up a little",
  "coach.voice_waveform_html": "<span class=\"mnl-ai-waveform__label\">Listening…</span>",
  "coach.why_footnote_html": "<p style=\"font-size:11px;color:#64748b;font-style:italic;margin-top:14px;\">All the doses respect the validated scientific maximum thresholds (clinical studies).</p>",
  "coach.why_intro_html": "<p style=\"font-size:13px;color:#475569;\">Calibrated from YOUR answers: <strong>",
  "coach.why_sport_html": "</strong> · sport <strong>",
  "coach.why_title_html": "<h3>Why this formula for you</h3>",
  "config.actives_suffix": " actives",
  "config.aria.act_level_html": "\" aria-label=\"Level ",
  "config.aria.act_more_label_html": "\" aria-label=\"Find out more about ",
  "config.aria.act_more_title_html": "\" role=\"button\" tabindex=\"0\" title=\"Find out more about ",
  "config.aria.dose_from": ", from ",
  "config.aria.dose_in": " in ",
  "config.aria.dose_of_html": "\" aria-label=\"Dose of ",
  "config.aria.dose_to": " to ",
  "config.aria.flavor_group": "Flavor choice",
  "config.aria.format_group": "Size choice",
  "config.aria.pillar_more_html": "\" type=\"button\" aria-label=\"Find out more about ",
  "config.aria.pillar_more_small_html": "\" aria-label=\"Find out more\">i</button></div>",
  "config.aria.toggle_ing_html": "\" aria-label=\"Switch on or off ",
  "config.atc.add_to_cart": "ADD TO CART",
  "config.atc.abo_demande": "REQUEST THIS CHANGE",
  "config.atc.abo_ok_title": "Request sent",
  "config.atc.abo_ok_sub": "We'll apply your new formula within 24 hours. You'll get an email.",
  "config.atc.abo_ko_title": "Request not sent",
  "config.atc.abo_ko_sub": "Try again in a moment.",
  "config.atc.need_name": "PICK A NAME TO ADD TO CART",
  "config.atc.sticky_need_name": "NAME YOUR FORMULA",
  "config.atc.sticky_see_formula": "SEE YOUR FORMULA",
  "config.atc_unavailable": "BUILDER UNAVAILABLE",
  "config.block.flavor": "Choose your flavor to carry on",
  "config.block.format": "Choose your size to carry on",
  "config.block.intensity": "Choose an intensity to carry on",
  "config.block.name": "Name your formula to carry on",
  "config.block.sport": "Choose your sport to carry on",
  "config.block.step": "Complete this step to carry on",
  "config.caffeine_notice_high": "⚠ High caffeine content (up to 200 mg per serving): not recommended for children or for pregnant or breast-feeding women. Do not exceed the recommended daily dose.",
  "config.caffeine_notice_none": "✓ Caffeine-free formula — no added stimulant.",
  "config.cancel": "Cancel",
  "config.cap.caffeine": "Cap 200 mg — the ANSES limit per intake.",
  "config.cap.creatine": "Cap 3 g — that is the exact dose of the authorised EFSA claim.",
  "config.cap.default": "Maximum dose of the product range.",
  "config.cap.glycerol": "Cap 3 g per serving — beyond that, the difference you feel is marginal (limit set by MyNutriLab).",
  "config.cap.pinksalt": "Cap 500 mg.",
  "config.cap.piperine": "Cap 2 mg — below the ANSES acceptable daily intake (2,3 mg).",
  "config.cap.taurine": "Cap 1 g per serving — limit set by MyNutriLab (the studies hold from 1 g).",
  "config.cap.theanine": "Cap 200 mg — that is the range of the studies on the caffeine/theanine duo (100-200 mg).",
  "config.chip_flavor_prefix": "Flavor ",
  "config.choose_flavor": "Choose your flavor",
  "config.choose_format": "Choose your size",
  "config.choose_intensity": "Choose your intensity",
  "config.choose_sport": "Choose your sport",
  "config.close": "Close",
  "config.cmp.and_join": " and ",
  "config.cmp.beats_all_html": "<strong>Your formula beats the 3 best-sellers on the market!</strong> You have a formula that is clinically superior to <strong>",
  "config.cmp.beats_all_tail_html": "</strong>, made to order, with no proprietary blend.",
  "config.cmp.beats_none_html": "<strong>You can do better.</strong> Switch to Expert Mode and push the doses up to beat the best-sellers on the market.",
  "config.cmp.beats_some_html": "✓ <strong>Your formula beats ",
  "config.cmp.beats_some_tail_html": "</strong>. Push the sliders in Expert mode to reach the Elite score and beat all 3.",
  "config.cmp.bonus_mid": " € less than the market average for the same size (",
  "config.cmp.bonus_prefix_html": "<br><br><strong>Bonus:</strong> for higher quality, you pay ",
  "config.cmp.bonus_tail": " servings).",
  "config.cmp.my_formula_th_html": "<th class=\"is-mine\">YOUR FORMULA</th>",
  "config.cmp.note_prefix_html": "<br><br><strong>Worth noting:</strong> you pay ",
  "config.cmp.note_tail": " € more than the average, but that is the price of a formula made to order, with no compromise on quality.",
  "config.cmp.price_per_dose_td_html": "<td class=\"is-name\">PRICE / SERVING</td>",
  "config.cmp.score_td_html": "<td class=\"is-name\">FORMULA SCORE</td>",
  "config.compare.intro_html": "<p style=\"margin:0 0 18px;font-size:13px;color:#64748b;\">Current (builder) vs last saved (<strong>",
  "config.compare.legend_html": "<p style=\"margin:18px 0 0;font-size:11px;color:#94a3b8;text-align:center;font-style:italic;\">↑ = dose increased · ↓ = dose reduced · = = unchanged</p>",
  "config.compare.modal_aria": "Formula comparison",
  "config.compare.saved_default_prefix": "Formula ",
  "config.compare.thead_html": "<thead><tr style=\"border-bottom:2px solid #e2e8f0;\"><th style=\"text-align:left;padding:8px 4px;font-size:11px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;\">Active</th><th style=\"text-align:right;padding:8px 4px;font-size:11px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;\">Before</th><th style=\"text-align:right;padding:8px 4px;font-size:11px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;\">Now</th><th style=\"text-align:right;padding:8px 4px;font-size:11px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#94a3b8;\">Δ</th></tr></thead>",
  "config.compare.title_html": "<h3 style=\"margin:0 0 4px;font-size:20px;font-weight:900;color:#0f172a;\">Formula comparison</h3>",
  "config.complete_this_step": "Complete this step",
  "config.configure_formula": "Configure your formula",
  "config.confirm.apply_preset": "Apply the preset",
  "config.confirm.keep_my_doses": "Keep my doses",
  "config.confirm.load_formula": "Load the formula",
  "config.confirm.overwrite_community_msg": "You have already adjusted some doses. Loading this community formula will overwrite them.",
  "config.confirm.overwrite_preset_prefix": "You have already adjusted doses by hand. Applying the preset \"",
  "config.confirm.overwrite_preset_suffix": "\" will overwrite them.",
  "config.confirm.overwrite_title": "Overwrite your adjustments?",
  "config.count_active_plural": "s",
  "config.count_active_word": " active",
  "config.crea_note_off_js_html": "Switch it on to <strong>add it to your formula</strong> — the dose follows the Strength pillar (up to 3 g). Leave it off if you already take it separately.",
  "config.crea_note_on_js_html": "Creatine <strong>added to your formula</strong> — adjust the dose with the Strength pillar (up to 3 g, the dose of the European claim).",
  "config.deadline_tomorrow": "tomorrow",
  "config.doses_duration_suffix": " days (1 serving a day)",
  "config.doses_saving_suffix": " % / serving vs 15 servings",
  "config.doses_suffix": " servings",
  "config.efficacy.low": "● Low dose",
  "config.efficacy.max": "● Max dose",
  "config.efficacy.off": "○ Switched off",
  "config.efficacy.ok": "● Effective dose",
  "config.efficacy_ok_html": "\">● Effective dose</span>",
  "config.elite_overlay_sub": "Your 11 actives are calibrated to the nearest mg.",
  "config.elite_overlay_title": "Elite Formula",
  "config.express.actives_line_html": " actives · calibrated from your answers</div>",
  "config.express.atc_html": "<button type=\"button\" data-xp-atc style=\"margin-left:auto;background:#E8480F;color:#fff;border:0;border-radius:10px;padding:15px 22px;font-family:inherit;font-size:15.5px;font-weight:800;cursor:pointer;\">Add to cart</button></div>",
  "config.express.close_html": "<button type=\"button\" data-xp-close style=\"margin-left:auto;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#5B5E66;padding:2px 4px;\" aria-label=\"Close\">×</button></div>",
  "config.express.configurator_link_html": "<div style=\"text-align:center;margin-top:11px;\"><a href=\"#\" data-xp-config style=\"font-size:13px;color:#5B5E66;text-decoration:underline;text-underline-offset:3px;\">I want to adjust my doses (full builder)</a></div>",
  "config.express.dose_count_html": "<div style=\"margin-top:15px;\"><div style=\"display:flex;justify-content:space-between;align-items:baseline;\"><span style=\"font-size:13px;font-weight:800;color:#0F1013;\">Number of servings</span><b data-xp-count style=\"font-family:\\u0027IBM Plex Mono\\u0027,monospace;font-size:14px;\">",
  "config.express.dose_count_suffix_html": " servings</b></div>",
  "config.express.flavor_block_html": "<div style=\"margin-top:15px;\"><div style=\"font-size:13px;font-weight:800;color:#0F1013;margin-bottom:8px;\">Your flavor <span data-xp-flaverr style=\"color:#C2410C;font-weight:700;display:none;\">— pick one!</span></div>",
  "config.express.made_for_you_html": "<text x=\"75\" y=\"116\" text-anchor=\"middle\" font-family=\"Archivo, sans-serif\" font-size=\"6\" fill=\"#43464E\">Made for you</text>",
  "config.express.name_block_html": "<div style=\"margin-top:13px;\"><label style=\"font-size:13px;font-weight:800;color:#0F1013;display:block;margin-bottom:6px;\" for=\"mnl-xp-nom\">Name your tub <span data-xp-nomerr style=\"color:#C2410C;font-weight:700;display:none;\">— give it a name!</span></label>",
  "config.express.name_input_html": "<input id=\"mnl-xp-nom\" type=\"text\" maxlength=\"40\" value=\"\" placeholder=\"E.g. The Rocket, Momo, Machine\\u2026\" style=\"width:100%;box-sizing:border-box;padding:11px 13px;border:1.5px solid #E5E5DF;border-radius:10px;font-family:inherit;font-size:14px;font-weight:600;color:#0F1013;\"></div>",
  "config.express.nocaf_html": "<div style=\"font-size:12px;color:#16A34A;font-weight:700;margin-top:4px;\">✓ Caffeine-free</div>",
  "config.express.pot_doses_html": " servings</text>",
  "config.express.pot_name_html": "<text id=\"mnl-xp-potnom\" x=\"75\" y=\"105\" text-anchor=\"middle\" font-family=\"Anton, Impact, sans-serif\" font-size=\"11\" fill=\"#E8480F\">YOUR FORMULA</text>",
  "config.express.ready_html": "<span style=\"font-family:\\u0027IBM Plex Mono\\u0027,monospace;font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:#8B8E96;\">Your formula is ready</span>",
  "config.express.slider_html": "\" style=\"width:100%;accent-color:#E8480F;height:32px;cursor:pointer;\" aria-label=\"Number of servings, 15 to 60\"></div>",
  "config.flav_recommended": "Recommended",
  "config.flavdesc_bleue": "The iconic blue taste, intense and tangy.",
  "config.flavdesc_citron": "A fresh, tangy taste, sharp on the palate.",
  "config.flavdesc_cola": "The iconic taste that brings the classics right back.",
  "config.flavdesc_framboise": "Intense and lightly tangy, for the sweet-toothed.",
  "config.flavdesc_fruitrouge": "Sweet and fruity, a timeless classic.",
  "config.flavdesc_icetea": "The freshness of iced tea, as thirst-quenching as it gets.",
  "config.flavdesc_neutre": "No added flavor, mix it however you like.",
  "config.flavdesc_pasteque": "Soft and juicy, perfect for the summer.",
  "config.fmt_label.d20": "20 servings",
  "config.fmt_label.d25": "25 servings",
  "config.fmt_label.d35": "35 servings",
  "config.fmt_label.d40": "40 servings",
  "config.fmt_label.d45": "45 servings",
  "config.fmt_label.d50": "50 servings",
  "config.fmt_label.d55": "55 servings",
  "config.fmt_label.pro": "Pro (60 servings)",
  "config.fmt_label.standard": "Standard (30 servings)",
  "config.fmt_label.starter": "Starter (15 servings)",
  "config.fmt_short.d20": "20 servings",
  "config.fmt_short.d25": "25 servings",
  "config.fmt_short.d35": "35 servings",
  "config.fmt_short.d40": "40 servings",
  "config.fmt_short.d45": "45 servings",
  "config.fmt_short.d50": "50 servings",
  "config.fmt_short.d55": "55 servings",
  "config.fmt_short.pro": "60 servings",
  "config.fmt_short.standard": "30 servings",
  "config.fmt_short.starter": "15 servings",
  "config.footer_recap_label_html": "<span class=\"mnl-fr__lbl\">Your formula</span>",
  "config.ing.betaalanine.fullname": "Beta-Alanine",
  "config.ing.betaalanine.fx": "Precursor of carnosine",
  "config.ing.betaalanine.halflife": "25 min (but the effect builds over 4 weeks)",
  "config.ing.betaalanine.mechanism": "Precursor of muscle carnosine. Carnosine buffers lactic acid during intense effort, delaying acidosis and fatigue. Cumulative effect: it takes 2-4 weeks of daily use to saturate the muscles.",
  "config.ing.betaalanine.study_result": "Beta-Alanine 4-6g a day for 4 weeks: improved performance on 1-4 minute efforts through muscle saturation with carnosine (pH buffer) — meta-analysis of 40 studies (Saunders 2017, BJSM). Tingling (paraesthesia) is normal and harmless.",
  "config.ing.betaalanine.study_title": "Meta-analysis of 40 studies (Saunders et al., 2017)",
  "config.ing.betaalanine.timing": "Before exercise (cumulative effect over 2-4 weeks)",
  "config.ing.caffeine.fullname": "Anhydrous Caffeine USP",
  "config.ing.caffeine.fx": "The most studied stimulant · adenosine antagonist",
  "config.ing.caffeine.halflife": "5-6 hours",
  "config.ing.caffeine.maxdose": "200mg (ANSES cap)",
  "config.ing.caffeine.mechanism": "Antagonist of the A1 and A2A adenosine receptors. Blocks the fatigue signal, increases the release of dopamine and noradrenaline. Improves muscle contraction by increasing calcium mobilisation.",
  "config.ing.caffeine.study_result": "Caffeine 3-6mg/kg: dose-dependent effect observed on strength, power and muscular endurance (meta-analysis of 21 studies, Grgic 2020). No health claim is authorised for caffeine in the EU — here: the exact dose, the ANSES cap of 200mg per serving, the studies cited. Nothing else.",
  "config.ing.caffeine.study_title": "Meta-analysis of 21 studies (Grgic et al., 2020)",
  "config.ing.caffeine.timing": "20-45 min before exercise",
  "config.ing.citrulline.fullname": "Pure L-Citrulline",
  "config.ing.citrulline.fx": "Precursor of arginine",
  "config.ing.citrulline.halflife": "0.7-1 hour",
  "config.ing.citrulline.mechanism": "Converted into arginine in the kidneys, which then produces nitric oxide (NO). NO dilates the blood vessels, increasing blood flow to the muscle — that is the pump. More effective than arginine taken directly, because it bypasses hepatic degradation.",
  "config.ing.citrulline.study_result": "Citrulline 8 g: support for performance on repeated sets to failure and for perceived muscle recovery after exercise (meta-analysis of 12 studies, Trexler 2019, EJSS). Pump effect from 4g through nitric oxide vasodilation.",
  "config.ing.citrulline.study_title": "Meta-analysis of 12 studies (Trexler et al., 2019)",
  "config.ing.citrulline.timing": "30-60 min before exercise",
  "config.ing.creatine.fullname": "Creatine Monohydrate",
  "config.ing.creatine.fx": "Max strength · Power · ATP regeneration",
  "config.ing.creatine.halflife": "Muscle storage",
  "config.ing.creatine.maxdose": "3g (EFSA claim Reg 432/2012)",
  "config.ing.creatine.mechanism": "Creatine monohydrate. Regenerates ATP from ADP via creatine kinase, supplying the immediate energy for explosive efforts (1-10 sec). Increases the muscle store of phosphocreatine, improving maximum power and cell volume (intracellular water retention).",
  "config.ing.creatine.study_result": "Creatine increases physical performance in successive bursts of short-term, high intensity exercise (EFSA claim authorised from 3g a day).",
  "config.ing.creatine.study_source": "EFSA Journal — Regulation (EU) 432/2012",
  "config.ing.creatine.study_title": "Authorised EFSA claim Reg 432/2012",
  "config.ing.creatine.timing": "Before or after exercise",
  "config.ing.electrolytes.fullname": "Electrolyte complex",
  "config.ing.electrolytes.fx": "Sodium · Potassium · Magnesium",
  "config.ing.electrolytes.halflife": "Variable",
  "config.ing.electrolytes.label": "Electrolyte complex",
  "config.ing.electrolytes.mechanism": "A blend of potassium (cells), magnesium (muscle and nerve) and sodium (extracellular). Maintains water and electrolyte balance, nerve conduction and muscle contraction. Crucial on long efforts or in the heat.",
  "config.ing.electrolytes.study_result": "Potassium and magnesium contribute to normal muscle function; sodium contributes to water and electrolyte balance during prolonged effort (authorised EFSA claims, Reg 432/2012). Intake recommended on efforts > 60 min or in the heat.",
  "config.ing.electrolytes.study_title": "IOC Consensus Statement recommendations",
  "config.ing.electrolytes.timing": "Before and during exercise",
  "config.ing.glycerol.fx": "GlycoPump® · glycerol 65 %",
  "config.ing.glycerol.halflife": "30-45 min",
  "config.ing.glycerol.mechanism": "Glycerol attracts and holds water in the cell compartments (hyperhydration). Osmotic effect: it increases plasma volume and intramuscular water retention.",
  "config.ing.glycerol.study_result": "Glycerol + 500ml of water before exercise: support for blood volume and for performance in a hot environment through cellular hyperhydration (Patlar 2012 study).",
  "config.ing.glycerol.study_title": "Study (Patlar et al., 2012)",
  "config.ing.glycerol.timing": "30-60 min before exercise, with 500ml of water",
  "config.ing.pinksalt.fullname": "Himalayan Pink Salt",
  "config.ing.pinksalt.fx": "Sodium and trace minerals",
  "config.ing.pinksalt.halflife": "Variable (depending on hydration)",
  "config.ing.pinksalt.mechanism": "A source of pure unrefined sodium, containing 84 trace minerals (potassium, magnesium, iron). Sodium maintains extracellular osmotic balance and amplifies the volumetric pump effect. Crucial for nerve conduction.",
  "config.ing.pinksalt.study_result": "Sodium before exercise (300-600mg): support for endurance performance and prevention of exercise-associated hyponatraemia (ACSM Position Stand 2007). Authorised EFSA claim: « sodium contributes to water and electrolyte balance » (≥1g). Synergistic effect with glycerol for hyperhydration.",
  "config.ing.pinksalt.study_title": "ACSM Position Stand recommendations",
  "config.ing.pinksalt.timing": "Before exercise",
  "config.ing.piperine.fullname": "Piperine",
  "config.ing.piperine.fx": "Black pepper extract",
  "config.ing.piperine.halflife": "Variable",
  "config.ing.piperine.mechanism": "Patented black pepper extract (95% standardised piperine). Inhibits intestinal and hepatic enzymes (CYP3A4, glucuronidation). Improves the bioavailability of fat-soluble actives.",
  "config.ing.piperine.study_result": "Piperine supports the bioavailability of fat-soluble actives (Badmaev 1999; the bioavailability reference Shoba 1998 is SPECIFICALLY on curcumin — the effect on other actives varies with the composition). Dose capped at 2 mg a day at MyNutriLab — strictly below the ANSES ADI of 2,3 mg.",
  "config.ing.piperine.study_title": "Badmaev et al. study (1999)",
  "config.ing.piperine.timing": "With the other actives",
  "config.ing.taurine.fullname": "Taurine USP",
  "config.ing.taurine.fx": "Sulphur amino acid",
  "config.ing.taurine.halflife": "1 hour",
  "config.ing.taurine.mechanism": "A sulphur amino acid abundant in skeletal and cardiac muscle. Regulates osmotic balance, intracellular calcium and antioxidation. Improves muscle contraction and reduces oxidative stress after exercise.",
  "config.ing.taurine.study_result": "Taurine 1-3g before exercise: support for endurance performance (TTE) and for perceived muscle recovery after exercise (meta-analysis of 19 studies, Waldron 2018). Dose capped at 1 g per serving at MyNutriLab.",
  "config.ing.taurine.study_title": "Meta-analysis of 19 studies (Waldron et al., 2018)",
  "config.ing.taurine.timing": "60-120 min before exercise",
  "config.ing.theanine.fullname": "L-Theanine",
  "config.ing.theanine.fx": "Green tea amino acid",
  "config.ing.theanine.halflife": "0.8-1.2 hours",
  "config.ing.theanine.mechanism": "Amino acid naturally present in green tea. Often paired with caffeine in pre-workout formulas (up to 1:1).",
  "config.ing.theanine.study_result": "L-Theanine 200mg + Caffeine 160mg: support for attentional accuracy and a reduction in perceived mental fatigue vs caffeine alone (Kahathuduwa 2017 study).",
  "config.ing.theanine.study_title": "Double-blind study (Kahathuduwa et al., 2017)",
  "config.ing.theanine.timing": "With the caffeine",
  "config.ing.tyrosine.fullname": "L-Tyrosine USP",
  "config.ing.tyrosine.fx": "Aromatic amino acid",
  "config.ing.tyrosine.halflife": "2 hours",
  "config.ing.tyrosine.mechanism": "Direct precursor of dopamine, noradrenaline and adrenaline. Under stress (intense effort, fatigue, short sleep), the catecholamine reserves run down — tyrosine keeps their synthesis going.",
  "config.ing.tyrosine.study_result": "In the Mahoney 2007 study, a 2 g intake maintains cognitive performance (working memory, alertness) over 4-6 h under intense physical stress, with a more marked benefit under sleep deprivation. That is the dose of the study protocol, not the dose in your formula: the slider goes up to 1000 mg per serving.",
  "config.ing.tyrosine.study_title": "Study on soldiers under fatigue (Mahoney et al., 2007)",
  "config.ing.tyrosine.timing": "30-60 min before exercise",
  "config.label_preview_default": "PRE-WORKOUT",
  "config.link_error_link": "The link looks truncated or too old.",
  "config.link_error_qr": "The QR looks damaged or incomplete.",
  "config.link_error_tail": " The builder opens blank — build your formula again or ask the AI Coach.",
  "config.link_error_title": "This formula link could not be read",
  "config.missing.flavor": "your flavor",
  "config.missing.format": "your size",
  "config.missing.intensity": "your intensity",
  "config.missing.name": "the name of your formula",
  "config.missing.objectives": "your goals",
  "config.modal.effective_dose_html": "<div class=\"mnl-modal__row\"><div class=\"mnl-modal__row-lbl\">Effective dose</div><div class=\"mnl-modal__row-val\"><strong>",
  "config.modal.halflife_html": "<div class=\"mnl-modal__row\"><div class=\"mnl-modal__row-lbl\">Half-life</div><div class=\"mnl-modal__row-val\">",
  "config.modal.mechanism_html": "<div class=\"mnl-modal__row\"><div class=\"mnl-modal__row-lbl\">Mechanism</div><div class=\"mnl-modal__row-val\">",
  "config.modal.min_up_to_html": "</strong> minimum, up to <strong>",
  "config.modal.study_html": "<div class=\"mnl-modal__study\"><div class=\"mnl-modal__study-tag\">// KEY STUDY — ",
  "config.modal.when_html": "<div class=\"mnl-modal__row\"><div class=\"mnl-modal__row-lbl\">When to take it</div><div class=\"mnl-modal__row-val\">",
  "config.name_preview_default": "Name of your formula",
  "config.name_your_formula": "Name your formula",
  "config.nav_atc": "Add to cart →",
  "config.nav_continue": "Continue →",
  "config.nav_name": "Name your formula →",
  "config.navsub_check": "Check my formula",
  "config.navsub_flavor": "Choose my flavor",
  "config.navsub_format": "Choose my size",
  "config.navsub_name": "Name my formula",
  "config.navsub_printed": "Printed on your label",
  "config.navsub_ready": "Your formula is ready",
  "config.night_mode_note": "Evening mode: 0 mg of caffeine. Focus still comes from L-theanine and L-tyrosine, with no stimulant.",
  "config.no_caffeine": "Caffeine-free",
  "config.nocaf_note_html": "Energy and focus delivered by <strong>L-Theanine</strong> and <strong>L-Tyrosine</strong>. No stimulants.",
  "config.nocaf_note_on_html": "Formula with <strong>0 mg of caffeine</strong> per serving · focus through L-Theanine &amp; L-Tyrosine.",
  "config.obj_expand_html": "Set each active <span class=\"mnl-obj__expand-caret\" aria-hidden=\"true\">▾</span>",
  "config.obj_expand_label": "Set each active ",
  "config.obj_hide_detail": "Hide the detail ",
  "config.obj_palier.high": "High",
  "config.obj_palier.light": "Light",
  "config.obj_palier.max": "Max",
  "config.obj_palier.moderate": "Moderate",
  "config.obj_palier.none": "None",
  "config.obj_palier.very_light": "Very light",
  "config.per_dose_compact": "€ / serving",
  "config.per_dose_price_suffix": " € / serving",
  "config.per_dose_suffix": " / serving",
  "config.persona.bodybuilder_html": "<strong>Weight training:</strong> Max pump and pure strength. Citrulline 8g + Glycerol + Pink salt for the pump (Pérez-Guisado 2010), Beta-Alanine 4g for 60-90s sets (Saunders 2017), Creatine Monohydrate 3g for the 1RM (EFSA claim on explosive performance).",
  "config.persona.crossfit_html": "<strong>CrossFit:</strong> Explosiveness + lactic endurance. Caffeine 200mg, Beta-Alanine 4g for 1-4 min WODs (sweet spot Saunders 2017 +2.85% capacity), Citrulline 8g for the pump, Creatine Monohydrate 3g for short repeated efforts (EFSA claim), Electrolytes 600mg for the heat.",
  "config.persona.cyclist_html": "<strong>Cycling:</strong> Long rides, pump and endurance. Glycerol 3g for hyperhydration, Citrulline 6-8g for the pump in the legs (Pérez-Guisado), Electrolytes 1000mg against cramp, Caffeine 150mg for the climbs, Creatine 3g for uphill sprints (EFSA claim).",
  "config.persona.fighter_html": "<strong>Combat:</strong> Reflexes, focus, lactic resistance. Tyrosine 1g (mental under stress), Caffeine 200mg + Theanine 200mg (1:1 ratio — Owen 2008), Beta-Alanine 4g for repeated 3-min rounds (Saunders sweet spot), Creatine Monohydrate 3g for punching power (EFSA claim on explosiveness).",
  "config.persona.other_html": "<strong>Another sport:</strong> A formula balanced across every pillar. Mental + Pump + Stamina + Optim + Creatine Monohydrate 3g (the EFSA claim dose, Reg 432/2012) at the right dosage for your intensity.",
  "config.persona.runner_html": "<strong>Running:</strong> Pure endurance and lactic threshold. Beta-Alanine 4g (anti-lactate through carnosine, Saunders 2017), moderate Caffeine 100-150mg, Electrolytes 1000mg + Pink salt for the sweat, Taurine 1g for recovery. Creatine 3g (intermediate sprints).",
  "config.pillar.mental.actif1": "Anhydrous Caffeine USP",
  "config.pillar.mental.actif2": "L-Theanine",
  "config.pillar.mental.actif3": "L-Tyrosine USP",
  "config.pillar.mental.ref_name": "Kahathuduwa 2017 study",
  "config.pillar.mental.ref_quote": "Caffeine 160mg + theanine 200mg combination: cognitive performance and alertness improved vs caffeine alone (Kahathuduwa 2017; Grgic 2020 meta-analysis).",
  "config.pillar.mental.ref_sport": "Nutritional Neuroscience",
  "config.pillar.mental.science": "A combination validated by meta-analyses for increasing cognitive and physical performance under intense effort (Grgic 2020, Kahathuduwa 2017).",
  "config.pillar.mental.sub": "Energy · Focus",
  "config.pillar.mental.tagline": "The cognitive pillar",
  "config.pillar.mental.what": "Mental Drive brings together the actives that work on the central nervous system: subjective energy, alertness, focus, motivation and resistance to mental fatigue.",
  "config.pillar.mental.why": "Without the mental side, there is no productive session. It is the first pillar you feel — the one that decides whether you push a PR or simply \\\"get the session done\\\".",
  "config.pillar.optim.actif1": "Electrolyte complex",
  "config.pillar.optim.actif2": "Piperine",
  "config.pillar.optim.ref_name": "Maughan 2007 study",
  "config.pillar.optim.ref_quote": "Saline solution (sodium + potassium) on efforts > 90 min: prevention of the incidence of muscle cramp vs pure water (study in heat of 30°C+).",
  "config.pillar.optim.ref_sport": "American J. of Physiology",
  "config.pillar.optim.science": "Piperine 0,5-2mg: support for the bioavailability of fat-soluble actives (Badmaev 1999). Electrolytes: support for performance and prevention of cramp on long efforts (IOC Consensus 2018).",
  "config.pillar.optim.sub": "Absorption · Hydration",
  "config.pillar.optim.tagline": "The multiplier pillar",
  "config.pillar.optim.what": "Optimization brings together the actives that multiply the effectiveness of ALL the others: better intestinal absorption, electrolyte balance, smooth nerve conduction.",
  "config.pillar.optim.why": "Without this pillar, 30% of the other actives go to waste. It is the invisible investment that turns a good formula into a clinically optimal one.",
  "config.pillar.pump.actif1": "Pure L-Citrulline",
  "config.pillar.pump.actif2": "Glycerol",
  "config.pillar.pump.actif3": "Himalayan Pink Salt",
  "config.pillar.pump.ref_name": "Trexler 2019 study",
  "config.pillar.pump.ref_quote": "Meta-analysis of 12 studies: citrulline 8 g before exercise supports performance on repeated sets to failure in compound exercises.",
  "config.pillar.pump.ref_sport": "European J. of Sport Science",
  "config.pillar.pump.science": "Citrulline 8g: support for repeated sets to failure (Trexler 2019, EJSS). Glycerol + 500ml of water: support for blood volume (Patlar 2012).",
  "config.pillar.pump.sub": "Congestion · Blood flow",
  "config.pillar.pump.tagline": "The vascular pillar",
  "config.pillar.pump.what": "Muscle Pump brings together the actives that dilate the blood vessels, increase plasma volume and hydrate the muscle cells for a pump that is hard, lasting and visible.",
  "config.pillar.pump.why": "A strong pump = more nutrients delivered to the fibres, better between-set recovery, and optimal anabolic signalling. Bonus: it is what makes you feel huge in the mirror.",
  "config.pillar.stamina.actif1": "Beta-Alanine",
  "config.pillar.stamina.actif2": "Taurine USP",
  "config.pillar.stamina.actif3": "Creatine Monohydrate",
  "config.pillar.stamina.ref_name": "Saunders 2017 study",
  "config.pillar.stamina.ref_quote": "Beta-Alanine 4-6g a day × 4 weeks: performance +2,85% on 1-4 min efforts (intense muscular efforts such as boxing rounds / WODs).",
  "config.pillar.stamina.ref_sport": "British J. of Sports Medicine",
  "config.pillar.stamina.science": "Beta-A 4-6g/day x4wks: +2.85% perf on 1-4min efforts (Saunders 2017). Creatine Monohydrate 3g/day: EFSA claim authorised for successive bursts of short-term, high intensity exercise.",
  "config.pillar.stamina.sub": "Strength · Muscular endurance",
  "config.pillar.stamina.tagline": "The physical pillar",
  "config.pillar.stamina.what": "Power & Stamina brings together the actives that push back muscle acidosis, increase force production and the ability to string long sets together without fading.",
  "config.pillar.stamina.why": "It is the pillar that makes the difference between 8 easy reps and 12 reps to failure. Or between holding 6 rounds of sparring and folding in the 4th.",
  "config.pillar_endurance": "Endurance",
  "config.pillar_energie": "Energy",
  "config.pillar_focus": "Focus",
  "config.pillar_force": "Strength",
  "config.pillar_modal.actifs_prefix_html": "<p class=\"mnl-pillar-section__lbl\">The ",
  "config.pillar_modal.actifs_suffix_html": " actives of this pillar</p>",
  "config.pillar_modal.reference_html": "<p class=\"mnl-pillar-section__lbl\">Scientific reference</p>",
  "config.pillar_modal.science_html": "<p class=\"mnl-pillar-section__lbl\">Scientific validation</p>",
  "config.pillar_modal.what_html": "<p class=\"mnl-pillar-section__lbl\">What it is</p>",
  "config.pillar_modal.why_html": "<p class=\"mnl-pillar-section__lbl\">Why it matters</p>",
  "config.pillar_num_html": "<span class=\"mnl-ing-section__num\">Pillar ",
  "config.pillar_pump": "Pump",
  "config.pillar_understand_html": "\">ⓘ Understand this pillar</button>",
  "config.pot_default_name": "YOUR FORMULA",
  "config.powder_per_dose_suffix": " g of powder / serving",
  "config.preset.beginner": "Beginner safe",
  "config.preset.bodybuilding": "Bodybuilding formula · pump + size",
  "config.preset.boxe": "Boxing / MMA formula · 12 rounds",
  "config.preset.crossfit": "CrossFit formula · long efforts",
  "config.preset.cyclisme": "Cycling formula · long ride",
  "config.preset.endurance": "Pure endurance",
  "config.preset.focus": "Laser focus",
  "config.preset.force": "Max strength",
  "config.preset.hyrox": "HYROX formula · 8 stations + run",
  "config.preset.marathon": "Marathon formula · lactic threshold",
  "config.preset.night": "No stim (evening)",
  "config.preset.powerlifting": "Powerlifting formula · max strength",
  "config.preset.pump": "Max pump",
  "config.preset.sportco": "Team sport formula · 90min match",
  "config.price_from_prefix": "from ",
  "config.price_mode_once": "One-time purchase",
  "config.price_mode_subscription": "Subscription −10%",
  "config.price_sub_starter": "From the Starter size · choose your size",
  "config.price_sub_starter_prefix": "From",
  "config.promo_once_html": "Price with the code <strong>MNL10</strong> — 1<sup>st</sup> order, applied automatically at checkout.",
  "config.promo_sub_html": "Subscription: <strong>−10 %</strong> on every delivery, <strong>plus −10 €</strong> with the code <strong>MNL10</strong> on the 1<sup>st</sup> delivery (applied automatically at checkout). The following deliveries keep the −10 %.",
  "config.promo_sub_only_html": "Subscription: <strong>−10 %</strong> on every delivery.",
  "config.qrf.cta_identical": "Order exactly the same again",
  "config.qrf.cta_today": "Order again at the current step",
  "config.qrf.empty": "Empty formula — personalise it in the builder.",
  "config.qrf.kicker_prefix": "Formula scanned from your tub · ",
  "config.qrf.kicker_suffix": " to the nearest mg",
  "config.qrf.note_changed_prefix": "The dose grid has moved on since this tub: ",
  "config.qrf.note_changed_tail": " at the step you paid for (the original struck through, the current dose in bold). The price follows the step, not the milligrams.",
  "config.qrf.note_identical": "Exactly your original recipe — every active named and dosed, just like on the label.",
  "config.recipe.caffeine_adjusted_prefix": "Caffeine adjusted to ",
  "config.recipe.caffeine_adjusted_suffix": " mg (from your answers). ",
  "config.recipe.loaded_prefix_html": "<svg viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 6 9 17l-5-5\"/></svg><div class=\"mnl-recipe-loaded__txt\"><strong>Recipe « ",
  "config.recipe.loaded_suffix_html": " » loaded</strong><span>You can change it, then choose your size and your flavor.</span></div>",
  "config.recipe.locked_prefix_html": "<svg viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\"/><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"/></svg><div class=\"mnl-recipe-lock__txt\"><strong>Recipe « ",
  "config.recipe.locked_suffix_html": " » locked</strong><span>Pre-calibrated formula. You choose the size and the flavor.</span></div>",
  "config.resume_default_name": "your formula",
  "config.resume_hour_suffix": "h",
  "config.resume_min_suffix": " min",
  "config.resume_seconds": "a few seconds",
  "config.resume_toast_fallback_name": "saved",
  "config.resume_toast_prefix": "Formula \"",
  "config.resume_toast_suffix": "\" picked up again!",
  "config.savings_vs_market": " € vs the market",
  "config.shaker_message": "Your formula is off to the lab…",
  "config.share.text": "My made-to-measure formula, created on mynutrilab.com",
  "config.share.title": "My MyNutriLab formula",
  "config.share_already_sub": "Thanks for adding to the community!",
  "config.share_already_title": "Already shared",
  "config.share_done": "✓ Shared with the community",
  "config.share_fail_net": "Check your connection",
  "config.share_fail_retry": "Try again in a moment",
  "config.share_fail_title": "Sharing failed",
  "config.share_incomplete_sub": "Set at least 2 actives before sharing",
  "config.share_incomplete_title": "Formula incomplete",
  "config.share_ok_sub": "It appears in the “Shared” tab",
  "config.share_ok_title": "Formula shared!",
  "config.share_progress": "Sharing…",
  "config.share_prompt_hint": "E.g. “Full body pump”, “Light cardio without caffeine”. 40 characters maximum.",
  "config.share_prompt_msg": "It will appear publicly in the “Shared” tab, visible to every visitor. Only the name and the doses are published.",
  "config.share_prompt_native": "Name of the formula you want to share?",
  "config.share_prompt_placeholder": "My morning bomb",
  "config.share_prompt_required": "Give your formula a name so the community can recognise it.",
  "config.share_prompt_title": "Share your formula",
  "config.share_word": "Share",
  "config.side_default_tag": "Personalised pre-workout",
  "config.socle_missing_msg": "The builder is temporarily unavailable: a component could not be loaded. Reload the page — if the problem carries on, write to us and we will put your formula together by hand.",
  "config.sport_tag.bodybuilder": "Strength • Size • Pump",
  "config.sport_tag.crossfit": "WOD • High intensity",
  "config.sport_tag.cyclist": "Endurance • Recovery",
  "config.sport_tag.fighter": "Power • Explosiveness",
  "config.sport_tag.football": "Performance • Explosiveness",
  "config.sport_tag.hyrox": "Hybrid endurance",
  "config.sport_tag.hyrox_focus": "Hybrid endurance • Focus",
  "config.sport_tag.padel": "Speed • Reflexes",
  "config.sport_tag.runner": "Endurance • Cardio",
  "config.story.actives_title": "MY ACTIVES · MY OWN DOSES",
  "config.story.configure_on": "Configure your formula at",
  "config.story.format": "SIZE",
  "config.story.intensity": "INTENSITY",
  "config.story.line1": "YOUR FORMULA.",
  "config.story.line2": "YOUR ENERGY.",
  "config.story.line3": "YOUR RULES.",
  "config.story.made_in_fr": "FRENCH BRAND",
  "config.story.sport": "SPORT",
  "config.story.tag": "MY MADE-TO-MEASURE FORMULA",
  "config.summary.auto": "✓ Auto",
  "config.summary.choose_sport": "Choose your main sport",
  "config.summary.doses_range": "15 to 60 servings, your choice",
  "config.summary.flavors_available": "5 flavors available",
  "config.summary.manual": "✓ Manual",
  "config.summary.name_close": " »",
  "config.summary.name_open": "✓ « ",
  "config.summary.name_placeholder": "Give it a name — printed on your label",
  "config.summary.no_creatine": " · No creatine",
  "config.summary.no_stim": " · No stim",
  "config.summary.objectives": "Adjust each goal to what you need. We handle the dosing.",
  "config.summary.set_goals": "Set your 4 goals",
  "config.summary_empty_html": "<p class=\"mnl-summary-empty\">Set your <strong>4 goals</strong> above — the detail of your formula appears live in « Your formula ».</p>",
  "config.tier.balanced": "A very good balanced formula",
  "config.tier.basic": "Basic profile — can be optimised",
  "config.tier.coherent": "A coherent, effective formula",
  "config.tier.intensive": "Intensive setup · maximum doses",
  "config.tier.maximal": "Maximum setup",
  "config.tier.todo": "Still to complete",
  "config.tier.very_effective": "A clinically very effective formula",
  "config.tier.weak": "Not enough effective doses",
  "config.tier_correct": "Fair",
  "config.tier_excellent": "Excellent",
  "config.tier_good": "Good",
  "config.tier_verygood": "Very good",
  "config.timer.betaalanine_note": " · cumulative effect over 4 weeks (beta-alanine)",
  "config.timer.duration_nocaf": "2-3h (calm focus, no spike)",
  "config.timer.html_1": "at <strong>",
  "config.timer.html_2": " min</strong> after taking it · peak at <strong>",
  "config.timer.html_3": " min</strong> · duration ",
  "config.to_complete": "To complete",
  "config.toast.cart_failed_sub": "Try again or go through the contact form: /pages/contact",
  "config.toast.cart_failed_title": "Could not add to cart",
  "config.toast.copy_failed_prefix": "Copy failed — ",
  "config.toast.dose_reset": "Dose reset",
  "config.toast.empty_formula_sub": "Switch on at least 1 active and set its dose to add to cart",
  "config.toast.empty_formula_title": "Empty formula",
  "config.toast.formula_saved": "Formula saved!",
  "config.toast.image_downloaded": "Image downloaded",
  "config.toast.image_downloaded_sub": "Share it on Insta / TikTok / Snap from your gallery.",
  "config.toast.incomplete_sub_prefix": "You are still missing: ",
  "config.toast.incomplete_title": "Complete your formula",
  "config.toast.link_copied": "Link copied",
  "config.toast.need_flavor_sub": "Five flavors to choose from — it changes nothing about the performance of your formula.",
  "config.toast.need_intensity_sub": "Mild, Balanced or Hardcore — that is what calibrates your 11 actives.",
  "config.toast.need_name_sub": "Take a suggestion or type your own — that is what will appear on your formula.",
  "config.toast.need_name_title": "Choose a formula name to carry on",
  "config.toast.network_error_save": "Network error — Check your connection.",
  "config.toast.network_error_sub": "Check your connection and try again.",
  "config.toast.network_error_title": "Network error",
  "config.toast.no_saved_formula": "No saved formula",
  "config.toast.no_saved_formula_sub": "Save one with the AI Coach to compare",
  "config.toast.nothing_to_redo": "Nothing to redo",
  "config.toast.nothing_to_undo": "Nothing to undo",
  "config.toast.redone": "Redone",
  "config.toast.redone_sub": "Later state restored",
  "config.toast.save_error": "Error — Try again or get in touch.",
  "config.toast.subscription_unavailable": "Subscription unavailable",
  "config.toast.subscription_unavailable_sub": "Formula added as a one-time purchase, at the normal price.",
  "config.toast.to_continue": "To move on to the next step.",
  "config.toast.undone": "Undone",
  "config.toast.undone_sub": "Previous state restored",
  "config.toast.variant_missing_sub": "Switch to Standard / Balanced (our recommended size) or go through the contact form: /pages/contact",
  "config.toast.variant_missing_title": "Combination unavailable",
  "config.with_word": "With",
  "config.without_word": "Without",
  "config.wiz_next": "Next →",
  "config.wizard_add_to_cart": "Add to cart →",
  "config.wizard_name_formula": "Name your formula →",
  "config.wizard_next": "Next →",
  "config.your_formula": "Your formula",
  "customer_tpl.common.hide_password": "Hide the password",
  "customer_tpl.common.plural_s": "s",
  "customer_tpl.common.show_password": "Show the password",
  "customer_tpl.order.js_added_ok": "✓ Added to cart",
  "customer_tpl.order.js_added_partial": "✓ Added (formula excluded)",
  "customer_tpl.order.js_adding": "Adding...",
  "customer_tpl.order.js_error": "Error",
  "customer_tpl.order.js_no_items": "No item to reorder",
  "customer_tpl.order.js_refuse_all_t": "We could not read back the doses of this order",
  "customer_tpl.order.js_refuse_partial_t": "Part of your order could not be added",
  "customer_tpl.order.js_reorder_impossible": "Reorder not possible",
  "customer_tpl.order.js_retry_soon": "Try again in a moment",
  "customer_tpl.order.js_see_cart": "View cart",
  "customer_tpl.order.js_sub_ok": "Taking you to the cart...",
  "customer_tpl.order.js_sub_partial": "Your personalised formula could not be read back.",
  "customer_tpl.order.js_timeout": "Timed out (15s). Check your connection and try again.",
  "customer_tpl.order.js_unavailable_s": "The products in this order are no longer available",
  "customer_tpl.order.js_unavailable_t": "Unavailable",
  "customer_tpl.order.js_unreadable_doses": "We could not read back the doses of this order. Reload the page and try again.",
  "customer_tpl.pwd.match_no": "✗ The passwords do not match",
  "customer_tpl.pwd.match_ok": "✓ The passwords match",
  "customer_tpl.pwd.medium": "Medium",
  "customer_tpl.pwd.strength_prefix": "Strength: ",
  "customer_tpl.pwd.strong": "Strong",
  "customer_tpl.pwd.very_strong": "Very strong",
  "customer_tpl.pwd.very_weak": "Very weak",
  "customer_tpl.pwd.weak": "Weak",
  "divers.bb.action_all": "See all the products",
  "divers.bb.action_config": "Configure",
  "divers.bb.added_cta": "✓ Pack added!",
  "divers.bb.added_title": "Pack added!",
  "divers.bb.adding": "Adding...",
  "divers.bb.copied_flash": "✓ Link copied",
  "divers.bb.copied_sub": "Share it wherever you like",
  "divers.bb.copied_title": "Link copied!",
  "divers.bb.cta": "Order the pre-workout on its own",
  "divers.bb.cta_add": "+ Add the pack",
  "divers.bb.err_add": "Add to cart error",
  "divers.bb.err_retry": "Try again",
  "divers.bb.err_title": "Error",
  "divers.bb.prompt_copy_html": "Copy the URL:",
  "divers.bb.prompt_title_html": "Copy the pack URL",
  "divers.bb.share_btn": "Share my pack",
  "divers.bb.share_text_html": "Look at the pack I put together on MyNutriLab",
  "divers.bb.share_title": "My MyNutriLab pack",
  "divers.bb.summary_empty": "No product selected",
  "divers.bb.tier_next_plural": "s",
  "divers.bb.toast_bb_sub": "Configure your products one by one in the meantime.",
  "divers.bb.toast_bb_title": "Bundle Builder being finalised",
  "divers.bb.toast_config_sub": "The pre-workout is calibrated to the nearest mg. The supplements in the bundle are being finalised.",
  "divers.bb.toast_config_title": "Taking you to the builder",
  "divers.fvid.modal_close_aria": "Close",
  "divers.fvid.modal_title": "Product video",
  "divers.preloader.cart": "Getting your cart ready…",
  "divers.preloader.coach": "Your coach is on the way…",
  "divers.preloader.lab": "Getting your lab ready…",
  "divers.quiz.shaker_loading": "The Coach is warming up…",
  "divers.unsub.js_email_invalid": "Invalid email",
  "divers.unsub.js_email_invalid_sub": "Check the format",
  "divers.unsub.js_error_title": "Error",
  "divers.unsub.js_manual_hint": "ℹFor your security, type your email in by hand.",
  "divers.unsub.js_pending": "In progress…",
  "divers.unsub.js_pref_saved": "Preference saved",
  "divers.unsub.js_pref_saved_sub": "1 email a month maximum",
  "divers.unsub.js_reduce_done": "From now on you will get 1 email a month at most. You can change this at any time.",
  "divers.unsub.js_resub_done": "Resubscription confirmed!",
  "divers.unsub.js_resub_done_sub": "Welcome back",
  "divers.unsub.js_resub_msg": "Welcome back! You will get our next email in the coming days.",
  "divers.unsub.js_resub_pending": "Resubscribing…",
  "divers.unsub.js_retry_contact": "Try again or go through the contact form (/pages/contact)",
  "divers.unsub.js_retry_contact_write": "Try again or write to us through the contact form (/pages/contact)",
  "divers.unsub.js_unsub_done": "Unsubscribe confirmed",
  "divers.unsub.js_unsub_done_sub": "Confirmation sent by email",
  "global.a11y_panel_label": "Accessibility preferences",
  "global.a11y_reset_html": "<button type=\"button\" class=\"mnl-a11y-panel__reset\">↻ Reset</button>",
  "global.a11y_row_contrast_html": "<label class=\"mnl-a11y-panel__row mnl-switch\"><span>Increased contrast</span><input type=\"checkbox\" data-mnl-a11y-opt=\"contrast\" ",
  "global.a11y_row_size_html": "<label class=\"mnl-a11y-panel__row mnl-switch\"><span>Larger text</span><input type=\"checkbox\" data-mnl-a11y-opt=\"size\" ",
  "global.a11y_row_underline_html": "<label class=\"mnl-a11y-panel__row mnl-switch\"><span>Underline all links</span><input type=\"checkbox\" data-mnl-a11y-opt=\"underline\" ",
  "global.a11y_sub_html": "<p class=\"mnl-a11y-panel__sub\">Adapt the display to what you need.</p>",
  "global.a11y_title_html": "<h3 class=\"mnl-a11y-panel__title\">♿ Accessibility</h3>",
  "global.a2hs_close_html": "<button type=\"button\" id=\"mnlIosA2hsClose\" aria-label=\"Close\" style=\"background:transparent;border:none;color:rgba(255,255,255,.6);font-size:18px;cursor:pointer;padding:0 4px;line-height:1;\">×</button>",
  "global.a2hs_label": "Install MyNutriLab on your home screen",
  "global.a2hs_step1_html": "<li>Tap <span aria-hidden=\"true\" style=\"display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;background:rgba(249,115,22,.3);border-radius:5px;font-size:13px;vertical-align:middle;\">⎙</span> at the bottom of Safari</li>",
  "global.a2hs_step2_html": "<li>Choose <strong>« Add to Home Screen »</strong></li>",
  "global.a2hs_step3_html": "<li>Tap <strong>Add</strong> at the top right</li>",
  "global.a2hs_sub_html": "<span style=\"font-size:11px;color:rgba(255,255,255,.7);\">Direct access from your home screen</span></div>",
  "global.a2hs_title_html": "<div style=\"flex:1;min-width:0;\"><strong style=\"display:block;font-size:13px;margin-bottom:2px;\">Install MyNutriLab</strong>",
  "global.agegate_legal_prefix_html": "<p class=\"mnl-age-gate__legal\">By carrying on, you confirm that you are at least ",
  "global.agegate_legal_suffix_html": " years old.<br>Caffeine: 200mg max per serving. Not during pregnancy / breast-feeding.</p>",
  "global.agegate_msg_prefix": "Our pre-workouts contain <strong>caffeine</strong> dosed according to the <strong>ANSES</strong> recommendations. They are not suitable for minors under ",
  "global.agegate_no_html": "<button type=\"button\" class=\"mnl-age-gate__btn mnl-age-gate__btn--no\">No, I am too young</button>",
  "global.agegate_title_prefix": "Are you ",
  "global.agegate_title_suffix": " or older?",
  "global.agegate_yes_prefix_html": "<button type=\"button\" class=\"mnl-age-gate__btn mnl-age-gate__btn--yes\">I am ",
  "global.agegate_yes_suffix_html": "+</button>",
  "global.anchor_label": "Direct link to this section",
  "global.anchor_section_prefix": "Section: ",
  "global.anchor_title": "Copy the link to this section",
  "global.announce_cart_updated_prefix": "Cart updated: ",
  "global.announce_default_item": "Item",
  "global.announce_wl_added_suffix": " added to the wishlist",
  "global.announce_wl_removed_suffix": " removed from the wishlist",
  "global.announcement_close_html": "<button type=\"button\" aria-label=\"Close the announcement\" data-mnl-banner-close style=\"background:transparent;border:0;color:rgba(255,255,255,.75);cursor:pointer;font-size:18px;line-height:1;padding:0 4px;flex-shrink:0;\">×</button>",
  "global.announcement_label": "Announcement",
  "global.antispam_sub": "Wait a few seconds before submitting",
  "global.antispam_title": "Check",
  "global.audio_default_title": "Audio",
  "global.audio_pause_prefix": "Pause ",
  "global.audio_play_prefix": "Play ",
  "global.audio_replay_prefix": "Replay ",
  "global.autosave_modified": "Changed",
  "global.autosave_saved": "Saved",
  "global.autosave_saving": "Saving…",
  "global.birthday_sub": "Your code BIRTHDAY20 = -20% is applied",
  "global.birthday_title": "Happy birthday!",
  "global.callout_close_html": "<button type=\"button\" class=\"mnl-callout__close\" aria-label=\"Close\">×</button>",
  "global.capslock_html": "<span class=\"mnl-capslock-warn\" role=\"alert\" aria-live=\"polite\">Caps Lock is on</span>",
  "global.carousel_slide_prefix": "Slide ",
  "global.cart_empty_tip": "Cart empty",
  "global.checkout_step_cart": "Cart",
  "global.checkout_step_done": "Confirmed",
  "global.checkout_step_info": "Details",
  "global.checkout_step_payment": "Payment",
  "global.city_autofilled": "Town filled in automatically",
  "global.clearfield_label": "Clear the field",
  "global.cmd_cat_action": "Action",
  "global.cmd_cat_help": "Help",
  "global.cmd_cat_navigation": "Navigation",
  "global.cmd_cat_preference": "Preference",
  "global.cmd_comparator": "Brand comparison",
  "global.cmd_configure_formula": "Configure my formula",
  "global.cmd_cookie_prefs": "Cookie preferences",
  "global.cmd_dashboard": "Dashboard",
  "global.cmd_install_app": "Install the app",
  "global.cmd_install_notif_sub": "Look for the prompt at the bottom if it is available",
  "global.cmd_install_notif_title": "App install",
  "global.cmd_kbd_shortcuts": "See the keyboard shortcuts",
  "global.cmd_lab": "Le Lab — clinical actives",
  "global.cmd_my_account": "My account",
  "global.cmd_my_wishlist": "My wishlist",
  "global.cmd_open_coach": "Open the AI Coach",
  "global.cmd_recent_products": "My recent products",
  "global.cmd_search": "Search",
  "global.cmd_see_cart": "See my cart",
  "global.cmd_toggle_dark": "Toggle dark mode",
  "global.cmdp_dialog_label": "Command palette",
  "global.cmdp_empty_html": "<div style=\"padding:24px;text-align:center;color:#94a3b8;font-size:13px;\">No command found</div>",
  "global.cmdp_input_html": "<input type=\"text\" class=\"mnl-cmdp__input\" placeholder=\"Type a command or a search…\" aria-label=\"Command search\">",
  "global.coach_fab_label": "Open the AI Coach to personalise my formula",
  "global.coach_fab_title": "AI Coach — Your formula to the nearest mg",
  "global.common_cancel": "Cancel",
  "global.common_close": "Close",
  "global.common_confirm": "Confirm",
  "global.common_copy": "Copy",
  "global.common_error": "Error",
  "global.common_next": "Next",
  "global.common_ok": "OK",
  "global.common_previous": "Previous",
  "global.common_retry": "Try again",
  "global.common_see": "See",
  "global.common_thanks": "Thank you!",
  "global.common_validate": "Confirm",
  "global.compare_added": "Added to the comparison",
  "global.compare_after": "After",
  "global.compare_bar_label": "Products to compare",
  "global.compare_before": "Before",
  "global.compare_count_suffix": "/3 products",
  "global.compare_cta_min_suffix": "/2 min)",
  "global.compare_cta_prefix": "Compare (",
  "global.compare_handle_label": "Compare before / after",
  "global.compare_max_sub": "Remove one first",
  "global.compare_max_title": "Max 3 products",
  "global.compare_removed": "Removed from the comparison",
  "global.config_restored_sub": "From a shared link",
  "global.config_restored_title": "Configuration restored",
  "global.cookie_banner_accept_html": "<button type=\"button\" class=\"mnl-cookie__btn mnl-cookie__btn--accept\" data-action=\"accept\" aria-label=\"Accept all cookies\">Accept</button>",
  "global.cookie_banner_custom_html": "<button type=\"button\" class=\"mnl-cookie__btn mnl-cookie__btn--custom\" data-action=\"custom\" aria-label=\"Customise my cookie choices\">Customise</button>",
  "global.cookie_banner_full_html": "<span class=\"mnl-cookie__text--full\">To improve your experience on MyNutriLab, we use cookies to measure our audience, personalise your browsing and optimise our services. You can change your preferences at any time in our <a href=\"/policies/privacy-policy\">privacy policy</a>.</span>",
  "global.cookie_banner_label": "Cookie consent banner",
  "global.cookie_banner_reject_html": "<button type=\"button\" class=\"mnl-cookie__btn mnl-cookie__btn--reject\" data-action=\"reject\" aria-label=\"Reject all non-essential cookies\">Reject</button>",
  "global.cookie_banner_short_html": "<span class=\"mnl-cookie__text--short\">Cookies to measure our audience and improve your browsing. Adjustable at any time — <a href=\"/policies/privacy-policy\">privacy</a>.</span>",
  "global.cookie_banner_title_html": "<p class=\"mnl-cookie__title\"><span class=\"mnl-cookie__ico\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" width=\"34\" height=\"34\"><circle cx=\"12\" cy=\"12\" r=\"9.2\" fill=\"#F97316\" fill-opacity=\".16\" stroke=\"#F97316\" stroke-width=\"1.6\"/><circle cx=\"9\" cy=\"9.4\" r=\"1.1\" fill=\"#F97316\"/><circle cx=\"14.6\" cy=\"9\" r=\".95\" fill=\"#F97316\"/><circle cx=\"15.1\" cy=\"14.2\" r=\"1.2\" fill=\"#F97316\"/><circle cx=\"9.4\" cy=\"14.6\" r=\"1\" fill=\"#F97316\"/><circle cx=\"12\" cy=\"12\" r=\".7\" fill=\"#F97316\"/></svg></span>We use cookies</p>",
  "global.cookieprefs_accept_all_html": "<button type=\"button\" class=\"mnl-cookie-prefs__btn mnl-cookie-prefs__btn--accept-all\" data-action=\"accept-all\">Accept all</button>",
  "global.cookieprefs_cat_analytics_html": "<div class=\"mnl-cookie-prefs__cat-info\"><p class=\"mnl-cookie-prefs__cat-name\">Analytics</p><p class=\"mnl-cookie-prefs__cat-desc\">Anonymous audience measurement (Google Analytics, Microsoft Clarity).</p></div>",
  "global.cookieprefs_cat_essential_html": "<div class=\"mnl-cookie-prefs__cat-info\"><p class=\"mnl-cookie-prefs__cat-name\">Essential <small>required</small></p><p class=\"mnl-cookie-prefs__cat-desc\">Vital to how the site works (cart, login, security). Cannot be switched off.</p></div>",
  "global.cookieprefs_cat_marketing_html": "<div class=\"mnl-cookie-prefs__cat-info\"><p class=\"mnl-cookie-prefs__cat-name\">Marketing</p><p class=\"mnl-cookie-prefs__cat-desc\">Ad personalisation (Meta Pixel, retargeting).</p></div>",
  "global.cookieprefs_cat_prefs_html": "<div class=\"mnl-cookie-prefs__cat-info\"><p class=\"mnl-cookie-prefs__cat-name\">Preferences</p><p class=\"mnl-cookie-prefs__cat-desc\">Remembers your interface choices (products viewed recently, badges unlocked).</p></div>",
  "global.cookieprefs_reject_all_html": "<button type=\"button\" class=\"mnl-cookie-prefs__btn mnl-cookie-prefs__btn--reject-all\" data-action=\"reject-all\">Reject all</button>",
  "global.cookieprefs_save_html": "<button type=\"button\" class=\"mnl-cookie-prefs__btn mnl-cookie-prefs__btn--save\" data-action=\"save\">Save</button>",
  "global.cookieprefs_saved_sub": "Your choices are active.",
  "global.cookieprefs_saved_title": "Preferences saved",
  "global.cookieprefs_sub_html": "<p class=\"mnl-cookie-prefs__sub\">Choose which cookies you accept. You can change these choices at any time.</p>",
  "global.cookieprefs_title_html": "<h3 class=\"mnl-cookie-prefs__title\" id=\"mnl-cookie-prefs-title\">Cookie preferences</h3>",
  "global.cookieprefs_toggle_essential_html": "<button type=\"button\" class=\"mnl-cookie-prefs__toggle is-on\" disabled aria-label=\"Essential cookies\"></button>",
  "global.cookieprefs_toggle_prefs_html": "\" data-cat=\"preferences\" aria-label=\"Preference cookies\"></button>",
  "global.copied_bang": "Copied!",
  "global.copied_check": "✓ Copied!",
  "global.copied_clipboard": "Copied to the clipboard",
  "global.copy_error_sub": "Try again or copy it by hand",
  "global.copy_error_title": "Copy error",
  "global.copy_failed_short": "✗ Failed",
  "global.copy_impossible_title": "Copy failed",
  "global.copy_manual_prefix": "Manual copy: ",
  "global.country_be": "Belgium",
  "global.country_ch": "Switzerland",
  "global.country_de": "Germany",
  "global.country_es": "Spain",
  "global.country_fr": "France",
  "global.country_gb": "United Kingdom",
  "global.country_it": "Italy",
  "global.country_lu": "Luxembourg",
  "global.country_pt": "Portugal",
  "global.country_us_ca": "USA / Canada",
  "global.datepicker_weekend": "No delivery at the weekend. Choose a working day.",
  "global.dlg_confirm_question": "Confirm?",
  "global.dlg_copy_message": "Select the text then Ctrl/⌘ + C to copy.",
  "global.dlg_copy_title": "Copy the text",
  "global.dlg_field_prefix": "Field ",
  "global.dlg_field_required": "This field is required.",
  "global.dlg_fields_title": "Enter the details",
  "global.dlg_notice_title": "Notice",
  "global.dlg_prompt_title": "Enter a value",
  "global.dnd_dropped": "Item dropped",
  "global.dnd_grabbed": "Item picked up, use the arrows to move it",
  "global.dnd_list_label": "Reorderable list (use Space then the Arrows)",
  "global.draft_autosaved_html": "<span class=\"mnl-form-draft__dot\"></span><span>Draft saved automatically</span>",
  "global.draft_restored_sub": "Pick up where you left off",
  "global.draft_restored_title": "Draft restored",
  "global.drawer_close_html": "<button type=\"button\" class=\"mnl-drawer__close\" data-mnl-drawer-close aria-label=\"Close\">×</button>",
  "global.email_typo_prefix_html": "Did you mean <button type=\"button\" class=\"mnl-email-typo__btn\">",
  "global.errbanner_close_html": "<button type=\"button\" class=\"mnl-error-banner__close\" aria-label=\"Close\">×</button>",
  "global.errbanner_msg_html": "<p class=\"mnl-error-banner__msg\">We spotted an error. If it carries on, reload the page or write to us.</p>",
  "global.errbanner_title_html": "<p class=\"mnl-error-banner__title\">Small technical hitch</p>",
  "global.eta_and_html": "</strong> and <strong>",
  "global.eta_between_html": ": between <strong>",
  "global.eta_countdown_html": "<span class=\"mnl-eta__express\" style=\"display:inline-flex;align-items:center;gap:4px;margin-left:8px;padding:2px 8px;background:#FDEDE6;color:#C93F12;border-radius:100px;font-size:11px;font-weight:800;letter-spacing:0;\"><span aria-hidden=\"true\"></span>Production starts today if you order within <strong>",
  "global.eta_label": "Estimated dispatch",
  "global.exit_badge_html": "<span class=\"mnl-exit__badge\">Welcome offer</span>",
  "global.exit_big_html": "<span class=\"mnl-exit__big\">−10 €</span>",
  "global.exit_bigsub_html": "<span class=\"mnl-exit__big-sub\">on your 1<sup>st</sup> order of at least 39 €</span>",
  "global.exit_chip_html": "<span class=\"mnl-exit__chip\">Code sent by email</span>",
  "global.exit_close_html": "<button class=\"mnl-exit__close\" type=\"button\" aria-label=\"Close the window\">×</button>",
  "global.exit_err_consent": "Tick the consent box",
  "global.exit_err_email_format": "Invalid email format",
  "global.exit_input_html": "<input type=\"email\" class=\"mnl-exit__input\" placeholder=\"your.email@example.com\" required maxlength=\"100\" autocomplete=\"email\" aria-label=\"Your email address\">",
  "global.exit_note_html": "<p class=\"mnl-exit__note\">An offer reserved for new customers.</p>",
  "global.exit_ok_close_html": "<button class=\"mnl-exit__close\" aria-label=\"Close\">×</button>",
  "global.exit_ok_cta_html": "?discount=MNL10\" class=\"mnl-exit__btn\">Use my code</a>",
  "global.exit_ok_skip_html": "<button type=\"button\" class=\"mnl-exit__skip\">Later</button>",
  "global.exit_ok_text_html": "<p class=\"mnl-exit__text\">Your code <strong>MNL10</strong> = −10&nbsp;€ on your 1st order — valid on a subscription too (1st delivery). We are sending it to you by email as well.</p>",
  "global.exit_ok_title_html": "<h3 class=\"mnl-exit__title\">It is on its way!</h3>",
  "global.exit_secure_html": "<p class=\"mnl-exit__secure\"><svg viewBox=\"0 0 24 24\" width=\"13\" height=\"13\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" style=\"flex:0 0 auto\"><rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\"/><path d=\"M7 11V7a5 5 0 0 1 10 0v4\"/></svg>No spam. Unsubscribe in one click. <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Privacy</a></p>",
  "global.exit_sending_html": "<span class=\"mnl-exit__spin\" aria-hidden=\"true\"></span>Sending…",
  "global.exit_submit_html": "<button type=\"submit\" class=\"mnl-exit__btn\">Get my code <span>−10 €</span></button>",
  "global.exit_tag_html": "<span class=\"mnl-exit__tag\">Before you go</span>",
  "global.exit_text_html": "<p class=\"mnl-exit__text\">Sign up and get your discount code straight away by email.</p>",
  "global.exit_title_html": "<h3 class=\"mnl-exit__title\" id=\"mnl-exit-title\">One last boost<br>before you go?</h3>",
  "global.form_chars_suffix": " characters",
  "global.form_check_sub": "Some fields need correcting",
  "global.form_check_title": "Check the fields",
  "global.form_email_invalid": "Invalid email (e.g. you@email.com)",
  "global.form_max_prefix": "Max: ",
  "global.form_maxlen_prefix": "Max ",
  "global.form_min_prefix": "Min: ",
  "global.form_minlen_prefix": "Min ",
  "global.form_number_invalid": "Invalid number",
  "global.form_pattern_invalid": "Invalid format",
  "global.form_required": "This field is required",
  "global.form_tel_invalid": "Invalid number (e.g. +33 6 12 34 56 78)",
  "global.form_url_invalid": "Invalid URL (https://...)",
  "global.geo_close_html": "<button type=\"button\" class=\"mnl-geo-banner__close\" aria-label=\"Close\">×</button>",
  "global.greeting_afternoon": "Good afternoon",
  "global.greeting_evening": "Good evening",
  "global.greeting_late_evening": "Have a good evening",
  "global.greeting_morning": "Good morning",
  "global.greeting_night": "Burning the midnight oil",
  "global.guard_default_msg": "You have unsaved changes. Leave anyway?",
  "global.guard_leave": "Leave without saving",
  "global.guard_stay": "Stay",
  "global.guard_title": "Unsaved changes",
  "global.honeypot_html": "<label>Do not fill in<input type=\"text\" name=\"mnl_hp_website\" tabindex=\"-1\" autocomplete=\"off\"></label>",
  "global.hotspot_detail_prefix": "Detail ",
  "global.inline_confirm": "Confirm?",
  "global.kbd_close_html": "<button type=\"button\" class=\"mnl-kbd-help__close\" aria-label=\"Close\">×</button>",
  "global.kbd_desc_close_modal": "Close the open drawer/modal",
  "global.kbd_desc_focus_search": "Focus the search bar",
  "global.kbd_desc_go_account": "Go to the account",
  "global.kbd_desc_go_home": "Go to the home page",
  "global.kbd_desc_nav_ai": "Move through the AI suggestions",
  "global.kbd_desc_newline_coach": "New line in the AI Coach",
  "global.kbd_desc_open_cart": "Open the cart",
  "global.kbd_desc_open_coach": "Open the AI Coach",
  "global.kbd_desc_send_message": "Confirm / send message",
  "global.kbd_desc_show_help": "Show this help",
  "global.kbd_group_gallery_html": "<p class=\"mnl-kbd-help__group-title\">Image gallery</p>",
  "global.kbd_group_navigation_html": "<p class=\"mnl-kbd-help__group-title\">Navigation</p>",
  "global.kbd_group_search_html": "<p class=\"mnl-kbd-help__group-title\">Search</p>",
  "global.kbd_overlay_foot_html": "<p style=\"margin:14px 0 0;font-size:11px;color:#94a3b8;text-align:center;\">Tip: press <kbd style=\"padding:1px 5px;background:#f1f5f9;border:1px solid #cbd5e1;border-radius:4px;font-size:10px;font-weight:800;\">?</kbd> anywhere to reopen this help</p>",
  "global.kbd_overlay_head_html": "<div style=\"display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;\"><h2 style=\"margin:0;font-size:18px;font-weight:900;\">⌨ Keyboard shortcuts</h2><button type=\"button\" id=\"mnl-kbd-help-close\" aria-label=\"Close\" style=\"background:transparent;border:none;font-size:24px;color:#94a3b8;cursor:pointer;line-height:1;padding:4px 8px;border-radius:6px;\">×</button></div>",
  "global.kbd_overlay_label": "Keyboard shortcuts",
  "global.kbd_row_close_modal_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Close any modal</span><span class=\"mnl-kbd-help__row-keys\"><kbd>Esc</kbd></span></li>",
  "global.kbd_row_close_zoom_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Close the zoom</span><span class=\"mnl-kbd-help__row-keys\"><kbd>Esc</kbd></span></li>",
  "global.kbd_row_nav_results_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Move through the results</span><span class=\"mnl-kbd-help__row-keys\"><kbd>↑</kbd><kbd>↓</kbd></span></li>",
  "global.kbd_row_open_search_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Open the search</span><span class=\"mnl-kbd-help__row-keys\"><kbd>",
  "global.kbd_row_prev_next_image_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Previous / next image</span><span class=\"mnl-kbd-help__row-keys\"><kbd>←</kbd><kbd>→</kbd></span></li>",
  "global.kbd_row_select_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Select</span><span class=\"mnl-kbd-help__row-keys\"><kbd>↵</kbd></span></li>",
  "global.kbd_row_show_help_html": "<li class=\"mnl-kbd-help__row\"><span class=\"mnl-kbd-help__row-label\">Show this help</span><span class=\"mnl-kbd-help__row-keys\"><kbd>?</kbd></span></li>",
  "global.kbd_sub_html": "<p class=\"mnl-kbd-help__sub\">Get around faster with these shortcuts</p>",
  "global.kbd_title_html": "<h3 class=\"mnl-kbd-help__title\" id=\"mnl-kbd-help-title\">⌨ Keyboard shortcuts</h3>",
  "global.konami_html": "KONAMI CODE!<br><small style=\"font-size:14px;font-weight:600;opacity:.9;\">Code KONAMI20 = -20% applied</small>",
  "global.link_copied": "Link copied",
  "global.link_copied_bang": "Link copied!",
  "global.load_error_retry": "Loading error — please try again",
  "global.loading_ellipsis": "Loading…",
  "global.loyalty_bonus_prefix": "You now get +",
  "global.loyalty_cap_sub": "Come back tomorrow for more points",
  "global.loyalty_cap_title": "Daily cap reached",
  "global.loyalty_level_prefix": "Level ",
  "global.loyalty_level_unlocked_suffix": " unlocked!",
  "global.loyalty_log_unlocked_suffix": " unlocked",
  "global.loyalty_max_level": "Max level reached! ",
  "global.loyalty_new_perks": "New perks available",
  "global.loyalty_newlevel_prefix": "New level: ",
  "global.loyalty_next_middle": " pts to reach ",
  "global.loyalty_next_prefix": "Just ",
  "global.loyalty_points_default_reason": "Well done, champ",
  "global.loyalty_points_suffix": " MNL Points!",
  "global.loyalty_reason_add_to_cart": "Added to cart",
  "global.loyalty_reason_daily_visit": "Daily visit",
  "global.loyalty_see_account": "See my account",
  "global.mc_hover_cart_cta_prefix": "See the cart (",
  "global.mc_hover_discover_cta": "Discover our products →",
  "global.mc_hover_empty_html": "<div class=\"mnl-mc-hover__empty\">Your cart is empty</div>",
  "global.mc_hover_note_first": "MNL10 · 1st order",
  "global.mc_hover_note_sub": "MNL10 · 1st delivery",
  "global.mc_hover_shell_html": "<div class=\"mnl-mc-hover__title\">Cart preview <small></small></div><div class=\"mnl-mc-hover__items\"></div><div class=\"mnl-mc-hover__total\"></div><a href=\"/cart\" class=\"mnl-mc-hover__cta\">See the full cart →</a>",
  "global.mc_hover_total_html": "<span>Total</span>",
  "global.mcta_close_html": "<button type=\"button\" data-mnl-mcta-close aria-label=\"Hide the button\" style=\"background:rgba(15,23,42,.06);border:0;color:#94a3b8;cursor:pointer;width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;line-height:1;\"><svg viewBox=\"0 0 24 24\" width=\"13\" height=\"13\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 6 6 18\"/><path d=\"m6 6 12 12\"/></svg></button>",
  "global.mcta_label": "Configure your formula",
  "global.mcta_sub_html": "<span style=\"font-size:10.5px;font-weight:600;color:#1a1a1a;letter-spacing:.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">AI Coach · pickup point free from 49€</span>",
  "global.mcta_title_html": "<span style=\"font-size:13px;font-weight:900;letter-spacing:-.01em;color:#0f172a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;\">Configure your formula</span>",
  "global.mic_check_perms": "Check the permissions",
  "global.mic_denied": "Microphone refused",
  "global.mic_error": "Mic error",
  "global.month_short_01": "jan",
  "global.month_short_02": "feb",
  "global.month_short_03": "mar",
  "global.month_short_04": "apr",
  "global.month_short_05": "may",
  "global.month_short_06": "jun",
  "global.month_short_07": "jul",
  "global.month_short_08": "aug",
  "global.month_short_09": "sep",
  "global.month_short_10": "oct",
  "global.month_short_11": "nov",
  "global.month_short_12": "dec",
  "global.multiselect_clear_html": "<div class=\"mnl-multiselect__divider\"></div><div class=\"mnl-multiselect__clear\">Clear the selection</div>",
  "global.multistep_default_label": "Step",
  "global.multistep_next": "Next →",
  "global.multistep_next_html": "<button type=\"button\" class=\"mnl-multistep__nav-btn mnl-multistep__nav-btn--next\">Next →</button>",
  "global.multistep_prev_html": "<button type=\"button\" class=\"mnl-multistep__nav-btn mnl-multistep__nav-btn--prev\" disabled>← Previous</button>",
  "global.multistep_validate": "Confirm ✓",
  "global.net_back_online": "✓ Connection restored",
  "global.net_back_online_title": "Back online",
  "global.net_offline_html": "<span class=\"mnl-net-status__icon\" aria-hidden=\"true\"></span><span class=\"mnl-net-status__text\">No connection — some features are unavailable</span>",
  "global.net_offline_sub": "Your actions will sync when you reconnect",
  "global.net_offline_text": "No connection — some features are unavailable",
  "global.net_offline_title": "Offline",
  "global.net_slow": "Slow connection detected — loading optimised",
  "global.news_err_email_disposable": "Disposable address detected — use a real email to receive your code",
  "global.news_err_email_format": "Invalid email format — check the format",
  "global.news_err_email_required": "Email required",
  "global.news_popup_html": "\\\n      <div class=\"mnl-news-popup__panel\">\\\n        <button type=\"button\" class=\"mnl-news-popup__close\" aria-label=\"Close\">×</button>\\\n        <div class=\"mnl-news-popup__icon\"></div>\\\n        <h3 class=\"mnl-news-popup__title\">−10€ on your <em>first formula</em></h3>\\\n        <p class=\"mnl-news-popup__sub\">Sign up to the MNL newsletter and get your MNL10 code instantly. Coach tips + early access to active drops.</p>\\\n        <form class=\"mnl-news-popup__form\">\\\n          <input type=\"email\" class=\"mnl-news-popup__input\" placeholder=\"you@email.com\" required maxlength=\"100\">\\\n          <button type=\"submit\" class=\"mnl-news-popup__btn\">Get my MNL10 code</button>\\\n        </form>\\\n        <p class=\"mnl-news-popup__msg\"></p>\\\n        <button type=\"button\" class=\"mnl-news-popup__no\">No thanks</button>\\\n      </div>",
  "global.news_success_close_html": "<button type=\"button\" class=\"mnl-news-popup__success-close\" id=\"mnlNewsCloseSuccess\">Later</button>",
  "global.news_success_code_label_html": "<span class=\"mnl-news-popup__success-code-lbl\">Your code</span>",
  "global.news_success_copy_html": "<button type=\"button\" class=\"mnl-news-popup__success-copy\" id=\"mnlNewsCopyBtn\" aria-label=\"Copy the code\"></button>",
  "global.news_success_cta_html": "<a href=\"/products/pre-workout-mynutrilab-personnalisable-au-mg-pres?open=ai\" class=\"mnl-news-popup__success-cta\">Configure my formula →</a>",
  "global.news_success_sub_html": "<p class=\"mnl-news-popup__success-sub\">Your code <strong>MNL10</strong>: −10&nbsp;€ on your 1st order — valid on a subscription too (1st delivery).</p>",
  "global.nl_code_sent_prefix": "Code MNL10 sent to ",
  "global.nl_confirm_code_html": "<span class=\"mnl-nl-confirm__code\" data-mnl-copy=\"MNL10\" data-mnl-copy-label=\"Code copied\">MNL10 — click to copy</span>",
  "global.nl_confirm_sub_html": "<p class=\"mnl-nl-confirm__sub\">Code <strong>MNL10</strong> sent to your email.</p>",
  "global.nl_confirm_title_html": "<p class=\"mnl-nl-confirm__title\">Sign-up confirmed</p>",
  "global.nl_subscribed_title": "Signed up!",
  "global.notif_close_label": "Close the notification",
  "global.notifcenter_clear_html": "<button type=\"button\" class=\"mnl-notif-center__clear\">Clear all</button>",
  "global.notifcenter_empty_html": "<div class=\"mnl-notif-center__empty\">No notifications</div>",
  "global.notifcenter_label": "Notification centre",
  "global.pagefeedback_no_html": "<button type=\"button\" class=\"mnl-feedback__btn\" data-vote=\"no\">Not really</button>",
  "global.pagefeedback_question": "Did this page help you?",
  "global.pagefeedback_textarea_html": "<textarea class=\"mnl-feedback__textarea\" placeholder=\"Tell us what we could improve (optional)\"></textarea>",
  "global.pagefeedback_thanks": "✓ Thanks for your feedback!",
  "global.pagefeedback_toast_sub": "Your feedback is valuable",
  "global.pagefeedback_yes_html": "<button type=\"button\" class=\"mnl-feedback__btn\" data-vote=\"yes\">Yes</button>",
  "global.pageload_label": "Page loading",
  "global.pagination_jump_prefix_html": "<span class=\"mnl-pagination__jump\">Go to <input type=\"number\" min=\"1\" max=\"",
  "global.pagination_jump_suffix_html": "\" aria-label=\"Page number\"> / ",
  "global.pagination_label": "Pagination",
  "global.pagination_next_html": " aria-label=\"Next page\">→</a>",
  "global.pagination_prev_html": " aria-label=\"Previous page\">←</a>",
  "global.panel_default_label": "Panel",
  "global.perdose_doses_suffix": " servings",
  "global.perdose_sep_html": " €</strong> / serving · ",
  "global.phone_country_btn_html": "<button type=\"button\" class=\"mnl-phone-intl__country\" aria-haspopup=\"listbox\" aria-expanded=\"false\" aria-label=\"Choose the country\">",
  "global.phone_format_hint": "Invalid format. Example: 06 12 34 56 78",
  "global.phone_input_html": "<input type=\"tel\" class=\"mnl-phone-intl__input\" placeholder=\"6 12 34 56 78\" autocomplete=\"tel\" data-mnl-format=\"phone-fr\" aria-label=\"Phone number\">",
  "global.promo_banner_suffix_html": "</code> activated! Applied at checkout.",
  "global.promo_notif_sub_suffix": " will be applied at checkout",
  "global.promo_notif_title": "Promo code activated",
  "global.promobar_close_label": "Close the promotional banner",
  "global.ptr_indicator_html": "<span class=\"mnl-ptr-indicator__icon\">↓</span><span class=\"mnl-ptr-indicator__txt\">Pull to refresh</span>",
  "global.ptr_pull": "Pull to refresh",
  "global.ptr_refreshing": "Refreshing…",
  "global.ptr_release": "Release to refresh",
  "global.pwa_dialog_label": "Install the MyNutriLab app",
  "global.pwa_install_html": "<button type=\"button\" class=\"mnl-pwa-install__btn mnl-pwa-install__btn--accept\">Install</button>",
  "global.pwa_installing_sub": "MyNutriLab is on its way to your home screen",
  "global.pwa_installing_title": "Install started",
  "global.pwa_later_html": "<button type=\"button\" class=\"mnl-pwa-install__btn mnl-pwa-install__btn--later\">Later</button>",
  "global.pwa_sub_html": "<p class=\"mnl-pwa-install__sub\">Direct access from your home screen — just like an app.</p>",
  "global.pwa_title_html": "<p class=\"mnl-pwa-install__title\">Install MyNutriLab</p>",
  "global.pwd_hide": "Hide",
  "global.pwd_hide_label": "Hide the password",
  "global.pwd_show": "Show",
  "global.pwd_show_label": "Show the password",
  "global.pwd_strength_excellent": "Excellent",
  "global.pwd_strength_medium": "Medium",
  "global.pwd_strength_strong": "Strong",
  "global.pwd_strength_weak": "Weak",
  "global.qr_close_html": "<button type=\"button\" class=\"mnl-qr__btn mnl-qr__btn--close\">Close</button>",
  "global.qr_copy_html": "\" data-mnl-copy-label=\"Link copied\">Copy</button>",
  "global.qr_default_sub": "Scan the QR code with your phone",
  "global.qr_default_title": "Share this link",
  "global.qv_close_html": "<button type=\"button\" class=\"mnl-qv__close\" aria-label=\"Close the preview\">×</button>",
  "global.qv_cta_html": "<a class=\"mnl-qv__cta\" style=\"flex:1;display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:14px 24px;background:#E84E1B;color:#fff;font-size:14px;font-weight:800;text-decoration:none;border-radius:100px;box-shadow:0 8px 20px rgba(194,65,12,.35);transition:transform .2s ease\">See the full page →</a>",
  "global.qv_dialog_label": "Quick product preview",
  "global.qv_eyebrow_html": "<p style=\"margin:0;font-size:11px;font-weight:800;color:#94a3b8;letter-spacing:.12em;text-transform:uppercase\">— Quick preview</p>",
  "global.qv_gone_msg": "This product no longer exists",
  "global.qv_invalid_sub": "Product link not recognised",
  "global.qv_invalid_title": "Invalid preview",
  "global.qv_retry_msg": "Try again or open the full page",
  "global.qv_thumbs_html": "<div class=\"mnl-qv__thumbs\" role=\"tablist\" aria-label=\"Product image gallery\" style=\"display:none;gap:8px;margin-top:12px;flex-wrap:wrap;\"></div>",
  "global.qv_unavailable_title": "Preview unavailable",
  "global.qv_wishlist_btn_html": "<button type=\"button\" class=\"mnl-qv__wl\" data-mnl-wishlist=\"\" aria-label=\"Add to the wishlist\" style=\"width:48px;height:48px;border:1.5px solid rgba(15,23,42,.1);border-radius:50%;background:#fff;font-size:20px;cursor:pointer;color:#475569;transition:all .2s ease\">♡</button>",
  "global.range_default_label": "Price",
  "global.rating_label": "Rating out of 5 stars",
  "global.reading_progress_label": "Reading progress",
  "global.readmore_less": "Read less",
  "global.readmore_more": "Read more",
  "global.recos_default_title": "You might like",
  "global.recos_next_html": "<button type=\"button\" class=\"mnl-recos__nav-btn\" data-mnl-recos-next aria-label=\"Next\">›</button>",
  "global.recos_prev_html": "<button type=\"button\" class=\"mnl-recos__nav-btn\" data-mnl-recos-prev aria-label=\"Previous\">‹</button>",
  "global.redirect_cancel_html": "</span>s…</span><button type=\"button\" class=\"mnl-redirect__cancel\">Cancel</button>",
  "global.redirect_cancelled": "Redirect cancelled",
  "global.redirect_default_msg": "Redirecting in",
  "global.ref_activated_title": "Referral activated",
  "global.ref_code_prefix": "Code ",
  "global.ref_discount_suffix": " — -10% on your 1st order",
  "global.reorder_added_sub_suffix": " in your cart",
  "global.reorder_added_title": "Order added!",
  "global.reorder_confirm": "Add to cart",
  "global.reorder_error_sub": "Some items could not be added",
  "global.reorder_message_suffix": " will be added to your current cart.",
  "global.reorder_title": "Order this again?",
  "global.reviews_empty_html": "<p style=\"text-align:center;color:#94a3b8;font-size:13px;font-weight:600;padding:14px;margin:0;\">No reviews yet</p>",
  "global.rv_history_cleared": "History cleared",
  "global.rv_history_cleared_sub": "The recent products have been forgotten.",
  "global.rv_panel_clear_html": "<button type=\"button\" class=\"mnl-rv-panel__clear\" data-mnl-rv-clear-panel><svg viewBox=\"0 0 24 24\" width=\"14\" height=\"14\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"vertical-align:-2px;margin-right:5px\" aria-hidden=\"true\"><path d=\"M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13\"/></svg>Clear all</button>",
  "global.rv_panel_close_html": "<button type=\"button\" class=\"mnl-rv-panel__close\" aria-label=\"Close\">×</button>",
  "global.rv_panel_label": "Recently viewed products",
  "global.rv_panel_title_html": "<p class=\"mnl-rv-panel__title\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"vertical-align:-2px;margin-right:5px\" aria-hidden=\"true\"><path d=\"M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg>Recently viewed</p>",
  "global.rv_strip_clear_html": "<button type=\"button\" class=\"mnl-rv-strip__clear\" data-mnl-rv-clear aria-label=\"Clear the recent history\">Clear</button></div>",
  "global.rv_strip_head_html": "<div class=\"mnl-rv-strip__head\"><p class=\"mnl-rv-strip__title\">You recently looked at</p>",
  "global.rv_strip_label": "Recently viewed products",
  "global.rv_widget_label": "See my recently viewed products",
  "global.saved_for_later": "Saved for later",
  "global.search_account_sub": "Orders · addresses",
  "global.search_account_title": "My account",
  "global.search_cart_sub": "See my items",
  "global.search_cart_title": "My cart",
  "global.search_cat_account": "Account",
  "global.search_cat_brand": "Brand",
  "global.search_cat_help": "Help",
  "global.search_cat_products": "Products",
  "global.search_cat_tools": "Tools",
  "global.search_coach_sub": "Claude AI assistant · 11 structured questions",
  "global.search_config_sub": "Pro mode, dose by dose",
  "global.search_config_title": "Expert builder",
  "global.search_contact_sub": "We reply within 24h",
  "global.search_contact_title": "Contact",
  "global.search_didyoumean_prefix": "Did you mean ",
  "global.search_faq_sub": "Frequently asked questions",
  "global.search_lab_sub": "11 clinical actives in detail",
  "global.search_lab_title": "Le Lab — actives",
  "global.search_noresult_prefix_html": "<p style=\"text-align:center;color:#64748b;padding:24px;font-size:14px;\">No results for \"<strong>",
  "global.search_overlay_html": "\\\n      <div class=\"mnl-search-overlay__panel\">\\\n        <div class=\"mnl-search-overlay__inputbox\">\\\n          <span class=\"mnl-search-overlay__icon\"></span>\\\n          <input type=\"text\" class=\"mnl-search-overlay__input\" id=\"mnl-search-overlay-input\" placeholder=\"Search for a product, a page, an active…\" autocomplete=\"off\" spellcheck=\"false\">\\\n          <span class=\"mnl-search-overlay__shortcut\">ESC</span>\\\n        </div>\\\n        <div class=\"mnl-search-overlay__results\" id=\"mnl-search-overlay-results\"></div>\\\n        <div class=\"mnl-search-overlay__hint\"><span><kbd>↑</kbd><kbd>↓</kbd> navigate · <kbd>↵</kbd> open</span><span>Powered by MNL Search</span></div>\\\n      </div>",
  "global.search_pledges_sub": "French brand · Transparency",
  "global.search_pledges_title": "Our commitments",
  "global.search_pw_sub": "Configure your formula to the nearest mg",
  "global.search_pw_title": "Made-to-measure Pre-Workout",
  "global.search_shipping_sub": "Preparation within 4 working days + transit · pickup point free from 49€, home from 110€",
  "global.search_shipping_title": "Delivery & returns",
  "global.search_story_sub": "Why MyNutriLab",
  "global.search_story_title": "Our story",
  "global.sel_copied_sub": "With the selected passage highlighted",
  "global.sel_copy_label": "Copy the link to this passage",
  "global.sel_copy_pill_html": "<span aria-hidden=\"true\"></span> Copy the link",
  "global.select_empty_html": "<div class=\"mnl-select__empty\">No results</div>",
  "global.select_placeholder": "Select",
  "global.select_search_html": "<div class=\"mnl-select__search\"><input type=\"text\" placeholder=\"Search...\" aria-label=\"Filter the options\" value=\"",
  "global.share_anywhere": "Share it anywhere",
  "global.share_config_sub": "Scan or copy the link",
  "global.share_config_title": "Share this setup",
  "global.share_target_missing": "Target not found",
  "global.sheet_close_html": "<button type=\"button\" class=\"mnl-sheet__close\" data-mnl-sheet-close aria-label=\"Close\">×</button>",
  "global.ship_remaining_prefix_html": "Only <strong>",
  "global.ship_remaining_suffix_html": " €</strong> to go for free pickup point delivery",
  "global.ship_threshold_prefix": "Threshold: ",
  "global.ship_unlocked_detail": "Add as many items as you like!",
  "global.ship_unlocked_html": "<span class=\"mnl-shipping-calc__free\">Free pickup point delivery unlocked ✓</span>",
  "global.shipbar_remaining_prefix_html": "<span>Only <strong>",
  "global.shipbar_remaining_suffix_html": "€</strong> to go for free pickup point delivery</span><span>",
  "global.shipbar_unlocked_html": "<span><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\"><path d=\"M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z\"/></svg>Free pickup point delivery unlocked!</span><span>≥ 49€</span>",
  "global.slider_default_label": "Value",
  "global.stock_email_invalid_sub": "Check the format",
  "global.stock_email_invalid_title": "Invalid email",
  "global.stock_in_stock": "In stock ✓",
  "global.stock_in_stock_suffix": " in stock",
  "global.stock_insufficient": "Not enough stock",
  "global.stock_only_prefix": "Only ",
  "global.stock_out": "Out of stock",
  "global.stock_subscribed_sub": "We will write to you as soon as it is back",
  "global.stock_subscribed_title": "On the waitlist",
  "global.stock_success_prefix_html": "✓ We will let you know as soon as <strong>",
  "global.stock_success_suffix_html": "</strong> is back in stock.",
  "global.stt_https_sub": "Voice recognition needs a secure connection",
  "global.stt_https_title": "HTTPS required",
  "global.stt_unsupported_sub": "Your browser does not support voice recognition",
  "global.sub_close_html": "<button type=\"button\" class=\"mnl-sub-banner__close\" aria-label=\"Close\">×</button>",
  "global.sub_cta_manage": "Manage",
  "global.sub_cta_resume": "Resume",
  "global.sub_cta_undo_skip": "Undo the skip",
  "global.sub_msg_cancelling": "Your cancellation request is being processed (within 48h).",
  "global.sub_msg_paused": "Your subscription is paused",
  "global.sub_msg_skipped": "You skipped your next delivery. The one after it is still scheduled.",
  "global.sub_msg_until_prefix": " until ",
  "global.sw_apply_cta": "Apply",
  "global.sw_apply_sub": "Click to apply (the page will reload)",
  "global.sw_dismiss_html": "<button type=\"button\" id=\"mnl-sw-dismiss\" aria-label=\"Later\" style=\"background:transparent;color:rgba(255,255,255,.6);border:none;padding:6px;border-radius:50%;font-size:18px;line-height:1;cursor:pointer;font-family:inherit;\">×</button>",
  "global.sw_new_version": "New version available",
  "global.sw_update_html": "<span aria-hidden=\"true\"></span><span>MyNutriLab update available</span>",
  "global.sync_ok_prefix": "✓ Sync OK (",
  "global.sync_running": "Syncing…",
  "global.theme_dark": "dark",
  "global.theme_enabled_suffix": " mode",
  "global.theme_light": "light",
  "global.theme_mode_prefix": "Switched to ",
  "global.time_imminent": "imminent",
  "global.time_just_now": "just now",
  "global.time_long_ago": "a long time ago",
  "global.time_yesterday": "yesterday",
  "global.timer_close_html": "<button type=\"button\" class=\"mnl-timer__close\" aria-label=\"Close the timer\">×</button>",
  "global.timer_done_sub": "Back to your set",
  "global.timer_done_title": "Rest over!",
  "global.tip_label_html": "<p class=\"mnl-tip-rotator__label\">Did you know?</p>",
  "global.tip_next_html": "<button type=\"button\" class=\"mnl-tip-rotator__nav-btn\" data-tip-next aria-label=\"Next\">›</button>",
  "global.tip_prev_html": "<button type=\"button\" class=\"mnl-tip-rotator__nav-btn\" data-tip-prev aria-label=\"Previous\">‹</button>",
  "global.toast_loading_default": "In progress…",
  "global.toast_success_default": "Success!",
  "global.toc_label": "Page contents",
  "global.totop_announce": "Back to the top of the page",
  "global.totop_label": "Back to the top of the page",
  "global.totop_label_page": "Back to the top of the page",
  "global.totop_title": "Back to top",
  "global.tour_card_label": "Guided tour",
  "global.tour_finish": "Finish ✓",
  "global.tour_next": "Next →",
  "global.tour_skip_html": "<button type=\"button\" class=\"mnl-tour-card__skip\">Skip</button>",
  "global.tour_step_prefix_html": "<p class=\"mnl-tour-card__step\">Step ",
  "global.tracker_label": "Order tracking",
  "global.trust_actives_html": "<strong>11 transparent actives</strong> · Dosed to the nearest mg",
  "global.trust_ai_html": "<strong>AI-personalised</strong> formula, to the nearest mg",
  "global.trust_close_html": "</div><button class=\"mnl-trust-strip__close\" aria-label=\"Close\">×</button>",
  "global.trust_doses_html": "<strong>Clinical dosages</strong> · Published studies",
  "global.trust_made_in_france_html": "<strong>French brand</strong> · ISO 22000 certified laboratory",
  "global.trust_payment_html": "<strong>100% secure</strong> payment · Card, Apple Pay, PayPal",
  "global.trust_shipping_html": "Preparation within <strong>4 working days</strong> + carrier transit · Pickup point free from 49€ · Home from 110€",
  "global.trust_support_html": "Support through the <strong>contact form</strong> · reply within 24h",
  "global.trust_vegan_html": "100% <strong>vegan</strong>, gluten-free, lactose-free",
  "global.trust_warranty_html": "<strong>Legal guarantee</strong> · faulty product replaced",
  "global.tts_unsupported_sub": "Your browser does not support speech synthesis",
  "global.unsupported_title": "Not supported",
  "global.upload_default_title": "Drop your files here",
  "global.upload_files_suffix": " files",
  "global.upload_input_html": "\" multiple aria-label=\"Choose files\" accept=\"",
  "global.upload_limit_prefix": "Maximum ",
  "global.upload_limit_title": "Limit reached",
  "global.upload_sub_files_html": " files · ",
  "global.upload_sub_prefix_html": "<p class=\"mnl-upload__sub\">or <strong>click to browse</strong> · max ",
  "global.upload_sub_size_html": " MB each</p>",
  "global.upload_toobig_middle": " is larger than ",
  "global.upload_toobig_title": "File too large",
  "global.upsell_add_aria_prefix": "\" aria-label=\"Add ",
  "global.upsell_add_btn_html": "\" style=\"padding:6px 12px;background:#E84E1B;color:#fff;border:none;border-radius:100px;font-size:11px;font-weight:800;cursor:pointer;font-family:inherit;letter-spacing:.02em;\">+ Add</button>",
  "global.upsell_added": "✓ Added",
  "global.upsell_title_html": "<p style=\"font-size:11px;font-weight:800;color:#94a3b8;letter-spacing:.08em;text-transform:uppercase;margin:0 0 10px;display:flex;align-items:center;gap:5px;\"><svg viewBox=\"0 0 24 24\" width=\"13\" height=\"13\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z\"/></svg>Often added together</p>",
  "global.video_fullscreen_html": "<button type=\"button\" class=\"mnl-video__btn\" data-act=\"fullscreen\" aria-label=\"Full screen\">⛶</button>",
  "global.video_mute_html": "<button type=\"button\" class=\"mnl-video__btn\" data-act=\"mute\" aria-label=\"Mute\"></button>",
  "global.video_play_html": "<button type=\"button\" class=\"mnl-video__play\" aria-label=\"Play the video\"></button>",
  "global.video_playpause_html": "<button type=\"button\" class=\"mnl-video__btn\" data-act=\"play\" aria-label=\"Play/Pause\">⏸</button>",
  "global.video_progress_html": "<div class=\"mnl-video__progress\" role=\"slider\" aria-label=\"Progress\"><div class=\"mnl-video__progress-fill\"></div></div>",
  "global.vote_removed": "Vote removed",
  "global.vote_thanks_sub": "Your vote helps the community",
  "global.waitlist_close_html": "<button type=\"button\" class=\"mnl-wl__close\" aria-label=\"Close\" style=\"position:absolute;top:12px;right:12px;width:32px;height:32px;border:0;border-radius:50%;background:rgba(15,23,42,.06);color:#475569;font-size:18px;cursor:pointer;line-height:1;\">×</button>",
  "global.waitlist_default_product": "This product",
  "global.waitlist_dialog_label": "Waiting list",
  "global.waitlist_email_input_html": "<input type=\"email\" name=\"contact[email]\" class=\"mnl-wl__email\" required placeholder=\"you@email.com\" autocomplete=\"email\" inputmode=\"email\" maxlength=\"254\" aria-label=\"Email address\" style=\"padding:13px 16px;border:1px solid #e2e8f0;border-radius:12px;font-size:16px;font-family:inherit;outline:none;box-sizing:border-box;\">",
  "global.waitlist_intro_html": "<p style=\"font-size:14px;color:#64748b;margin:0 0 18px;line-height:1.5;\">Leave your email: you will be the first to know at launch.</p>",
  "global.waitlist_nospam_html": "<p style=\"font-size:11px;color:#94a3b8;margin:12px 0 0;\">No spam.</p>",
  "global.waitlist_ok_sub": "You will be the first to know at launch",
  "global.waitlist_ok_title": "You are on the list!",
  "global.waitlist_submit_html": "<button type=\"submit\" class=\"mnl-wl__submit\" style=\"padding:13px 18px;border:0;border-radius:12px;background:#E84E1B;color:#fff;font-weight:800;font-size:15px;cursor:pointer;font-family:inherit;\">Let me know</button>",
  "global.waitlist_title_suffix": " is coming soon",
  "global.wb2_ago_suffix": " already. ",
  "global.wb2_cart_sub": "Your cart has not moved.",
  "global.wb2_close_html": "<button type=\"button\" class=\"mnl-welcome-back__close\" aria-label=\"Close\">×</button>",
  "global.wb2_cta_formula": "My formula",
  "global.wb2_formula_sub": "Pick your formula up where you left it.",
  "global.wb2_months_suffix": " months already. ",
  "global.wb2_one_week": "1 week",
  "global.wb2_title_prefix_html": "<p class=\"mnl-welcome-back__title\">Welcome back",
  "global.wb_cart_sub_prefix": "Your items are still here — last visit ",
  "global.wb_cart_title": "Your cart is waiting",
  "global.wb_close_html": "<button type=\"button\" class=\"mnl-welcomeback__close\" aria-label=\"Close\">×</button>",
  "global.wb_cta_checkout": "Check out",
  "global.wb_cta_resume": "Resume",
  "global.wb_cta_wishlist": "See wishlist",
  "global.wb_default_name": "athlete",
  "global.wb_formula_sub": "Your made-to-measure formula is waiting in the AI Coach",
  "global.wb_hello_prefix": "Hello again ",
  "global.wb_wishlist_sub_prefix": "Find your favourite products again (seen ",
  "global.wb_wishlist_title": "Your wishes are saved",
  "global.wl_add_label": "Add to the wishlist",
  "global.wl_add_to_header": "Add to…",
  "global.wl_added_to_prefix": "Added to ",
  "global.wl_default_list_name": "the wishlist",
  "global.wl_list_favorites": "My favourites",
  "global.wl_list_full": "List full (30 max)",
  "global.wl_list_reorder": "Regulars",
  "global.wl_list_totest": "To try",
  "global.wl_longpress_hint": " · long-press ♡ to choose",
  "global.wl_manage_lists": "→ Manage my lists",
  "global.wl_oldest_removed": "The oldest item was removed to make room.",
  "global.wl_panel_shell_html": "<div class=\"mnl-news-popup__panel\" style=\"text-align:left;\"><button type=\"button\" class=\"mnl-news-popup__close\" aria-label=\"Close\">×</button>",
  "global.wl_panel_title_prefix_html": "<h3 style=\"font-size:22px;font-weight:900;letter-spacing:-.02em;margin:0 0 14px;\">Your favourites (",
  "global.wl_pick_list_label": "Choose a wishlist",
  "global.wl_remove_label": "Remove from the wishlist",
  "global.wl_removed_from_prefix": "Removed from ",
  "global.wl_shared_list": "Shared list",
  "global.wl_shared_suffix": " (shared)",
  "global.zoom_close_html": "<button type=\"button\" class=\"mnl-zoom-overlay__close\" aria-label=\"Close\">×</button>",
  "global.zoom_dialog_label": "Enlarged image",
  "global.zoom_next_html": "<button type=\"button\" class=\"mnl-zoom-overlay__nav mnl-zoom-overlay__nav--next\" aria-label=\"Next image\">›</button>",
  "global.zoom_prev_html": "<button type=\"button\" class=\"mnl-zoom-overlay__nav mnl-zoom-overlay__nav--prev\" aria-label=\"Previous image\">‹</button>",
  "glossaire.js_empty_prefix": "No results for “",
  "glossaire.js_empty_suffix": "”",
  "header-polish.acc_addr_create_btn": "✓ Create the address",
  "header-polish.acc_addr_creating": "Creating…",
  "header-polish.acc_addr_del_fail_alert": "Could not delete — please try again in a moment",
  "header-polish.acc_addr_del_fail_message": "Please try again in a moment.",
  "header-polish.acc_addr_del_fail_sub": "Please try again in a moment",
  "header-polish.acc_addr_del_fail_title": "Could not delete",
  "header-polish.acc_addr_delete_message": "It will be removed from your account.",
  "header-polish.acc_addr_delete_title": "Delete this address?",
  "header-polish.acc_addr_fail_alert": "Address not saved — please check the fields",
  "header-polish.acc_addr_fail_message": "Check the fields then try again.",
  "header-polish.acc_addr_fail_sub": "Check the fields",
  "header-polish.acc_addr_fail_title": "Address not saved",
  "header-polish.acc_addr_label_gym": "Gym",
  "header-polish.acc_addr_label_home": "Home",
  "header-polish.acc_addr_label_other": "Other",
  "header-polish.acc_addr_label_work": "Work",
  "header-polish.acc_addr_save": "Save",
  "header-polish.acc_addr_saving": "Saving…",
  "header-polish.acc_bk_clear_message": "All the AI Coach bookmarks will be deleted. This cannot be undone.",
  "header-polish.acc_bk_clear_ok": "Clear everything",
  "header-polish.acc_bk_clear_title": "Clear all the favourites?",
  "header-polish.acc_bk_context_label_html": "<div style=\"background:rgba(15,23,42,.04);border-left:3px solid rgba(194,65,12,.3);padding:8px 12px;margin-bottom:10px;font-size:12px;color:#1a1a1a;font-style:italic;border-radius:0 8px 8px 0;\"><strong style=\"color:#0f172a;not-italic:font-style:normal;\">Your question:</strong> ",
  "header-polish.acc_bk_copied": "✓ Copied",
  "header-polish.acc_bk_copy": "Copy",
  "header-polish.acc_bk_copy_btn_html": "\" aria-label=\"Copy the text\" title=\"Copy\" style=\"background:rgba(15,23,42,.05);border:0;border-radius:8px;padding:6px 12px;font-size:12px;font-weight:700;cursor:pointer;color:#1a1a1a;font-family:inherit;\">Copy</button>",
  "header-polish.acc_bk_deleted_toast": "Note deleted",
  "header-polish.acc_bk_remove_btn_html": "\" aria-label=\"Remove from favourites\" title=\"Remove\" style=\"background:rgba(220,38,38,.08);border:0;border-radius:8px;padding:6px 12px;font-size:12px;font-weight:700;cursor:pointer;color:#dc2626;font-family:inherit;display:inline-flex;align-items:center;\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><polyline points=\"3 6 5 6 21 6\"/><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"/></svg></button>",
  "header-polish.acc_cancel": "Cancel",
  "header-polish.acc_delete": "Delete",
  "header-polish.acc_delete_q": "Delete?",
  "header-polish.acc_loyalty_balance_prefix": " · balance ",
  "header-polish.acc_loyalty_disabled_sub": "Coming soon",
  "header-polish.acc_loyalty_disabled_title": "Programme in the works",
  "header-polish.acc_loyalty_pts_suffix": " pts",
  "header-polish.acc_month_00": "jan",
  "header-polish.acc_month_01": "feb",
  "header-polish.acc_month_02": "mar",
  "header-polish.acc_month_03": "apr",
  "header-polish.acc_month_04": "may",
  "header-polish.acc_month_05": "jun",
  "header-polish.acc_month_06": "jul",
  "header-polish.acc_month_07": "aug",
  "header-polish.acc_month_08": "sep",
  "header-polish.acc_month_09": "oct",
  "header-polish.acc_month_10": "nov",
  "header-polish.acc_month_11": "dec",
  "header-polish.acc_quiet_active": "(currently active )",
  "header-polish.acc_quiet_inactive": "(inactive right now)",
  "header-polish.acc_quiet_off": "Notifications switched back on",
  "header-polish.acc_quiet_on": "Quiet mode on",
  "header-polish.acc_quiet_same_hours": "(identical hours — switched off)",
  "header-polish.acc_reward_action_cart": "See the cart",
  "header-polish.acc_reward_code_label_html": "</strong><br><br>Code to use: <code style=\"background:#f1f5f9;padding:3px 8px;border-radius:6px;font-weight:800;\">",
  "header-polish.acc_reward_code_prefix": "Code ",
  "header-polish.acc_reward_code_suffix": " copied — valid for 30 days",
  "header-polish.acc_reward_confirm_ok": "Redeem",
  "header-polish.acc_reward_confirm_prefix": "Redeem ",
  "header-polish.acc_reward_confirm_suffix": " pts?",
  "header-polish.acc_reward_need_prefix": "Just ",
  "header-polish.acc_reward_need_suffix": " pts to unlock it",
  "header-polish.acc_reward_notif_prefix": "Reward code ",
  "header-polish.acc_reward_redeem_prefix": "Click to redeem ",
  "header-polish.acc_reward_unlocked_title": "Reward unlocked!",
  "header-polish.acc_reward_validity_html": "</code><br><small style=\"color:#1a1a1a;\">Valid for 30 days</small>",
  "header-polish.acc_time_ago_prefix": "About ",
  "header-polish.acc_time_days_suffix": "d",
  "header-polish.acc_time_hours_suffix": "h",
  "header-polish.acc_time_minutes_suffix": " min",
  "header-polish.acc_time_now": "Just now",
  "header-polish.acc_wl_remove_aria_html": "\" aria-label=\"Remove ",
  "header-polish.acc_wl_removed_toast": "Removed from the list",
  "header-polish.acc_wl_view_html": "\" style=\"flex:1;text-align:center;padding:6px;background:#C2410C;color:#fff;text-decoration:none;border-radius:8px;font-size:11px;font-weight:800;\">View</a>",
  "header-polish.cart_atc_error_sub": "Try again in a moment",
  "header-polish.cart_atc_error_title": "Could not add",
  "header-polish.cart_compo_summary_prefix_html": "<details class=\"mnl-hd-cart__details\"><summary>See the composition (",
  "header-polish.cart_compo_summary_suffix_html": " actives)</summary><div class=\"mnl-hd-cart__details-list\">",
  "header-polish.cart_discount_line_html": "<div class=\"mnl-hd-cart__discount-line\"><span>Discount</span><span>−",
  "header-polish.cart_estimate_checkout_html": "<strong>Calculated at checkout</strong>",
  "header-polish.cart_estimate_free_html": "<strong>Free</strong>",
  "header-polish.cart_estimate_free_relay_html": "<strong>Free</strong> (pickup point)",
  "header-polish.cart_item_remove_aria_html": "\" aria-label=\"Remove ",
  "header-polish.cart_item_subscription_html": "<p class=\"mnl-hd-cart__item-sub\">Monthly subscription · delivery every 30 days</p>",
  "header-polish.cart_mnl10_first_delivery_html": "1<sup>st</sup> delivery only",
  "header-polish.cart_mnl10_first_order_html": "1<sup>st</sup> order",
  "header-polish.cart_mnl10_ok_mid_html": ") · only <strong style=\"color:#E84E1B;\">",
  "header-polish.cart_mnl10_ok_prefix_html": "<p class=\"mnl-hd-cart__mnl10\" style=\"margin:6px 0 10px;font:600 12.5px/1.45 \\'Manrope\\',ui-sans-serif,sans-serif;color:#1a1a1a;\"><span style=\"color:#15803d;font-weight:800;\">✓</span> <strong>MNL10</strong> applied at checkout (",
  "header-polish.cart_mnl10_ok_relay_prefix_html": "<p class=\"mnl-hd-cart__mnl10\" style=\"margin:6px 0 10px;font:600 12.5px/1.45 \\'Manrope\\',ui-sans-serif,sans-serif;color:#1a1a1a;\"><span style=\"color:#15803d;font-weight:800;\">✓</span> <strong style=\"color:#E84E1B;white-space:nowrap;\">−10 €</strong> <strong>MNL10</strong> applied at checkout (",
  "header-polish.cart_mnl10_ok_relay_suffix_html": ") · <span style=\"color:#15803d;font-weight:800;\">✓</span> <strong>free pickup point</strong> delivery",
  "header-polish.cart_mnl10_ok_suffix_html": "</strong> to go for <strong>free pickup point</strong> delivery",
  "header-polish.cart_mnl10_sub_note_html": "<br><span style=\"font-weight:400;opacity:.85;\">The following deliveries keep the −10% subscription discount.</span>",
  "header-polish.cart_mnl10_teaser_prefix_html": "<p class=\"mnl-hd-cart__mnl10\" style=\"margin:6px 0 10px;font:600 12.5px/1.45 \\'Manrope\\',ui-sans-serif,sans-serif;color:#1a1a1a;\">Only <strong style=\"color:#E84E1B;\">",
  "header-polish.cart_mnl10_teaser_suffix_html": "</strong> to go for −10 € with the code <strong>MNL10</strong> (",
  "header-polish.cart_preview_empty_html": "<p class=\"mnl-hd-cart-preview__empty\">Cart empty</p>",
  "header-polish.cart_promo_apply": "Apply",
  "header-polish.cart_promo_empty_hint": "Type your code (e.g. MNL10) then Apply",
  "header-polish.cart_promo_ko": "Code not applied: check the code or the minimum spend.",
  "header-polish.cart_promo_network_error": "Network error — try again",
  "header-polish.cart_promo_not_applied_suffix": " — not applied",
  "header-polish.cart_promo_ok": "Code applied ✓",
  "header-polish.cart_promo_removed": "Code removed",
  "header-polish.cart_promo_timeout": "Timed out — check your connection",
  "header-polish.cart_ship_home_free_html": "<svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\" aria-hidden=\"true\"><path d=\"M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z\"/></svg><strong>Free home delivery!</strong>",
  "header-polish.cart_ship_home_left_prefix_html": "<svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\" aria-hidden=\"true\"><path d=\"M3 11.5 12 4l9 7.5\"/><path d=\"M5 10v9h14v-9\"/><path d=\"M10 19v-5h4v5\"/></svg>Only <strong>",
  "header-polish.cart_ship_home_left_suffix_html": "</strong> to go for <strong>free home delivery</strong>",
  "header-polish.cart_ship_relay_left_prefix_html": "<svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\" aria-hidden=\"true\"><path d=\"M3 7.5 12 3l9 4.5v9L12 21 3 16.5z\"/><path d=\"M3 7.5 12 12l9-4.5M12 12v9\"/></svg>Only <strong>",
  "header-polish.cart_ship_relay_left_suffix_html": "</strong> to go for the <strong>free pickup point</strong>",
  "header-polish.coach_shortcut_sub": "Shortcut Alt+A · ESC to close",
  "header-polish.coach_shortcut_title": "AI Coach open",
  "header-polish.copy_done_html": "<span style=\"display:inline-flex;align-items:center;gap:4px;\"><span aria-hidden=\"true\">✓</span> Copied</span>",
  "header-polish.copy_toast_title": "Copied to the clipboard",
  "header-polish.logout_confirm_cancel": "Stay logged in",
  "header-polish.logout_confirm_message": "You will be sent back to the home page.",
  "header-polish.logout_confirm_ok": "Log out",
  "header-polish.logout_confirm_title": "Log out?",
  "header-polish.notif_empty_html": "<p class=\"mnl-hd-notif-empty\">No notifications right now <svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px\" aria-hidden=\"true\"><path d=\"M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z\"/></svg></p>",
  "header-polish.notif_marked_read": "Notifications marked as read",
  "header-polish.phone_placeholder_fr": "06 12 34 56 78",
  "header-polish.postal_placeholder_fr": "75001",
  "header-polish.qr_age_ago_prefix": "about ",
  "header-polish.qr_age_days_suffix": "d",
  "header-polish.qr_age_months_suffix": " months",
  "header-polish.qr_age_today": "today",
  "header-polish.qr_age_weeks_suffix": " weeks",
  "header-polish.qr_age_yesterday": "yesterday",
  "header-polish.qr_close_html": "<button type=\"button\" data-mnl-qr-close aria-label=\"Close\" style=\"background:transparent;border:0;color:#94a3b8;font-size:18px;cursor:pointer;padding:4px 8px;line-height:1;font-family:inherit;flex-shrink:0;\">×</button>",
  "header-polish.qr_created_prefix_html": "<div style=\"font-size:11px;color:#94a3b8;font-weight:600;\">Created ",
  "header-polish.qr_cta_html": "<button type=\"button\" data-mnl-qr-go style=\"background:#E84E1B;color:#fff;border:0;padding:10px 14px;border-radius:8px;font-weight:900;font-size:12px;cursor:pointer;font-family:inherit;white-space:nowrap;box-shadow:0 4px 12px rgba(232,78,27,.24);flex-shrink:0;\">1-click</button>",
  "header-polish.qr_default_formula_name": "My formula",
  "header-polish.qr_widget_aria": "Order my last formula again",
  "header-polish.qr_widget_kicker_html": "<div style=\"font-weight:800;color:#E84E1B;font-size:11px;letter-spacing:.02em;margin-bottom:2px;text-transform:uppercase;\">Order again</div>",
  "header-polish.quiz_recovery_close_html": "<button type=\"button\" data-mnl-recover-close aria-label=\"Close\" style=\"background:transparent;border:0;color:rgba(255,255,255,.5);font-size:18px;cursor:pointer;padding:4px 8px;line-height:1;font-family:inherit;\">×</button>",
  "header-polish.quiz_recovery_cta_html": "<button type=\"button\" data-mnl-recover-go style=\"background:#E84E1B;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-weight:800;font-size:12px;cursor:pointer;font-family:inherit;white-space:nowrap;box-shadow:0 4px 12px rgba(232,78,27,.24);\">Resume →</button>",
  "header-polish.quiz_recovery_kicker_html": "<div style=\"font-weight:800;color:#FF7847;font-size:12px;letter-spacing:.02em;margin-bottom:2px;\">QUIZ IN PROGRESS</div>",
  "header-polish.recovery_close_html": "<button type=\"button\" data-mnl-cart-recover-close aria-label=\"Close\" style=\"background:transparent;border:0;color:#94a3b8;font-size:18px;cursor:pointer;padding:4px 8px;line-height:1;font-family:inherit;\">×</button>",
  "header-polish.recovery_cta_html": "<a href=\"/cart\" data-mnl-cart-recover-go style=\"background:#E84E1B;color:#fff;text-decoration:none;padding:8px 14px;border-radius:8px;font-weight:800;font-size:12px;white-space:nowrap;box-shadow:0 4px 12px rgba(232,78,27,.24);\">View →</a>",
  "header-polish.recovery_kicker_html": "<div style=\"font-weight:800;color:#E84E1B;font-size:11px;letter-spacing:.02em;margin-bottom:2px;text-transform:uppercase;\">Cart saved</div>",
  "header-polish.search_article_blog_html": "</strong><small>Le Mag</small></span></a>",
  "header-polish.search_articles_lbl_html": "<p class=\"mnl-hd-search__suggestions-lbl\">Articles</p><div class=\"mnl-hd-search__live-list\">",
  "header-polish.search_bar_placeholder": "Search for an active, a sport…",
  "header-polish.search_no_results_prefix_html": "<p class=\"mnl-hd-search__live-empty\">No instant results for « ",
  "header-polish.search_no_results_suffix_html": " » — the full search also covers the content of the articles.</p>",
  "header-polish.search_pages_lbl_html": "<p class=\"mnl-hd-search__suggestions-lbl\">Pages</p><div class=\"mnl-hd-search__live-list\">",
  "header-polish.search_placeholder_base": "Search: ",
  "header-polish.search_price_from_html": "<small>from ",
  "header-polish.search_products_lbl_html": "<p class=\"mnl-hd-search__suggestions-lbl\">Product</p><div class=\"mnl-hd-search__live-list\">",
  "header-polish.search_see_all_html": "\" class=\"mnl-hd-search__live-all\">See all the results →</a>",
  "header-polish.search_suggestions_lbl_html": "<p class=\"mnl-hd-search__suggestions-lbl\">Suggestions</p><div class=\"mnl-hd-search__tags\">",
  "header-polish.search_tw_actif_sport": "an active, a sport…",
  "header-polish.search_tw_caffeine": "Caffeine",
  "header-polish.search_tw_citrulline": "Citrulline",
  "header-polish.search_tw_creatine": "Creatine",
  "header-polish.search_tw_crossfit": "CrossFit",
  "header-polish.search_tw_endurance": "Endurance",
  "header-polish.search_tw_focus": "Focus",
  "header-polish.search_tw_no_caffeine": "Caffeine-free",
  "header-polish.search_tw_preworkout": "Pre-workout",
  "header-polish.search_tw_pump": "Pump",
  "header-polish.skip_to_content": "↓ Skip to content",
  "header-polish.time_days_suffix": "d",
  "header-polish.time_hours_suffix": "h",
  "header-polish.time_minutes_suffix": " min",
  "header-polish.time_now": "just now",
  "header-polish.tour_s1_msg_html": "You are about to <strong>configure your made-to-measure pre-workout formula</strong> in 60 seconds — 11 clinical actives dosed to the nearest mg for your profile.",
  "header-polish.tour_s1_title": "Welcome to MyNutriLab",
  "header-polish.tour_s2_msg": "Chat with our AI coach: a few quick questions and it calibrates your formula to the nearest mg according to your sport, your weight and your tolerance.",
  "header-polish.tour_s2_title": "AI Coach",
  "header-polish.tour_s3_msg_html": "Your cart is saved. <strong>Pickup point free from 49€</strong> · preparation within 4 working days after payment, plus carrier transit time.",
  "header-polish.tour_s3_title": "Your cart",
  "header-polish.tour_s4_msg": "1-tap access to the home page, search, AI coach, cart and account — always at the bottom of your screen.",
  "header-polish.tour_s4_title": "Quick navigation",
  "header-polish.tour_s5_msg_html": "<strong>SSL encrypted 3D-Secure</strong> payment (Visa / MC / AMEX / PayPal / Apple/Google Pay). French brand, DGCCRF compliant. Legal guarantee (faulty product replaced).",
  "header-polish.tour_s5_title": "Payment & trust",
  "header.cart_aria_prefix": "My basket (",
  "header.cart_band_html": " <div class=\"mnl-hd-cart__band\"> <p class=\"mnl-hd-cart__band-title\"><svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\" aria-hidden=\"true\"><path d=\"M13 2 5 13h6l-1 9 9-12h-6l1-8z\"/></svg>MyNutriLab members — exclusive perks</p> <div class=\"mnl-hd-cart__band-btns\"> <a href=\"/customer_authentication/login?return_to=%2Fpages%2Faccount\" class=\"mnl-hd-cart__band-btn\">Log in</a> <a href=\"/customer_authentication/login?return_to=%2Fpages%2Faccount\" class=\"mnl-hd-cart__band-btn mnl-hd-cart__band-btn--solid\">Sign up</a> </div> </div>",
  "header.cart_checkout_html": "\" class=\"mnl-hd-cart__checkout\"><svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\" aria-hidden=\"true\"><rect x=\"5\" y=\"11\" width=\"14\" height=\"9\" rx=\"2\"/><path d=\"M8 11V8a4 4 0 0 1 8 0v3\"/></svg>Secure checkout →</a> <a href=\"/cart\" class=\"mnl-hd-cart__continue\">View my basket</a> </div> </div>",
  "header.cart_empty_btn_html": "\" class=\"mnl-hd-cart__empty-btn\"><svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\" style=\"vertical-align:-2px;margin-right:6px\"><line x1=\"4\" x2=\"4\" y1=\"21\" y2=\"14\"/><line x1=\"4\" x2=\"4\" y1=\"10\" y2=\"3\"/><line x1=\"12\" x2=\"12\" y1=\"21\" y2=\"12\"/><line x1=\"12\" x2=\"12\" y1=\"8\" y2=\"3\"/><line x1=\"20\" x2=\"20\" y1=\"21\" y2=\"16\"/><line x1=\"20\" x2=\"20\" y1=\"12\" y2=\"3\"/><line x1=\"2\" x2=\"6\" y1=\"14\" y2=\"14\"/><line x1=\"10\" x2=\"14\" y1=\"8\" y2=\"8\"/><line x1=\"18\" x2=\"22\" y1=\"16\" y2=\"16\"/></svg>Build my formula →</a> </div> </div> </div>",
  "header.cart_empty_html": " <div class=\"mnl-hd-cart__head\"> <h2 class=\"mnl-hd-cart__title\">My basket</h2> </div> <div class=\"mnl-hd-cart__items\"> <div class=\"mnl-hd-cart__empty\"> <div class=\"mnl-hd-cart__empty-icon\"><svg width=\"1em\" height=\"1em\" viewBox=\"8 8 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><g transform=\"translate(8 8)\" stroke-width=\"1.8\"><path d=\"M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z\"/><path d=\"M3 6h18\"/><path d=\"M16 10a4 4 0 0 1-8 0\"/></g></svg></div> <h3 class=\"mnl-hd-cart__empty-title\">Your basket is empty</h3> <p class=\"mnl-hd-cart__empty-sub\">Build your made-to-measure formula and come back.</p> <a href=\"",
  "header.cart_estimate_lbl_html": " <div class=\"mnl-hd-cart__estimate\"> <span>Estimated delivery</span> <span>",
  "header.cart_head_prefix_html": " <div class=\"mnl-hd-cart__head\"> <h2 class=\"mnl-hd-cart__title\">My basket <span class=\"mnl-hd-cart__title-count\">· ",
  "header.cart_item_remove_html": "\">Remove</button> </div> </div> <div class=\"mnl-hd-cart__item-price\">",
  "header.cart_preview_other_plural_s": "s",
  "header.cart_preview_other_word": " other",
  "header.cart_promo_apply_html": "\"> <button type=\"button\" class=\"mnl-hd-cart__promo-btn\" data-mnl-promo-apply>Apply</button> </div>",
  "header.cart_promo_code_prefix_html": " <div class=\"mnl-hd-cart__promo-applied\" style=\"display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;background:#fff3e6;border:1.5px solid rgba(249,115,22,.45);border-radius:10px;\"> <span style=\"font-size:12.5px;font-weight:700;color:#101418;line-height:1.4;\">Code <strong style=\"color:#C2410C;letter-spacing:.04em;text-transform:uppercase;\">",
  "header.cart_promo_form_html": " <div class=\"mnl-hd-cart__promo-form\" data-mnl-promo-form> <input type=\"text\" class=\"mnl-hd-cart__promo-input\" placeholder=\"Your code\" autocomplete=\"off\" data-mnl-promo-input value=\"",
  "header.cart_promo_remove_html": "</span> <button type=\"button\" class=\"mnl-hd-cart__promo-remove\" data-mnl-promo-remove aria-label=\"Remove the promo code\" style=\"display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;min-height:38px;flex:none;padding:0;background:#101418;color:#fff;border:none;border-radius:8px;cursor:pointer;\"> <svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" aria-hidden=\"true\"><path d=\"M6 6l12 12M18 6L6 18\"/></svg> </button> </div>",
  "header.cart_promo_summary_html": "> <summary> <span><svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"display:inline-block;vertical-align:-2px;margin-right:4px\" aria-hidden=\"true\"><path d=\"M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z\"/><circle cx=\"7.5\" cy=\"7.5\" r=\"1.3\"/></svg>I have a promo code</span> <span style=\"display:inline-flex;align-items:center;gap:8px;\">",
  "header.cart_qty_minus_html": "\" aria-label=\"Decrease\">−</button> <span>",
  "header.cart_qty_plus_html": "\" aria-label=\"Increase\">+</button> </div> <button type=\"button\" class=\"mnl-hd-cart__item-remove\" data-mnl-remove=\"",
  "header.cart_relaynote_html": " <p class=\"mnl-hd-cart__relaynote\" style=\"margin:2px 0 8px;font:600 11.5px/1.45 Manrope,ui-sans-serif,sans-serif;color:#5f5e5a;display:flex;align-items:flex-start;gap:6px;\"> <svg viewBox=\"0 0 24 24\" width=\"14\" height=\"14\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"flex:0 0 auto;margin-top:1px\" aria-hidden=\"true\"><path d=\"M12 21s-7-6.3-7-11a7 7 0 0 1 14 0c0 4.7-7 11-7 11z\"/><circle cx=\"12\" cy=\"10\" r=\"2.5\"/></svg> <span>Pickup&nbsp;point? You will choose your Mondial&nbsp;Relay pickup point right after payment.</span> </p> <a href=\"",
  "header.cart_threshold_home_html": "</strong>Home</div> </div> </div>",
  "header.cart_threshold_relay_html": "</strong>Pickup point</div> <div class=\"",
  "header.cart_total_html": " <div class=\"mnl-hd-cart__total\"> <div> <span class=\"mnl-hd-cart__total-lbl\">Subtotal</span> <p class=\"mnl-hd-cart__total-sub\">Taxes included · delivery at checkout</p> </div> <span class=\"mnl-hd-cart__total-val\">",
  "home_hero.opt_5_plus": "5 and more",
  "home_hero.opt_ajoute_la": "Add it",
  "home_hero.opt_apres_midi": "In the afternoon",
  "home_hero.opt_autre_sport": "Another sport",
  "home_hero.opt_badminton": "Badminton",
  "home_hero.opt_basket": "Basketball",
  "home_hero.opt_boxe": "Boxing",
  "home_hero.opt_course_route": "Road running",
  "home_hero.opt_crossfit": "CrossFit",
  "home_hero.opt_cyclisme": "Cycling",
  "home_hero.opt_deja_creatine": "I already take it",
  "home_hero.opt_endurance": "Endurance",
  "home_hero.opt_endurance_obj": "Endurance",
  "home_hero.opt_energie": "Energy",
  "home_hero.opt_football": "Football",
  "home_hero.opt_force": "Strength",
  "home_hero.opt_grappling": "Grappling / Wrestling",
  "home_hero.opt_habitue": "Used to it",
  "home_hero.opt_handball": "Handball",
  "home_hero.opt_hyrox": "Hyrox",
  "home_hero.opt_marathon": "Marathon",
  "home_hero.opt_matin": "In the morning",
  "home_hero.opt_mma": "MMA",
  "home_hero.opt_muay_thai": "Muay Thai",
  "home_hero.opt_musculation": "Weight training",
  "home_hero.opt_normal": "Normal",
  "home_hero.opt_padel": "Padel",
  "home_hero.opt_powerlifting": "Powerlifting",
  "home_hero.opt_pump": "Pump",
  "home_hero.opt_rugby": "Rugby",
  "home_hero.opt_sans_creatine": "No creatine",
  "home_hero.opt_sensible": "Sensitive",
  "home_hero.opt_soir": "In the evening",
  "home_hero.opt_sport_collectif": "Team sport",
  "home_hero.opt_sport_combat": "Combat sport",
  "home_hero.opt_sport_raquette": "Racket sport",
  "home_hero.opt_squash": "Squash",
  "home_hero.opt_tard_soir": "Late in the evening",
  "home_hero.opt_tennis": "Tennis",
  "home_hero.opt_trail": "Trail",
  "home_hero.opt_zero_cafeine": "Zero caffeine",
  "home_hero.q_caf": "How are you with caffeine?",
  "home_hero.q_crea": "What about creatine?",
  "home_hero.q_freq": "How many sessions a week?",
  "home_hero.q_obj": "What are you after?",
  "home_hero.q_sport": "What sport do you do?",
  "home_hero.q_time": "When do you usually train?",
  "home_hero.scan_camera_refusee": "Camera refused — take a photo of the QR code instead.",
  "home_hero.scan_lecture_impossible": "Cannot read it — try again.",
  "home_hero.scan_lecture_impossible_ici": "Cannot read it here — go through your orders.",
  "home_hero.scan_lecture_photo": "Reading the photo…",
  "home_hero.scan_mode_photo": "Take a photo of the QR code, we will read it here.",
  "home_hero.scan_ok": "Label recognised — your formula is on its way…",
  "home_hero.scan_photo_illisible": "Photo unreadable — try again.",
  "home_hero.scan_qr_etranger": "This QR code is not a MyNutriLab label. Try again, or go through your orders.",
  "home_hero.scan_qr_introuvable": "No QR code found on the photo — frame the label more closely.",
  "home_hero.scan_vise": "Point at the QR code on the label…",
  "home_hero.sq_collectif": "Which team sport?",
  "home_hero.sq_combat": "Which combat sport?",
  "home_hero.sq_endurance": "Which endurance sport?",
  "home_hero.sq_raquette": "Which racket sport?",
  "home_hero.sq_salle": "What do you do in the gym?",
  "hub.end_cta_ig_html": "\" target=\"_blank\" rel=\"noopener\">Follow on Instagram</a>",
  "hub.end_cta_main_html": "\">Build my formula →</a>",
  "hub.end_sub_html": "<p class=\"mnl-sto-end__sub\">Your formula, your doses, your energy — calibrated to the mg.</p>",
  "hub.end_title_html": "<h3 class=\"mnl-sto-end__title\">That was MyNutriLab.</h3>",
  "hub.see_more": "See more",
  "hub.sound_label": "Sound",
  "hub.sound_off_aria": "Mute",
  "hub.sound_on_aria": "Unmute",
  "hub.sound_on_label": "Sound on",
  "mnl.coach.chip.autre": "Other",
  "mnl.coach.chip.caf_habitue": "Used to it (3+ coffees/day)",
  "mnl.coach.chip.caf_normale": "Normal (1-2 coffees/day)",
  "mnl.coach.chip.caf_sensible": "Sensitive to caffeine",
  "mnl.coach.chip.caf_tres_tolerant": "Very tolerant",
  "mnl.coach.chip.caf_zero": "No caffeine",
  "mnl.coach.chip.combat": "Combat sports",
  "mnl.coach.chip.crea_non": "No, include it in my formula",
  "mnl.coach.chip.crea_oui": "Yes, I already take some",
  "mnl.coach.chip.cyclisme": "Cycling",
  "mnl.coach.chip.exp_debutant": "Beginner (1-2 times)",
  "mnl.coach.chip.exp_expert": "Long-time user",
  "mnl.coach.chip.exp_jamais": "Never tried",
  "mnl.coach.chip.exp_regulier": "Regular (>3 months)",
  "mnl.coach.chip.fmt_pro": "Pro 60 servings",
  "mnl.coach.chip.fmt_standard": "Standard 30 servings",
  "mnl.coach.chip.fmt_starter": "Starter 15 servings",
  "mnl.coach.chip.musculation": "Strength training",
  "mnl.coach.chip.nom_perso": "I'll type my own name",
  "mnl.coach.chip.running_trail": "Running / Trail",
  "mnl.coach.chip.sport_collectif": "Team sports",
  "mnl.coach.welcome": "Hi, I'm the MyNutriLab assistant.\nI'll help you build your formula in a few questions.\n\nWhat's your main sport?",
  "pages2.b2b.js_siret_err_len": "The SIRET number must contain 14 digits",
  "pages2.b2b.js_siret_err_luhn": "Please check the number (incorrect Luhn check digit)",
  "pages2.b2b.js_siret_err_title": "Invalid SIRET number",
  "pages2.loyalty.js_more_before": "Another ",
  "pages2.loyalty.js_more_end": " pts required)",
  "pages2.loyalty.js_more_mid": " pts to unlock ",
  "pages2.loyalty.js_pts_suffix": " pts",
  "pages2.loyalty.js_unlocked": "✓ Unlocked",
  "pages2.loyalty.js_unlocked_title": "You have reached and passed this level",
  "pages2.mealprep.js_toast_sub": "The PDF generator is being set up. Come back in a few days, we will let newsletter subscribers know.",
  "pages2.mealprep.js_toast_title": "PDF being finalised",
  "pdp3.atc_default": "Create my formula with the coach — 3 min",
  "pdp3.ing.betaalanine.halflife": "25 min (but the effect builds over 4 weeks)",
  "pdp3.ing.betaalanine.mechanism": "Precursor of muscle carnosine. Carnosine buffers lactic acid during intense effort, delaying acidosis and fatigue. Cumulative effect: it takes 2-4 weeks of daily use to saturate the muscles.",
  "pdp3.ing.betaalanine.name": "Beta-Alanine",
  "pdp3.ing.betaalanine.study_result": "Precursor of muscle carnosine. Beta-Alanine 4-6g a day for 4 weeks: studied on efforts of 1 to 4 minutes through saturation with carnosine (pH buffer), meta-analysis of 40 studies (Saunders 2017, BJSM). Tingling (paraesthesia) is normal and harmless.",
  "pdp3.ing.betaalanine.study_source": "British Journal of Sports Medicine, 2017",
  "pdp3.ing.betaalanine.study_title": "Meta-analysis of 40 studies (Saunders et al., 2017)",
  "pdp3.ing.betaalanine.sub": "Anti lactic acidosis, cumulative effect over 4 weeks",
  "pdp3.ing.betaalanine.timing": "Daily (cumulative effect over 2-4 weeks)",
  "pdp3.ing.betaine.halflife": "14 hours",
  "pdp3.ing.betaine.max_dose": "400 mg (DGCCRF/EFSA cap)",
  "pdp3.ing.betaine.mechanism": "Methyl group donor, derived from beetroot. Cellular osmolyte.",
  "pdp3.ing.betaine.name": "Anhydrous Betaine",
  "pdp3.ing.betaine.study_result": "Betaine capped at 400mg a day in France (DGCCRF, EFSA 2019 source) — intake in addition to the diet. The Cholewa 2013 studies on 2.5g a day cannot be transposed to the French regulatory framework.",
  "pdp3.ing.betaine.study_source": "DGCCRF — ingredients & substances database · EFSA Journal 2019;5658",
  "pdp3.ing.betaine.study_title": "EFSA opinion 2019 (EFSA J. 2019;5658)",
  "pdp3.ing.betaine.sub": "Strength and anabolism — extracted from beetroot",
  "pdp3.ing.betaine.timing": "Before exercise",
  "pdp3.ing.caffeine.halflife": "5-6 hours",
  "pdp3.ing.caffeine.max_dose": "200 mg (ANSES cap)",
  "pdp3.ing.caffeine.mechanism": "Antagonist of the A1 and A2A adenosine receptors. Studies describe an effect on the release of dopamine and noradrenaline, as well as work on calcium mobilisation.",
  "pdp3.ing.caffeine.name": "Anhydrous Caffeine USP",
  "pdp3.ing.caffeine.study_result": "Caffeine 3-6mg/kg: dose-dependent effect observed on strength, power and muscular endurance (meta-analysis of 21 studies, Grgic 2020).",
  "pdp3.ing.caffeine.study_source": "Sports Medicine, 2020 · DOI: 10.1007/s40279-020-01367-9",
  "pdp3.ing.caffeine.study_title": "Meta-analysis of 21 studies (Grgic et al., 2020)",
  "pdp3.ing.caffeine.sub": "Anhydrous caffeine USP — meta-analysis of 21 studies (Grgic 2020)",
  "pdp3.ing.caffeine.timing": "20-45 min before exercise",
  "pdp3.ing.citrulline.halflife": "0.7-1 h",
  "pdp3.ing.citrulline.mechanism": "Converted into arginine in the kidneys, which then produces nitric oxide (NO). NO dilates the blood vessels, increasing blood flow to the muscle — that is the pump. More effective than arginine taken directly, because it bypasses hepatic degradation.",
  "pdp3.ing.citrulline.name": "Pure L-Citrulline",
  "pdp3.ing.citrulline.study_result": "The science — Citrulline 8 g: performance on repeated sets to failure and perceived recovery after exercise observed in a meta-analysis of 12 studies (Trexler 2019, EJSS). The mechanism described goes through the arginine–nitric oxide pathway (vasodilation).",
  "pdp3.ing.citrulline.study_source": "European Journal of Sport Science, 2019",
  "pdp3.ing.citrulline.study_title": "Meta-analysis of 12 studies (Trexler et al., 2019)",
  "pdp3.ing.citrulline.sub": "Hard pump through blood flow and NO",
  "pdp3.ing.citrulline.timing": "30-60 min before exercise",
  "pdp3.ing.creatine.halflife": "3 hours (but cumulative muscle saturation)",
  "pdp3.ing.creatine.max_dose": "3 g (EFSA claim Reg 432/2012: ≥ 3 g a day)",
  "pdp3.ing.creatine.mechanism": "Regenerates ATP (cellular energy) on explosive efforts under 30s by giving a phosphate back to ADP through phosphocreatine. Increases the muscle stores of phosphocreatine (PCr).",
  "pdp3.ing.creatine.name": "Creatine Monohydrate",
  "pdp3.ing.creatine.study_result": "Creatine 3-5g a day: improved performance on repeated short, intense efforts. Authorised EFSA claim Reg 432/2012: « creatine increases physical performance in successive bursts of short-term, high intensity exercise » (from 3g a day).",
  "pdp3.ing.creatine.study_source": "Journal of the International Society of Sports Nutrition, 2017 · EFSA Reg 432/2012",
  "pdp3.ing.creatine.study_title": "ISSN Position Stand — Meta-analysis of 500+ studies (Kreider et al., 2017)",
  "pdp3.ing.creatine.sub": "The most studied active in the world — certified German purity",
  "pdp3.ing.creatine.timing": "Daily (timing does not matter — saturation effect)",
  "pdp3.ing.electrolytes.halflife": "Variable",
  "pdp3.ing.electrolytes.mechanism": "A blend of potassium (cells), magnesium (muscle and nerve) and sodium (extracellular). Maintains water and electrolyte balance, nerve conduction and muscle contraction. Crucial on long efforts or in the heat.",
  "pdp3.ing.electrolytes.name": "Electrolyte complex",
  "pdp3.ing.electrolytes.study_result": "Electrolyte replacement during efforts over 60 min: support for performance, prevention of cramp and heat tolerance (IOC Consensus 2018, BJSM). Authorised EFSA claims: « magnesium contributes to normal muscle function » and « contributes to the reduction of tiredness and fatigue ».",
  "pdp3.ing.electrolytes.study_source": "British Journal of Sports Medicine, IOC Consensus 2018",
  "pdp3.ing.electrolytes.study_title": "IOC Consensus Statement",
  "pdp3.ing.electrolytes.sub": "Hydration and electrolyte balance",
  "pdp3.ing.electrolytes.timing": "Before and during exercise",
  "pdp3.ing.glycerol.halflife": "30-45 min",
  "pdp3.ing.glycerol.mechanism": "Glycerol attracts and holds water in the cell compartments (hyperhydration). Osmotic effect: it increases plasma volume and intramuscular water retention.",
  "pdp3.ing.glycerol.name": "Glycerol",
  "pdp3.ing.glycerol.study_result": "Glycerol + 500ml of water before exercise: support for blood volume and for performance in a hot environment through cellular hyperhydration (Patlar 2012 study).",
  "pdp3.ing.glycerol.study_source": "Journal of Sports Science & Medicine, 2012",
  "pdp3.ing.glycerol.study_title": "Study (Patlar et al., 2012)",
  "pdp3.ing.glycerol.sub": "Cellular hyperhydration for a volumetric pump",
  "pdp3.ing.glycerol.timing": "30-60 min before, with 500ml of water",
  "pdp3.ing.pinksalt.halflife": "Variable",
  "pdp3.ing.pinksalt.mechanism": "A source of pure unrefined sodium, containing 84 trace minerals (potassium, magnesium, iron). Sodium maintains extracellular osmotic balance and amplifies the volumetric pump effect. Crucial for nerve conduction.",
  "pdp3.ing.pinksalt.name": "Himalayan Pink Salt",
  "pdp3.ing.pinksalt.study_result": "Sodium before exercise (300-600mg): makes up for the sodium lost through sweat, which varies with the individual and the intensity (ACSM Position Stand 2007). Often paired with glycerol (an osmolyte) in hyperhydration protocols.",
  "pdp3.ing.pinksalt.study_source": "American College of Sports Medicine, 2007",
  "pdp3.ing.pinksalt.study_title": "ACSM Position Stand",
  "pdp3.ing.pinksalt.sub": "Pure sodium + 84 trace minerals",
  "pdp3.ing.pinksalt.timing": "Before exercise",
  "pdp3.ing.piperine.halflife": "Variable",
  "pdp3.ing.piperine.mechanism": "Patented black pepper extract (95% standardised piperine). Inhibits intestinal and hepatic enzymes (CYP3A4, glucuronidation). Improves the bioavailability of fat-soluble actives.",
  "pdp3.ing.piperine.name": "Piperine",
  "pdp3.ing.piperine.study_result": "The « absorption booster »: it helps your body take up the actives better. The science — piperine supports the bioavailability of fat-soluble actives (Shoba 1998 study, curcumin + piperine; the effect varies with the composition).",
  "pdp3.ing.piperine.study_source": "Badmaev et al., 1999",
  "pdp3.ing.piperine.study_title": "Badmaev et al. study (1999) · Curcumin bioavailability reference (Shoba 1998)",
  "pdp3.ing.piperine.sub": "Improves the bioavailability of fat-soluble actives",
  "pdp3.ing.piperine.timing": "With the other actives",
  "pdp3.ing.taurine.halflife": "1 hour",
  "pdp3.ing.taurine.mechanism": "A sulphur amino acid abundant in skeletal and cardiac muscle. Takes part in osmotic balance, the regulation of intracellular calcium and antioxidant defences.",
  "pdp3.ing.taurine.name": "Taurine USP",
  "pdp3.ing.taurine.study_result": "Taurine 1-3g before exercise: support for endurance performance and for perceived muscle recovery after exercise (meta-analysis of 19 studies, Waldron 2018).",
  "pdp3.ing.taurine.study_source": "Sports Medicine, 2018",
  "pdp3.ing.taurine.study_title": "Meta-analysis of 19 studies (Waldron et al., 2018)",
  "pdp3.ing.taurine.sub": "Anti-cramp and muscle recovery",
  "pdp3.ing.taurine.timing": "60-120 min before exercise",
  "pdp3.ing.theanine.halflife": "0.8-1.2 h",
  "pdp3.ing.theanine.mechanism": "Green tea amino acid. Increases alpha waves (a state of alert relaxation). Modulates GABA and glutamate. Often paired with caffeine in the studies on attention (Kahathuduwa 2017).",
  "pdp3.ing.theanine.name": "L-Theanine",
  "pdp3.ing.theanine.study_result": "L-Theanine 200mg + Caffeine 160mg: support for attentional accuracy and a reduction in perceived mental fatigue vs caffeine alone (Kahathuduwa 2017 study).",
  "pdp3.ing.theanine.study_source": "Nutritional Neuroscience, 2017",
  "pdp3.ing.theanine.study_title": "Double-blind study (Kahathuduwa et al., 2017)",
  "pdp3.ing.theanine.sub": "Green tea amino acid, often paired with caffeine (up to 1:1)",
  "pdp3.ing.theanine.timing": "With the caffeine",
  "pdp3.ing.tyrosine.halflife": "2 hours",
  "pdp3.ing.tyrosine.mechanism": "Direct precursor of dopamine, noradrenaline and adrenaline. Under stress (intense effort, fatigue, short sleep), the catecholamine reserves run down — tyrosine keeps their synthesis going.",
  "pdp3.ing.tyrosine.name": "L-Tyrosine USP",
  "pdp3.ing.tyrosine.study_result": "In the Mahoney 2007 study, a 2 g intake maintains cognitive performance (working memory, alertness) over 4-6 h under intense physical stress. That is the dose of the study protocol, not the dose in your formula: the slider goes up to 1000 mg per serving.",
  "pdp3.ing.tyrosine.study_source": "Physiology & Behavior, 2007",
  "pdp3.ing.tyrosine.study_title": "Study (Mahoney et al., 2007)",
  "pdp3.ing.tyrosine.sub": "Direct precursor of dopamine under stress",
  "pdp3.ing.tyrosine.timing": "30-60 min before exercise",
  "pdp3.js_calc_mnl10": " · MNL10: ",
  "pdp3.js_calc_sessions": " sessions a year with the Standard size",
  "pdp3.js_calc_then": "/session on the 1st order, then ",
  "pdp3.js_coach_down_sub": "Taking you to the manual builder — you can still create your formula.",
  "pdp3.js_coach_down_title": "AI Coach unavailable",
  "pdp3.js_email_invalid": "Invalid email — check the format",
  "pdp3.js_goal_sub": "We carry on with your sport to calibrate your formula.",
  "pdp3.js_goal_title": "Goal pre-filled",
  "pdp3.js_import": "Import",
  "pdp3.js_loaded_suffix": " loaded",
  "pdp3.js_network_error": "Network error — check your connection",
  "pdp3.js_preset_prefix": "Preset formula ",
  "pdp3.js_rating_link": " reviews — see the reviews",
  "pdp3.js_rating_note": "Rating ",
  "pdp3.js_rating_of5": " out of 5, ",
  "pdp3.js_recipe_locked": "Choose your size and your flavor.",
  "pdp3.js_recipe_prefix": "Recipe ",
  "pdp3.js_recipe_unlocked": "You can change it, then choose your size and your flavor.",
  "pdp3.js_reviews_suffix": " reviews",
  "pdp3.js_sending": "Sending...",
  "pdp3.js_shared_fallback": "Personalised formula",
  "pdp3.js_shared_title": "A formula has been shared with you!",
  "pdp3.js_signup_error": "Error — try again or contact us",
  "pdp3.js_signup_ok": "Here we go! MNL10 code by email in 1-2 min",
  "pdp3.js_signup_unavailable": "Sign-up temporarily unavailable — try again later",
  "pdp3.js_sport_bodybuilding": "Bodybuilding",
  "pdp3.js_sport_combat": "Combat / Boxing",
  "pdp3.js_sport_crossfit": "Crossfit",
  "pdp3.js_sport_endurance": "Endurance / Marathon",
  "pdp3.js_sport_powerlifting": "Powerlifting / Strength",
  "pdp3.js_sticky_coach_aria": "AI Coach — configure your formula",
  "pdp3.js_view_cart": "See my cart",
  "pdp3.pillar.mental_drive": "Mental Drive",
  "pdp3.pillar.muscle_pump": "Muscle Pump",
  "pdp3.pillar.optimization": "Optimization",
  "pdp3.pillar.power_stamina": "Power & Stamina",
  "pdp_details.js_actif_betaalanine": "Beta-Alanine",
  "pdp_details.js_actif_caffeine": "Anhydrous Caffeine USP",
  "pdp_details.js_actif_citrulline": "Pure L-Citrulline",
  "pdp_details.js_actif_creatine": "Creatine Monohydrate",
  "pdp_details.js_actif_electrolytes": "Electrolyte complex",
  "pdp_details.js_actif_glycerol": "Glycerol (GlycoPump® 65 %)",
  "pdp_details.js_actif_pinksalt": "Himalayan Pink Salt",
  "pdp_details.js_actif_piperine": "Piperine",
  "pdp_details.js_actif_taurine": "Taurine USP",
  "pdp_details.js_actif_theanine": "L-Theanine",
  "pdp_details.js_actif_tyrosine": "L-Tyrosine USP",
  "pdp_details.js_cert_body_1": "Hello,\\n\\nI would like to receive the supplier sheet / the certificate of analysis of the latest batch for: ",
  "pdp_details.js_cert_body_2": ".\\n\\nThank you!",
  "pdp_details.js_cert_subject": "Supplier certificate request — ",
  "pdp_details.js_toast_action": "Request",
  "pdp_details.js_toast_sub": "We reply through the contact form — tap to pre-fill it",
  "pdp_details.js_toast_title": "Certificate on request",
  "product.atc_price_soldout": "Out of stock",
  "product.cancel": "Cancel",
  "product.close": "Close",
  "product.compare_aria": "Size comparison",
  "product.compare_choose": "Choose",
  "product.compare_soldout": "Sold out",
  "product.fmt_pro_badge": "Regular",
  "product.fmt_pro_best": "2 months · -25% €/serving",
  "product.fmt_pro_subt": "Experienced athletes, subscription recommended",
  "product.fmt_standard_badge": "Recommended",
  "product.fmt_standard_best": "1 month · 4 sessions/week",
  "product.fmt_standard_subt": "The size we advise — good €/serving ratio to start with",
  "product.fmt_starter_badge": "Beginner",
  "product.fmt_starter_best": "Trial · 2 weeks",
  "product.fmt_starter_subt": "Ideal for testing before subscribing",
  "product.lightbox_aria": "Enlarged image",
  "product.notif_formula_saved": "Formula saved",
  "product.opt_soldout": "sold out",
  "product.option_fallback": "Option",
  "product.quicksave_placeholder": "My Monday pre-workout…",
  "product.quicksave_prompt_msg": "Give it a name so you can find it easily later.",
  "product.quicksave_prompt_title": "Name of this configuration",
  "product.rating_1": "Disappointing",
  "product.rating_2": "Average",
  "product.rating_3": "Fair",
  "product.rating_4": "Good",
  "product.rating_5": "Excellent!",
  "product.review_sending": "Sending…",
  "product.save_cta": "Save",
  "product.stock_last_one_html": "<strong>Last one</strong> in stock — order now!",
  "product.stock_two_left_html": "<strong>Last 2</strong> in stock — order quickly!",
  "product.toast_config_saved": "Configuration saved",
  "product.toast_review_sent": "Review sent for moderation",
  "product.toast_review_sent_sub": "+50 loyalty pts credited after publication",
  "product.toast_save_error": "Save failed",
  "product.toast_save_error_sub": "Local storage full",
  "product.toast_see_formulas": "See my formulas",
  "product.toast_soon_sub": "The full reviews page is coming — for now, scroll through the selection above",
  "product.toast_soon_title": "Coming soon",
  "product.zoom_aria": "Enlarge the image (Enter or Esc to close)",
  "recettes.copy_dialog_title": "Copy the recipe",
  "recettes.modal_default_title": "Recipe",
  "recettes.plural_s": "s",
  "recettes.prompt_copy": "Copy this recipe:",
  "recettes.r10_ing_2": "200ml green apple juice (no added sugar)",
  "recettes.r10_ing_3": "4-5 ice cubes",
  "recettes.r10_step_1": "Mix the juice + pre-workout in a shaker",
  "recettes.r10_step_3": "Pour over the ice cubes",
  "recettes.r10_step_4": "Cool and tangy",
  "recettes.r11_ing_1": "1 serving pre-workout (Mild)",
  "recettes.r11_ing_2": "200ml plant milk (oat or almond)",
  "recettes.r11_ing_3": "1 tsp unsweetened cocoa",
  "recettes.r11_ing_5": "1 tsp maple syrup (optional)",
  "recettes.r11_step_1": "Heat the milk on a low heat (60°C max)",
  "recettes.r11_step_2": "Add the cocoa and the cinnamon, whisk",
  "recettes.r11_step_3": "Off the heat, add the pre-workout (never over the heat)",
  "recettes.r11_step_4": "Stir and drink",
  "recettes.r12_ing_2": "300g deseeded watermelon",
  "recettes.r12_ing_3": "5 mint leaves",
  "recettes.r12_ing_4": "½ lemon",
  "recettes.r12_step_1": "Blend the watermelon and the mint",
  "recettes.r12_step_2": "Strain the juice to remove the pulp (optional)",
  "recettes.r12_step_3": "Add the lemon and the pre-workout",
  "recettes.r12_step_4": "Stir well and serve very cold",
  "recettes.r1_ing_1": "1 serving (10g) of MyNutriLab pre-workout",
  "recettes.r1_ing_2": "250-300ml of cold water",
  "recettes.r1_ing_3": "3-4 ice cubes",
  "recettes.r1_step_1": "Pour the cold water into a shaker",
  "recettes.r1_step_2": "Add the serving of pre-workout",
  "recettes.r1_step_3": "Shake for 15 seconds",
  "recettes.r1_step_4": "Drink 20-30 min before your training session",
  "recettes.r2_ing_1": "1 serving pre-workout",
  "recettes.r2_ing_2": "200ml cold water",
  "recettes.r2_ing_3": "100g red berries (fresh or frozen)",
  "recettes.r2_ing_4": "1 tbsp chia seeds (optional)",
  "recettes.r2_step_1": "Put all the ingredients in a blender",
  "recettes.r2_step_2": "Blend for 30 seconds at max power",
  "recettes.r2_step_3": "Pour into a large glass",
  "recettes.r2_step_4": "Drink within 5 min",
  "recettes.r3_ing_1": "1 serving pre-workout (caffeine-free or Mild)",
  "recettes.r3_ing_2": "1 espresso (30ml)",
  "recettes.r3_ing_3": "150ml cold water",
  "recettes.r3_ing_4": "2 ice cubes",
  "recettes.r3_step_1": "Make an espresso and let it cool for 5 min",
  "recettes.r3_step_2": "Pour water + pre-workout into a shaker",
  "recettes.r3_step_3": "Add the cooled espresso",
  "recettes.r3_step_4": "Shake hard, add ice cubes",
  "recettes.r4_ing_2": "200ml sparkling water",
  "recettes.r4_ing_3": "½ lime",
  "recettes.r4_ing_4": "8 mint leaves",
  "recettes.r4_ing_5": "4-5 crushed ice cubes",
  "recettes.r4_step_1": "Muddle the mint in the bottom of a glass",
  "recettes.r4_step_2": "Add the lime juice",
  "recettes.r4_step_3": "Pour in the pre-workout pre-mixed with a little water",
  "recettes.r4_step_4": "Top up with the sparkling water and crushed ice",
  "recettes.r5_ing_2": "200ml water",
  "recettes.r5_ing_3": "50g frozen blackcurrants",
  "recettes.r5_ing_4": "50g frozen blueberries",
  "recettes.r5_ing_5": "1 tbsp agave syrup (optional)",
  "recettes.r5_step_1": "Everything in the blender",
  "recettes.r5_step_2": "Blend for 20 seconds",
  "recettes.r5_step_3": "It is ready!",
  "recettes.r6_ing_1": "1 serving pre-workout (Mild/caffeine-free)",
  "recettes.r6_ing_2": "200ml warm water (40°C max)",
  "recettes.r6_ing_3": "1 cm grated fresh ginger",
  "recettes.r6_ing_4": "1 tsp honey",
  "recettes.r6_ing_5": "1 pinch of cinnamon",
  "recettes.r6_step_1": "Infuse the ginger in the warm water for 5 min",
  "recettes.r6_step_2": "Strain and let it cool a little",
  "recettes.r6_step_3": "Add the pre-workout, the honey and the cinnamon",
  "recettes.r6_step_4": "Stir and drink within 10 min",
  "recettes.r7_ing_2": "150ml cold brew",
  "recettes.r7_ing_3": "100ml cold water",
  "recettes.r7_ing_4": "5-6 ice cubes",
  "recettes.r7_step_1": "Make your cold brew the night before (16h cold infusion)",
  "recettes.r7_step_2": "Mix water + pre-workout in a large glass",
  "recettes.r7_step_3": "Add the cold brew on top",
  "recettes.r7_step_4": "Ice cubes and away you go",
  "recettes.r8_ing_2": "150ml coconut milk",
  "recettes.r8_ing_3": "50g frozen mango",
  "recettes.r8_ing_4": "50g passion fruit (fresh or pulp)",
  "recettes.r8_ing_5": "50ml water",
  "recettes.r8_step_1": "All the ingredients in the blender",
  "recettes.r8_step_2": "Blend for 30 seconds",
  "recettes.r8_step_3": "Taste and adjust with a little water if it is too thick",
  "recettes.r8_step_4": "Serve cold",
  "recettes.r9_ing_2": "200ml coconut water",
  "recettes.r9_ing_3": "50g pineapple chunks",
  "recettes.r9_ing_5": "4 ice cubes",
  "recettes.r9_step_3": "Pour into a tropical-style glass",
  "recettes.r9_step_4": "Decorate with a slice of pineapple (for the look)",
  "recettes.search_count_word": " recipe",
  "recettes.search_found_word": " found in the result",
  "recettes.search_none_post": "”. Try another ingredient.",
  "recettes.search_none_pre": "No recipe with “",
  "recettes.search_with_post": "”",
  "recettes.search_with_pre": " with “",
  "recettes.share_cta": "Share the recipe",
  "recettes.share_default_title": "MyNutriLab recipe",
  "recettes.toast_copied_sub": "Paste it wherever you like",
  "recettes.toast_copied_title": "Recipe copied",
  "recettes.toast_fav_added": "Favourite recipe!",
  "recettes.toast_fav_removed": "Removed from favourites",
  "returns.js_err_email_sub": "Check the format",
  "returns.js_err_email_title": "Invalid email",
  "returns.js_err_msg_sub": "Minimum 20 characters for \"Other reason\"",
  "returns.js_err_msg_title": "Specify your reason",
  "returns.js_err_order_sub": "Expected format: MNL-2026-XXXX or #1234",
  "returns.js_err_order_title": "Invalid order number",
  "returns.js_err_reason": "Select a reason",
  "returns.js_err_resolution": "Choose a resolution",
  "returns.js_msg_required": "(required — min 20 characters)",
  "returns.v2_optional": "(optional)",
  "reviews.config_unavailable_sub": "Reload the page",
  "reviews.config_unavailable_title": "Builder unavailable",
  "reviews.formula_of_prefix": "The formula of ",
  "reviews.formula_suggested_title": "Suggested formula for this sport",
  "reviews.ing_betaalanine": "Beta-Alanine",
  "reviews.ing_caffeine": "Caffeine",
  "reviews.ing_citrulline": "L-Citrulline",
  "reviews.ing_creatine": "Creatine",
  "reviews.ing_electrolytes": "Electrolytes",
  "reviews.ing_glycerol": "Glycerol",
  "reviews.ing_pinksalt": "Pink salt",
  "reviews.ing_piperine": "Piperine",
  "reviews.ing_taurine": "Taurine",
  "reviews.ing_theanine": "L-Theanine",
  "reviews.ing_tyrosine": "L-Tyrosine",
  "reviews.this_customer": "this customer",
  "reviews.toast_adjust": "Adjust it however you like",
  "reviews.toast_loaded": "Formula loaded",
  "reviews.toast_suggested_loaded": "Suggested formula loaded",
  "search.actif_meta_beta_alanine": "Dosed active · 2–4 g",
  "search.actif_meta_cafeine": "Dosed active · max 200 mg",
  "search.actif_meta_citrulline": "Dosed active · 3–8 g",
  "search.actif_meta_creatine": "Dosed active · 3 g",
  "search.actif_meta_electrolytes": "Dosed active · 400–1500 mg",
  "search.actif_meta_glycerol": "Dosed active · 0,5–3 g",
  "search.actif_meta_piperine": "Dosed active · 0,5–2 mg",
  "search.actif_meta_sel_rose": "Dosed active · 200–500 mg",
  "search.actif_meta_taurine": "Dosed active · 0,25–1 g",
  "search.actif_meta_theanine": "Dosed active · 25–200 mg",
  "search.actif_meta_tyrosine": "Dosed active · 250–1000 mg",
  "search.faq_label": "FAQ",
  "search.input_placeholder": "Search for a product, a page, an active…",
  "search.item_account_meta": "Personal dashboard",
  "search.item_account_title": "My account",
  "search.item_coach_meta": "Your formula to the nearest mg",
  "search.item_coach_title": "AI Coach",
  "search.item_comparator_meta": "Why MNL",
  "search.item_comparator_title": "Brand comparison",
  "search.item_crossfit_meta": "Formula for wod/box",
  "search.item_cycling_meta": "Watts at threshold",
  "search.item_cycling_title": "Cycling",
  "search.item_engagements_meta": "Transparency & traceability",
  "search.item_engagements_title": "Our commitments",
  "search.item_faq_meta": "All the questions",
  "search.item_football_meta": "90 min without dropping off",
  "search.item_football_title": "Football",
  "search.item_hyrox_meta": "8 stations 8 km",
  "search.item_lab_meta": "Composition details + studies",
  "search.item_lab_title": "Le Lab — 11 actives",
  "search.item_mma_meta": "Explosiveness + clear thinking",
  "search.item_mma_title": "MMA / Boxing",
  "search.item_muscu_meta": "Max strength + volume",
  "search.item_muscu_title": "Weight training",
  "search.item_product_meta": "Personalised through the AI Coach · from 24,95€",
  "search.item_product_title": "MyNutriLab Pre-Workout",
  "search.item_rugby_meta": "80 min of battle",
  "search.item_rugby_title": "Rugby",
  "search.item_running_meta": "Aerobic endurance",
  "search.item_running_title": "Running / Trail",
  "search.item_sav_meta": "Faulty product or a mistake?",
  "search.item_sav_title": "After-sales service",
  "search.item_story_meta": "How MNL was born",
  "search.item_story_title": "Our story",
  "search.item_wishlist_meta": "Your favourites",
  "search.item_wishlist_title": "Wishlist",
  "search.result_count_plural": "s",
  "search.result_count_word": " result",
  "search.suggestions_heading": "Popular suggestions",
  "search.trending_actifs": "All the actives",
  "search.trending_configure": "Configure my formula",
  "search.trending_flavors": "Flavors",
  "search.trending_how": "How it works",
  "search.trending_preworkout": "Pre-Workout",
  "search.type_aide": "Help",
  "search.type_brand": "Brand",
  "search.type_compte": "Account",
  "search.type_pages": "Pages",
  "search.type_products": "Products",
  "search.type_sports": "Sports",
  "search.voice_aria": "Voice search",
  "search.voice_denied_sub": "Allow it in your browser settings",
  "search.voice_denied_title": "Mic refused",
  "search.voice_listening_placeholder": "Speak now…",
  "search.voice_nospeech_sub": "Try again or type your search",
  "search.voice_nospeech_title": "I did not hear anything",
  "search.voice_stop_aria": "Stop listening",
  "shop.coll_price_all": "All products shown",
  "shop.err404_cart_item_plural": "s",
  "shop.err404_last_formula": "Your latest AI formula",
  "shop.err404_link_contact": "Contact us",
  "shop.err404_link_faq": "Frequently asked questions",
  "shop.err404_link_lab": "Le Lab — clinical actives",
  "shop.err404_link_story": "Our story",
  "shop.err404_path_account": "My account",
  "shop.err404_path_b2b": "B2B / Pro",
  "shop.err404_path_blog": "News blog",
  "shop.err404_path_cart": "My cart",
  "shop.err404_path_glossaire": "Nutrition glossary",
  "shop.err404_path_login": "Log in",
  "shop.err404_path_pw": "Made-to-measure pre-workout",
  "shop.err404_path_recettes": "Pre-workout recipes",
  "shop.err404_path_sport": "Sport page",
  "shop.err404_path_transparence": "Transparency",
  "shop.err404_path_wishlist": "♥ My wishlist",
  "shop.search_type_article": "Article",
  "shop.search_type_page": "Page",
  "shop.search_type_product": "Product",
  "snip.cf.d_ob_beginner_html": "First pre-workout: entry doses, complete but gentle.",
  "snip.cf.d_ob_endurance": "Long efforts: lactic buffer, hydration, steady energy.",
  "snip.cf.d_ob_focus": "Concentration: caffeine buffered with theanine (1:1 ratio) + tyrosine.",
  "snip.cf.d_ob_force": "Heavy sets: strength, explosiveness, recovery between sets.",
  "snip.cf.d_ob_night": "Zero caffeine: pump, focus and endurance, even in the evening.",
  "snip.cf.d_ob_pump": "Maximum congestion: vasodilation and cell volumisation.",
  "snip.cf.d_sp_bodybuilding": "Hypertrophy: pump, volume and between-set recovery.",
  "snip.cf.d_sp_boxe": "Repeated rounds: clear thinking, lactic buffer, hydration.",
  "snip.cf.d_sp_crossfit": "WODs: explosiveness, repeated efforts, lactic buffer.",
  "snip.cf.d_sp_cyclisme": "Long rides: reinforced hydration and endurance.",
  "snip.cf.d_sp_hyrox": "Hybrid strength + cardio: the most complete profile.",
  "snip.cf.d_sp_marathon": "Long distance: hydration, electrolytes, steady energy.",
  "snip.cf.d_sp_powerlifting": "Maximal lifts: pure strength and alertness under the bar.",
  "snip.cf.d_sp_sportco": "90 min match: repeated sprints and clear thinking.",
  "snip.cf.empty_bought_html": "No formula bought yet.",
  "snip.cf.empty_shared": "Be the first to share your formula!",
  "snip.cf.f_ob_beginner": "Beginner",
  "snip.cf.f_ob_endurance": "Endurance",
  "snip.cf.f_ob_focus": "Focus",
  "snip.cf.f_ob_force": "Strength",
  "snip.cf.f_ob_night": "Stim-free",
  "snip.cf.f_ob_pump": "Pump",
  "snip.cf.f_seed0": "Morning Focus",
  "snip.cf.f_seed1": "Extreme Pump",
  "snip.cf.f_seed2": "Stim-Free Zen",
  "snip.cf.f_seed3": "Raw Strength",
  "snip.cf.f_seed4": "Long Endurance",
  "snip.cf.f_seed5": "Short Explosive",
  "snip.cf.f_sp_bodybuilding": "Weight training",
  "snip.cf.f_sp_boxe": "Boxing / MMA",
  "snip.cf.f_sp_crossfit": "CrossFit",
  "snip.cf.f_sp_cyclisme": "Cycling",
  "snip.cf.f_sp_hyrox": "Hyrox",
  "snip.cf.f_sp_marathon": "Running / Marathon",
  "snip.cf.f_sp_powerlifting": "Powerlifting",
  "snip.cf.f_sp_sportco": "Team sport",
  "snip.cf.form_submit": "Publish",
  "snip.cf.pillar_mental": "Mental",
  "snip.cf.pillar_optim": "Optim",
  "snip.cf.pillar_pump": "Pump",
  "snip.cf.pillar_stamina": "Strength",
  "snip.cf.publishing": "Publishing…",
  "snip.cf.sport_1rm": "1RM",
  "snip.cf.sport_combat": "Combat",
  "snip.cf.sport_concentration": "Concentration",
  "snip.cf.sport_congestion": "Congestion",
  "snip.cf.sport_distance": "Distance",
  "snip.cf.sport_doux": "Mild",
  "snip.cf.sport_endurance": "Endurance",
  "snip.cf.sport_explosif": "Explosive",
  "snip.cf.sport_focus": "Focus",
  "snip.cf.sport_force": "Strength",
  "snip.cf.sport_hybride": "Hybrid",
  "snip.cf.sport_match": "Match",
  "snip.cf.sport_pump": "Pump",
  "snip.cf.sport_sansstim": "Stim-free",
  "snip.cf.sport_sortie_longue": "Long ride",
  "snip.cf.sport_wod": "WOD",
  "snip.cf.sport_zero_cafeine": "Zero caffeine",
  "snip.cf.toast_configopen_sub": "Adjust your doses, close it again, then publish",
  "snip.cf.toast_configopen_title": "Builder open",
  "snip.cf.toast_loaded_sub": "Adjust it however you like",
  "snip.cf.toast_loaded_title": "Formula loaded",
  "snip.cf.toast_noconfig_sub": "Reload the page",
  "snip.cf.toast_noconfig_title": "Builder unavailable",
  "snip.cf.toast_publish_fail_sub": "Try again",
  "snip.cf.toast_publish_fail_title": "Publishing failed",
  "snip.cf.toast_published_sub_html": "Thanks for adding to the community",
  "snip.cf.toast_published_title": "Formula published!",
  "snip.cf.toast_share_soon_title": "Sharing live very soon",
  "snip.cf.toast_soon_sub": "The community opens very soon",
  "snip.cf.toast_votes_title": "Votes live very soon",
  "snip.ing.betaalanine": "Beta-alanine",
  "snip.ing.betaine": "Betaine",
  "snip.ing.caffeine": "Caffeine",
  "snip.ing.citrulline": "Citrulline",
  "snip.ing.creatine": "Creatine",
  "snip.ing.electrolytes": "Electrolytes",
  "snip.ing.glycerol": "Glycerol",
  "snip.ing.pinksalt": "Pink salt",
  "snip.ing.piperine": "Piperine",
  "snip.ing.taurine": "Taurine",
  "snip.ing.theanine": "L-Theanine",
  "snip.ing.tyrosine": "L-Tyrosine",
  "snip.pot.default_name": "Your formula",
  "snip.pot.doses_suffix": " servings",
  "snip.pot.doses_suffix_html": " servings</em>",
  "snip.pot.flavor_prefix_html": "Flavor <em>",
  "snip.pot.format_prefix_html": "Size <em>",
  "snip.pot.ready_prefix_html": "« <em>",
  "snip.pot.ready_suffix_html": "</em> » is ready",
  "snip.pot.scene1_caption": "Your actives drop into the tub",
  "snip.pot.scene1_sub": "Weighed to the nearest mg",
  "snip.pot.scene2_sub": "Your tub is calibrated",
  "snip.pot.scene3_sub": "Without touching the effectiveness",
  "snip.pot.scene4_sub": "Sealed at the lab",
  "snip.push.activating_sub": "Hang on",
  "snip.push.activating_title": "Activating...",
  "snip.push.blocked_sub_html": "Switch them on in your browser settings (icon in the address bar)",
  "snip.push.blocked_title": "Notifications blocked",
  "snip.push.denied_sub": "You can change this in your browser settings",
  "snip.push.denied_title": "Notifications refused",
  "snip.push.fail_sub": "Try again in a few moments",
  "snip.push.fail_title": "Activation failed",
  "snip.push.ok_sub": "You will hear about the new releases and drops",
  "snip.push.ok_title": "Notifications on",
  "snip.push.pending_sub": "The push service is being set up on the admin side. We will get back to you as soon as it is live.",
  "snip.push.pending_title": "Notifications being finalised",
  "snip.push.requesting": "Request in progress…",
  "snip.push.unsupported_sub": "Push notifications are not available here",
  "snip.push.unsupported_title": "Browser not supported",
  "snip.qr.copied": "✓ Copied!",
  "snip.qr.copy_dialog_title": "Copy the formula link",
  "snip.qr.copy_link": "Copy the link",
  "snip.qr.copy_prompt": "Copy the link:",
  "snip.qr.default_name": "Your MNL formula",
  "snip.qr.download": "Download QR",
  "snip.qr.downloaded": "✓ Downloaded!",
  "snip.qr.share_text_prefix": "Take a look at my MyNutriLab formula: ",
  "snip.qr.share_title_prefix": "Share ",
  "snip.qr.sub_js": "Scan this QR code with your phone, or share the link.",
  "snip.qr.unavailable_prefix": "QR unavailable — copy this link: ",
  "snip.rev.err_dup_sub": "You can post a new review in 24h",
  "snip.rev.err_dup_title": "Review already posted",
  "snip.rev.err_email_sub": "Check your email address",
  "snip.rev.err_email_title": "Invalid email",
  "snip.rev.err_fast_sub": "Take a few seconds to write your review",
  "snip.rev.err_fast_title": "Too fast",
  "snip.rev.err_format_sub": "Images only (jpg/png/webp)",
  "snip.rev.err_format_title": "Invalid format",
  "snip.rev.err_generic_sub": "Try again or go through the contact form (/pages/contact)",
  "snip.rev.err_generic_title": "Sending failed",
  "snip.rev.err_rate_sub": "Try again in an hour",
  "snip.rev.err_rate_title": "Too many attempts",
  "snip.rev.err_rating_sub": "Click to give a rating",
  "snip.rev.err_rating_title": "Rating missing",
  "snip.rev.err_short_sub": "Minimum 50 characters",
  "snip.rev.err_short_title": "Review too short",
  "snip.rev.err_size_sub": "Max 5 MB per photo",
  "snip.rev.err_size_title": "Photo too heavy",
  "snip.rev.photo_alt_prefix": "Photo ",
  "snip.rev.photo_remove_aria": "Remove the photo",
  "snip.rev.rating_hint": "Click to rate",
  "snip.rev.sending": "Sending...",
  "snip.rev.sending_photos": "Sending the photos...",
  "snip.rev.star1_word": "Disappointing",
  "snip.rev.star2_word": "Meh",
  "snip.rev.star3_word": "Good",
  "snip.rev.star4_word": "Very good",
  "snip.rev.star5_word": "The very best",
  "snip.satc.collapse_aria": "Shrink the bar",
  "snip.satc.expand_aria": "Expand the bar",
  "snip.sub.toast_24h_sub": "We apply it within 24h, confirmation by email",
  "snip.sub.toast_cancel_sub_html": "Our team confirms it to you by email within 24h. If you change your mind, just reply to the email.",
  "snip.sub.toast_cancel_title": "Cancellation request received",
  "snip.sub.toast_default_title": "Request recorded",
  "snip.sub.toast_freq_title": "Change request received",
  "snip.sub.toast_pause_title": "Pause request received",
  "snip.sub.toast_skip_sub": "Confirmation by email within 24h",
  "snip.sub.toast_skip_title": "Delivery skip recorded",
  "thankyou.js_copied": "✓ Copied!",
  "thankyou.js_copied_caps": "✓ COPIED!",
  "thankyou.js_mail_subject": "My MyNutriLab code",
  "thankyou.js_share_msg_1": "Try MyNutriLab with my code: ",
  "thankyou.js_share_msg_2": " — you get -10% and so do I ",
  "thankyou.js_text_copied": "✓ Text copied!",
  "thankyou.share_copy": "Copy the code",
  "tracking.btn_submit": "Track",
  "tracking.js_err_email": "Invalid email. Enter the email used for the purchase.",
  "tracking.js_err_generic": "Order not found. Check your details or write to us.",
  "tracking.js_err_notfound": "No order found. Check the number and the email used at purchase. If you are sure → go through the contact form (/pages/contact)",
  "tracking.js_err_order": "Invalid order number. Expected format: #1042 or MNL-2026-XXXX",
  "tracking.js_err_ratelimit": "Too many attempts. Wait a few minutes then try again.",
  "tracking.js_step_confirmed": "Order confirmed",
  "tracking.js_step_confirmed_sub": "Payment validated · email sent",
  "tracking.js_step_delivered": "Delivered",
  "tracking.js_step_delivered_sub": "At your door or at a pickup point",
  "tracking.js_step_production": "Manufacturing at the lab",
  "tracking.js_step_production_sub": "Made by hand · partner laboratory in France",
  "tracking.js_step_shipped": "Shipped",
  "tracking.js_step_shipped_sub": "On its way",
  "tracking.js_verifying": "Checking...",
  "wishlist.count_zero": "0 item",
  "wishlist.js_add_failed": "Add failed",
  "wishlist.js_added_check": "✓ Added",
  "wishlist.js_added_suffix": " added",
  "wishlist.js_added_to_cart": "Added to cart",
  "wishlist.js_adding": "Adding…",
  "wishlist.js_ago_prefix": "About ",
  "wishlist.js_article_plural": "s",
  "wishlist.js_article_word": " item",
  "wishlist.js_cancel": "Cancel",
  "wishlist.js_cannot_add": "Cannot add",
  "wishlist.js_cannot_delete_last": "You cannot delete the last list",
  "wishlist.js_cannot_encode": "Cannot encode the list",
  "wishlist.js_check_connection": "Check your connection",
  "wishlist.js_clear_confirm": "Clear everything",
  "wishlist.js_clear_title": "Clear your whole wishlist?",
  "wishlist.js_continue": "Continue",
  "wishlist.js_copy_prompt": "Copy this link:",
  "wishlist.js_copy_share_title": "Copy the share link",
  "wishlist.js_create_msg": "Give it a name (max 40 characters).",
  "wishlist.js_create_placeholder": "E.g.: Winter bulk, Morning cardio…",
  "wishlist.js_create_title": "Create a new list",
  "wishlist.js_del_confirm": "Delete",
  "wishlist.js_del_msg": "All the items will be lost. This cannot be undone.",
  "wishlist.js_del_title": "Delete this list?",
  "wishlist.js_emoji_confirm": "Create the list",
  "wishlist.js_emoji_msg": "Choose an emoji to represent the list, or leave it blank for the default one.",
  "wishlist.js_emoji_title": "Emoji icon (optional)",
  "wishlist.js_empty_fav_h": "♥ My favourites is empty",
  "wishlist.js_empty_fav_text": "Add the ones you love by clicking on the — favourite products, saved formulas.",
  "wishlist.js_empty_generic_suffix": " is empty",
  "wishlist.js_empty_generic_text": "Long-press on of a product to choose this list. Or just click on : that adds it to the active list.",
  "wishlist.js_empty_reorder_h": "Recurring is empty",
  "wishlist.js_empty_reorder_text": "Your recurring purchases will land here. Long-press on of a product to add it to \"Recurring\".",
  "wishlist.js_empty_totest_h": "To test is empty",
  "wishlist.js_empty_totest_text": "Fancy exploring? Long-press on of a product then choose \"To test\" to note it here.",
  "wishlist.js_error": "Error",
  "wishlist.js_export_ready": "Export ready",
  "wishlist.js_export_sub": "JSON file downloaded",
  "wishlist.js_history_aria": "See wishlist history",
  "wishlist.js_history_btn": "↶ History",
  "wishlist.js_history_title": "See the history of changes (undo)",
  "wishlist.js_impossible": "Not possible",
  "wishlist.js_invalid_link": "Invalid link",
  "wishlist.js_invalid_link_sub": "The shared link looks corrupted",
  "wishlist.js_item_plural": "s",
  "wishlist.js_item_word": " item",
  "wishlist.js_link_copied": "Link copied!",
  "wishlist.js_link_copied_check": "✓ Link copied!",
  "wishlist.js_link_copied_sub": "Share it with whoever you like. Cap of 30 items included in the link.",
  "wishlist.js_list_created_a": "List \"",
  "wishlist.js_list_created_b": "\" created",
  "wishlist.js_list_deleted": "List deleted",
  "wishlist.js_list_imported": "List imported",
  "wishlist.js_list_plural": "s",
  "wishlist.js_list_renamed": "List renamed",
  "wishlist.js_list_word": " list",
  "wishlist.js_max_lists": "Max 10 lists or invalid name",
  "wishlist.js_max_lists_reached": "You already have the maximum of 10 lists",
  "wishlist.js_no_history": "No history yet",
  "wishlist.js_no_history_sub": "Snapshots are created as you change your wishlist",
  "wishlist.js_no_variant": "No variant available",
  "wishlist.js_no_variant_sub": "Open each product to choose a variant",
  "wishlist.js_order_saved": "Sort order saved",
  "wishlist.js_product_fallback": "Product",
  "wishlist.js_removed_from_wl": "Removed from your wishlist",
  "wishlist.js_removed_suffix": " removed",
  "wishlist.js_rename_confirm": "Update",
  "wishlist.js_rename_msg": "Type a new name, or leave it blank to delete the list.",
  "wishlist.js_rename_placeholder": "List name...",
  "wishlist.js_rename_title": "Rename the list",
  "wishlist.js_restore_confirm": "Restore",
  "wishlist.js_restore_failed": "Restore failed",
  "wishlist.js_restore_msg": "Your current changes will be overwritten.",
  "wishlist.js_restore_title": "Restore this state?",
  "wishlist.js_see_cart": "View cart",
  "wishlist.js_share_btn": "Share",
  "wishlist.js_share_list_text": "Here is my list — click to see it ",
  "wishlist.js_share_text": "Here is my MyNutriLab wishlist!",
  "wishlist.js_shared_suffix": " (shared)",
  "wishlist.js_skipped_plural": "s",
  "wishlist.js_skipped_word": " skipped",
  "wishlist.js_unit_h": "h",
  "wishlist.js_unit_min": "min",
  "wishlist.js_will_be_removed": " will be removed. This cannot be undone.",
  "wishlist.js_wl_added_title": "Wishlist added to cart",
  "wishlist.js_wl_cleared": "Wishlist cleared",
  "wishlist.js_wl_restored": "Wishlist restored",
  "wishlist.js_wl_restored_sub": "Previous state recovered",
  "wishlist.share_btn_copy": "Copy the link",
  "wishlist.share_native_title": "My MyNutriLab wishlist"
};

Object.assign(window.__MNL_I18N, {
  "header-polish.cart_member_prompt": "Already a MyNutriLab member?",
  "header-polish.cart_member_login": "Sign in",
  "header-polish.cart_preworkout_name": "Custom pre-workout",
  "header-polish.cart_update_error": "Couldn’t update your cart. Please try again.",
  "header-polish.cart_updating": "Updating your cart…"
});

Object.assign(window.__MNL_I18N, {
  "header-polish.qr2_launcher": "My last formula",
  "header-polish.qr2_title": "Ready to revisit your formula?",
  "header-polish.qr2_local": "Saved on this device",
  "header-polish.qr2_resume": "Resume my formula",
  "header-polish.qr2_browse": "All my formulas",
  "header-polish.qr2_hint": "Check the ingredients and price in the configurator before adding to your cart.",
  "header-polish.qr2_reduce": "Minimize card",
  "header-polish.qr2_format": "Saved format",
  "header-polish.qr2_flavor": "Saved flavor",
  "header-polish.qr2_default_name": "My formula",
  "header-polish.qr2_choose": "Choose my formula",
  "header-polish.qr2_old_hint": "This older formula needs to be checked in the configurator."
});
